export const hungary = () => {

    return {
        dashboard: 'Dashboard',
        cms_dashboard: 'cms',
        content_dashboard: 'Tartalom',
        sales_dashboard: 'Sales',
        booking_status_dashboard: "Foglalás állapota",
        booking_summary_dashboard: "Foglalási összefoglaló",
        contract_menu: 'Szerződés',
        contract_sub_menu: 'Szerződés',
        media_management_menu: 'Médiakezelés',
        media_others_menu: 'Egyéb',
        series_sub_menu: 'Szülő sorozat',
        season_sub_menu: 'Sorozat',
        episode_sub_menu: 'Független epizód',
        program_sub_menu: 'Program',
        movie_sub_menu: "Film",
        trailer_sub_menu: 'Trailer',
        interstitial_sub_menu: "Közbeiktatott",
        commercial_sub_menu: 'Kereskedelmi',
        filler_sub_menu: "Filler",
        music_sub_menu: 'Zene',
        break_sub_menu: 'Szünet',
        media_episode_group_sub_menu: 'Médiaepizódcsoport',
        planning_menu: 'Tervezés',
        planing_sub_menu: 'Tervezés',
        formats_sub_menu: 'Formátumok',
        program_schedule_clash_sub_menu: 'Programütemezési összecsapás',
        scheduling_menu: 'Ütemezés',
        curate_menu: 'Curate',
        timeline_sub_menu: 'Idővonal',
        timeline_linear_sub_menu: "Lineáris idővonal",
        series_timeline_sub_menu: 'Sorozat idővonala',
        rails_sub_menu: "Sínek",
        pages_sub_menu: 'Oldalok',
        property_sub_menu: "Eszközök",
        tv_preview_sub_menu: "TV előnézet",
        web_preview_sub_menu: 'Webes előnézet',
        mobile_preview_sub_menu: "Mobil előnézet",
        ingestion_menu: "Lenyelés",
        posters_sub_menu: 'Poszterek',
        ingestion_template_sub_menu: "Beadási sablon",
        partner_ingestion_sub_menu: "Partner feldolgozás",
        jobs_sub_menu: 'Jobs',
        sales_menu: 'Sales',
        agency_sub_menu: "Ügynökség",
        client_sub_menu: 'Kliens',
        campaign_sub_menu: 'Kampány',
        booking_sub_menu: "Foglalás",
        booking_transfer_sub_menu: 'Foglalási transzfer',
        update_booking_line_number_sub_menu: "Foglalási sorszám frissítése",
        sales_team_sub_menu: "Értékesítési csapat",
        sales_executive_sub_menu: "Értékesítési vezető",
        reconciliation_menu: 'Reconciliation',
        as_run_reconciliation_sub_menu: 'As Run Reconciliation ',
        import_planning_sub_menu: 'Importtervezés',
        import_asRun_sub_menu: 'AsRun importálása',
        manage_asRun_sub_menu: 'AsRun kezelése',
        export_menu: 'Exportálás',
        epg_sub_menu: 'EPG',
        epg_template_sub_menu: 'EPG-sablon',
        Secondary_event_menu: "Másodlagos esemény",
        prototype_sub_menu: 'Prototípus',
        styleSheet_sub_menu: "StyleSheet",
        default_prototype_sub_menu: 'Alapértelmezett prototípus',
        protoType_source_sub_menu: 'ProtoType Source',
        Secondary_event_dynamic_rule_sub_menu: "SecondaryEvent dinamikus szabály",
        billing_menu: 'Számlázás',
        billing_sub_menu: 'Számlázás',
        genered_bills_sub_menu: 'Generált számlák',
        masters_menu: "Mesterek",
        master_menu_title: "Mester",
        language_sub_menu: 'Nyelv',
        content_sub_menu: 'Tartalom',
        property_type_sub_menu: 'Eszköztípus',
        rails_type_sub_menu: "Sínek típusa",
        posters_type_sub_menu: "Poszterek típusa",
        users_sub_menu: 'Felhasználók',
        Department_sub_menu: 'Osztály',
        role_sub_menu: 'Szerep',
        content_category_sub_menu: "Tartalomkategória",
        region_sub_menu: 'Régió',
        brand_sub_menu: "Márka",
        product_sub_menu: 'Termék',
        bank_account_sub_menu: "Bankszámla",
        tax_sub_menu: "Adó",
        licensor_sub_menu: 'Licensz',
        channel_sub_menu: 'Csatorna',
        currency_sub_menu: 'Pénznem',
        time_range_sub_menu: 'Időtartomány',
        repeat_pattern_sub_menu: 'Minta ismétlése',
        invoice_content_sub_menu: "Számla tartalma",
        segemnt_type_sub_menu: "Szegmens típusa",
        variation_sub_menu: 'Változat',
        break_format_sub_menu: "Formátum megszakítása",
        payment_provider_sub_menu: 'Fizetési szolgáltató',
        ott_period_type_sub_menu: "Ott időszak típusa",
        payment_type_sub_menu: 'Fizetési típus',
        schedule_constraints_sub_menu: 'Ütemezési kényszerek',
        monetization_menu: 'Bevételszerzés',
        ott_period_sub_menu: "Időszak",
        subscriber_sub_menu: 'Feliratkozó',
        ott_campaign_sub_menu: "Kampány",
        coupon_sub_menu: "Kupon",
        data_migration_menu: 'Adatmigráció',
        form_fields_menu: 'Űrlapmezők',
        save_button_tooltip: 'Mentés',
        save_button_text: 'Mentés',
        back_button_tooltip: 'Vissza',
        add_button_tooltip: 'Hozzáadás',
        add_button_text: 'Hozzáadás',
        add_multiple_button_text: 'Több hozzáadása',
        add_dialog_header: 'Hozzáadás',
        new_button_dialog_header: 'Új',
        new_title_editpageheader: 'Új',
        edit_button_tooltip: "Szerkesztés",
        update_button_tooltip: 'Frissítés',
        remove_button_tooltip: 'Eltávolítás',
        delete_button_tooltip: "Törlés",
        select_button_tooltip: 'Kiválasztás',
        select_button_text: 'Kiválasztás',
        cancel_button_tooltip: 'Mégse',
        cancel_button_text: 'Mégse',
        preferencia_button_tooltip: 'Preferencia',
        opciók: "opciók",
        refresh_button_tooltip: 'Frissítés',
        archívum: "Archívum",
        ExportBreaksOnly: "Export Breaks Only",
        loading_pleasewait: 'Betöltés, kérem, várjon...',
        no_records_found: 'Nem található rekord!!',
        contract_number_label: "Szerződés száma",
        platform_type_label: 'Platformtípus',
        licensor_label: 'Licensor',
        payee_label: "Kedvezményezett",
        start_date_label: "Kezdő dátum",
        end_Date_label: 'Befejezés dátuma',
        channel_label: 'Csatorna',
        platform_label: 'Platform',
        region_label: 'Régió',
        kiállítás_label: 'Kiállítás',
        repeat_label: 'Ismétlés',
        play_time_number_label: 'Play Time Number',
        playTime_label: 'Play Time',
        is_unlimited_label: 'Korlátlan',
        add_media_episode_button_tooltip: "Médiaepizód hozzáadása",
        remove_media_episode_button_tooltip: 'Remove Media Episode',
        assetId_column: "Eszközazonosító",
        title_column: "Cím",
        media_category_column: 'Médiakategória',
        start_date_column: "Kezdő dátum",
        end_date_column: 'Befejezés dátuma',
        is_unlimited_column: "Korlátlan",
        exhibition_column: 'Kiállítás',
        repeat_column: 'Ismétlés',
        play_time_number_column: 'PlayTimeNumber',
        playTime_column: 'PlayTime',
        media_library_dialog_header: "Médiatár",
        Summary: 'Summary',
        create_series_dialog_header: "Szülő sorozat létrehozása",
        title_label: "Cím",
        content_label: 'Tartalom',
        asset_id_label: "Eszközazonosító",
        description_label: 'Leírás',
        synopsis_label: 'Synopsis',
        islive_label: 'Élő',
        seasons_title: 'sorozat',
        series_cardlist_header: 'SERIES',
        season_cardlist_header: 'EPISODE',
        sidefix_season_tooltip: "Szezon",
        s_content_label: 'S. Tartalom',
        season_no_label: 'Szezon száma',
        ep_content_label: 'Ep. Tartalom',
        episodes_label: 'Epizódok',
        no_of_episodes_label: 'Nem. az epizódok',
        Duration_label: "Időtartam (óó:pp:pp:ff)",
        playlist_duration_label: "Időtartam (óó:pp:pp)",
        total_block_duration_label: "A blokk teljes időtartama (óó:pp:pp:ff)",
        season_number_column: 'Szezon száma',
        no_of_episodes_column: 'Nem. Az epizódok',
        season_content_column: "Évadtartalom",
        episode_content_column: "Epizód tartalma",
        Duration_column: "Időtartam",
        timerangefrom_column: 'From',
        timerangeto_column: "To",
        select_image_collection_header: 'Kép kiválasztása',
        description_column: 'Leírás',
        meta_data_label: 'Metaadatok',
        posters_label: 'Poszterek',
        publishing_label: 'Kiadás',
        search_by_title: 'Keresés cím szerint',
        genre_label: 'Műfaj',
        language_label: 'Nyelv',
        pg_rating_label: 'PG besorolás',
        keywords_label: 'Kulcsszavak',
        add_poster_button_tooltip: "Poszter hozzáadása",
        poster_type_column: 'Poszter típusa',
        image_column: 'Kép',
        edit_poster_dialog_header: "Poszter szerkesztése",
        poster_type_label: 'Poszter típusa',
        url_label: 'URL',
        select_url_tooltip: 'URL kiválasztása',
        add_publishing_button_tooltip: 'Kiadás hozzáadása',
        unlimited_rights_grid: 'Korlátlan jogok',
        tba_label: "TBA",
        tba_column: "TBA",
        publishing_dialog_header: 'Közzététel',
        platform_type_column: 'Platformtípus',
        channel_column: 'Csatorna',
        source_column: 'Forrás',
        enter_title: "Adja meg a címet",
        create_season_dialog_header: "Sorozat létrehozása",
        season_number_label: 'Szezon száma',
        series_label: 'Parent Series',
        start_episode_label: 'Starting Episode',
        select_series_collection_header: 'Select Parent Series',
        video_label: 'Videó',
        videos_label: 'Videók',
        add_video_button_tooltip: "Videó hozzáadása",
        video_type_column: 'Videó típusa',
        video_type_label: 'Videó típusa',
        url_column: 'URL',
        edit_video_dialog_header: "Videó szerkesztése",
        create_video_dialog_header: 'Videó létrehozása',
        episode_title_label: 'Epizód címe',
        episode_number_label: 'Epizódszám',
        episode_number_labelshort: 'EpNo.',
        release_date_label: "Kiadás dátuma",
        version_label: 'Verzió',
        content_category_label: "Tartalomkategória",
        format_label: 'Formátum',
        cast_and_crew_label: 'Szerepek és stáb',
        dynamic_fields_label: "Dinamikus mezők",
        censor_rating_label: "Cenzor minősítés",
        Technical_prototype_label: "Technical Prototype",
        production_year_label: "Gyártás éve",
        language_column: 'Nyelv',
        synopsis_column: 'Synopsis',
        cast_column: 'Cast',
        name_column: 'Név',
        name_label: 'Név',
        cast_type_label: 'Cast típusa',
        segment_type_column: "Típus",
        material_id_column: "Anyagazonosító",
        fact_duration_column: "Tényleges időtartam",
        is_default_column: 'Alapértelmezett',
        is_hard_parted_column: 'Keményen elválasztva',
        edit_version_dialog_header: "Verzió szerkesztése",
        create_version_dialog_header: 'Verzió létrehozása',
        segment_type_label: "Szegmens típusa",
        material_id_label: 'Anyagazonosító',
        is_hard_parted_label: 'Keményen elválasztva',
        is_default_label: 'Alapértelmezett',
        gener_segments_button_text: "Szegmensek generálása",
        auto_distribute_button_text: 'Automatikus terjesztés',
        Sequence_column: 'Sequence',
        media_id_column: 'Médiaazonosító',
        start_time_column: "Kezdési idő",
        end_time_column: 'Vége',
        previewed_column: 'Előnézet',
        parent_content_category_column: "Szülőtartalom-kategória",
        select_format_collection: "Formátum kiválasztása",
        select_content_category_collection_header: "Tartalomkategória kiválasztása",
        manual_assetid_label: "Manual Asset Id",
        media_category_label: 'Médiakategória',
        media_category_type_label: 'Médiakategória típusa',
        tc_in_label: 'Tc In (óó:pp:ss:ff)',
        tc_out_label: 'Tc Out (óó:pp:ss:ff)',
        media_episode_group_dialog_header: "Médiaepizódcsoport létrehozása",
        program_group_dialog_header: 'Programcsoport létrehozása',
        interstital_group_dialog_header: "Közbeiktatott csoport létrehozása",
        media_category_type_column: "Médiakategória típusa",
        media_category_type_collection_header: "Médiakategória típusa",
        episode_dialog_header: 'Epizód',
        sidefixmenu_rails_asset_tooltip: "Eszköz",
        cardlist_rails_title: "Eszközök",
        cardlist_rails_assets_title: "Asset Library",
        rails_title_editpageheader: "Sínek",
        display_title_label: "Cím megjelenítése",
        rails_type_label: "Típus",
        rails_note_label: 'Megjegyzés: A felhasználó választhat',
        publish_label: 'Közzététel',
        Publicated_label: 'Közzétéve',
        unpublished_label: 'Unpublished',
        rails_p_label: 'P',
        rails_up_label: 'FEL',
        ott_assets_collection_header: "Ott Assets",
        options_actionbutton_menutext: 'Opciók',
        delete_actionbutton_option: 'Törlés',
        moveup_actionbutton_option: 'Move Up',
        movedown_actionbutton_option: 'Move Down',
        sidefixmenu_rails_tooltip: "Sín",
        cardlist_page_rails_title: "Sínek",
        cardlist_rails_page_title: "Rail Library",
        theme_label: "Téma",
        icon_url_label: "Ikon URL",
        please_fill_out_details_label: 'Kérjük, töltse ki ezt a mezőt.',
        property_dialog_header: "Eszközök létrehozása",
        érvényesítés: 'Kérjük, válassza ki az értéket',
        asset_type_label: "Eszköz típusa",
        portrait_image_url_label: "Portré kép URL-je",
        landscape_image_url_label: "Fekvő kép URL-je",
        video_playback_url_label: "Video lejátszási URL",
        select_portal_image_url_collection_header: "Válasszon állókép URL-t",
        select_landscape_image_url_collection_header: "Fekvő kép URL-címének kiválasztása",
        create_poster_dialog_header: 'Poszter létrehozása',
        image_url_label: 'Kép URL-je',
        file_path_label: 'Fájl elérési útja',
        poster_note_label: 'Megjegyzés: Mentéskor a kép feltöltésre kerül, és az URL hozzárendelve lesz',
        template_name_label: 'Sablon neve',
        module_type_label: 'Modul típusa',
        ingestion_template_type_label: "Beadási sablon típusa",
        save_template_text: 'Sablon mentése',
        send_text: 'SEND',
        send_button_tooltip: 'Küldés',
        body_label: "Body",
        response_label: 'Válasz',
        select_file_label: 'Fájl kiválasztása',
        load_button_text: 'Betöltés',
        ingestion_template_note_label: 'Az első param értéket cserélje ki a keresési szövegre mentés közben',
        key_column: "Kulcs",
        value_column: "Érték",
        key_label: "Kulcs",
        value_label: "Érték",
        template_details_label: 'Sablon részletei',
        template_label: 'sablon',
        search_title_label: 'Cím keresése',
        ingest_button_text: "Felvétel",
        ingest_button_tooltip: "Felvétel",
        load_button_tooltip: 'Betöltés',
        ingestion_details_label: 'Lenyelés részletei',
        pg_rating_column: 'PGRating',
        genres_column: "Műfajok",
        show_response_label: 'Válasz megjelenítése',
        answer_dialog_header: 'Válasz',
        eye_tooltip: "Szem",
        agency_dialog_header: "Ügynökség létrehozása",
        code_label: "Kód",
        address_label: 'Cím',
        pincode_label: 'Pin kód',
        email_label: 'E-mail',
        credit_limit_label: "Hitelkeret",
        pan_label: 'PAN',
        gst_number_label: "GST-szám",
        default_tax_label: "Alapértelmezett adó",
        is_credit_unlimited_label: "A hitel korlátlan",
        client_dialog_header: "Client létrehozása",
        agency_label: "Ügynökség",
        campaign_number_label: "Kampányszám",
        order_date_label: 'Rendelés dátuma *',
        period_from_label: 'From',
        period_to_label: "Cél",
        campaign_type_label: "Típus",
        deal_type_label: "Ügylet típusa",
        client_label: 'kliens',
        location_label: 'Location',
        product_label: "Termék",
        Commission_label: 'Jutalék',
        target_budget_label: 'Cél költségkeret',
        target_spots_label: 'Célhelyek',
        target_seconds_label: 'Cél másodpercek',
        currency_label: 'Pénznem',
        discount_label: 'Kedvezmény',
        tax_applicable_label: "Alkalmazandó adó",
        fact_booking_label: "Tényleges foglalás",
        commercial_label: 'Kereskedelmi',
        fct_label: 'FCT',
        billing_label: 'Számlázás',
        channel_tab_label: 'Csatorna',
        channel_name_column: 'Csatorna neve',
        epg_code_column: "EPG kód",
        asrun_code_column: 'AsRun Code',
        content_column: 'Tartalom',
        add_channel_button_tooltip: "Csatorna hozzáadása",
        add_commercial_button_tooltip: "Kereskedelmi bejegyzés hozzáadása",
        add_fct_button_tooltip: "FCT hozzáadása",
        add_billing_button_tooltip: "Számlázás hozzáadása",
        channel_collection_header: "Csatornák",
        commercials_collection_header: "Reklámok",
        fct_column: 'FCT',
        from_date_column: 'Dátumtól',
        to_date_column: 'Dátumig',
        campaign_type_column: "Kampánytípus",
        rate10sec_column: 'Rate10sec',
        days_column: 'napok',
        fct_dialog_header: 'FCT',
        billing_dialog_header: "Számlázás",
        from_date_label: 'Dátumtól',
        to_date_label: 'Dátumig',
        rate10sec_label: 'Rate10sec',
        rate30sec_label: 'Rate30Sec',
        day_label: 'Day',
        select_all_label: 'Mind kijelölése',
        sun_label: 'Sun',
        my_label: "Saját",
        tue_label: "Ked",
        wed_label: 'Sze',
        thu_label: 'cs',
        fri_label: 'Ingyenes',
        sat_label: 'Szo',
        summa_column: 'összeg',
        summa_label: 'összeg',
        booking_label: 'Foglalás',
        campaign_label: 'Kampány',
        year_label: 'Év',
        months_label: 'Hónapok',
        booking_collection_header: 'Kampány kiválasztása a foglaláshoz',
        from_label: 'From:',
        to_label: 'Címzett:',
        total_spot_label: 'Spotok összesen',
        total_seconds_label: "Összes másodperc",
        total_budget_label: 'Teljes költségkeret:',
        download_template_tooltip: 'Sablon letöltése',
        file_tooltip: 'Fájl kiválasztása',
        line_no_column: "Sor száma",
        commercial_column: 'Kereskedelmi',
        program_column: 'Program',
        house_number_column: "Házszám",
        type_column: "Típus",
        deal_type_column: "Ügylet típusa",
        spot_rate_column: 'Spot Rate',
        position_column: 'Pozíció',
        from_time_column: 'From',
        to_time_column: "Cél",
        product_code_column: "Termékkód",
        total_spot_column: 'Total Spot',
        total_fct_column: 'Total FCT',
        total_amount_column: "Teljes összeg",
        booked_spots_lable: 'Foglalt helyek :',
        current_spots_label: 'Jelenlegi helyek:',
        booked_seconds_label: 'Lefoglalt másodpercek :',
        current_seconds_label: 'Jelenlegi másodpercek :',
        booked_amount_label: 'Lefoglalt összeg :',
        current_amount_label: 'Jelenlegi összeg:',
        add_booking_dialog_header: "Foglalás hozzáadása",
        type_label: 'Típus',
        from_time_label: 'Az időből',
        spot_per_day_label: 'Szpot (naponként)',
        spot_per_week_label: 'Spot (Hetente)',
        rate_label: 'Rate',
        assessment_code_label: 'Becsült kód',
        remark_label: 'Megjegyzések',
        count_label: 'Count',
        transfer_from_label: 'Transfer From',
        transfer_to_label: 'Átvitel ide',
        transfer_button_tooltip: 'Transfer',
        transfer_button_text: 'Átadás',
        campaign_column: 'Campaign',
        booking_date_column: "Foglalás dátuma",
        time_range_from_column: 'Time Range From',
        time_range_to_column: 'Time Range To',
        edit_actionbutton_menutext: 'Szerkesztés',
        select_all_Header_menutext: 'Minden fejléc kijelölése',
        delete_actionbutton_menutext: 'Törlés',
        editduration_actionbutton_menutext: "Időtartam szerkesztése",
        cut_actionbutton_menutext: 'Vágás',
        update_booking_line_number_label: "Foglalási sorszám frissítése",
        select_campaign_collection_text: 'Kampány kiválasztása',
        edit_campaign_collection_text: "Kampány szerkesztése",
        select_campaign_collection_tooltip: "Kiválasztás",
        jau_scheduled_label: 'Már ütemezve',
        not_scheduled_label: 'Nincs ütemezve',
        edit_booking_dialog_header: "Foglalás szerkesztése",
        spot_rate_label: 'Spot Rate',
        time_range_from_label: 'TimeRange From',
        time_range_to_label: 'TimeRange To',
        auto_reconcile_button_tooltip: "Automatikus egyeztetés",
        auto_reconcile_button_text: 'Automatikus egyeztetés',
        import_as_run_button_text: 'Importálás futásként',
        import_as_run_button_tooltip: 'Importálás futásként',
        reconciled_r_label: "R",
        reconciled_label: 'Egyeztetett',
        non_reconciled_label: 'Nem egyeztetett',
        non_reconciled_nr_label: 'NR',
        total_label: 'Összesen',
        total_commercial: 'Total Commercial:',
        sno_column: 'SN.',
        slot_date_time_column: 'Slot Date Time',
        episode_number_column: 'Epizódszám',
        category_column: 'Kategória',
        reconciled_status_column: "Egyeztetett állapot",
        is_reconciled_column: 'Egyeztetett',
        reconsilation_by_column: 'Reconsilation by',
        status_column: 'Status',
        ref_force_match_label: 'Force Match',
        force_match_label: 'Force Match',
        force_match_fm_label: 'FM',
        ref_force_unmatch_label: 'Force Unmatch',
        ref_cancel_label: 'Mégse',
        ref_export_xml_label: 'XML exportálása',
        purge_button_tooltip: "Tisztítás",
        unpurge_button_tooltip: 'Unpurge',
        campaign_no_label: "Kampány nem",
        fic_dxb_0002486_label: 'FIC-DXB-0002486',
        total_spot_857_label: '857',
        total_amount_label: 'Teljes összeg',
        total_seconds_19935_label: '19935',
        total_cast_2478_label: '2478.00',
        purged_label: 'Purged',
        date_column: 'Dátum',
        is_purged_column: 'IsPurged',
        ref_purged_label: "Tisztítás",
        ref_unpurged_label: 'UnPurge',
        ref_calculate_spot_rate_label: 'Spot árfolyam kiszámítása',
        total_fct_label: 'Total FCT',
        total_spot_rate: 'Teljes azonnali ár',
        ref_calculate_fct_label: "FCT kiszámítása",
        ref_change_time_range_label: "Időtartomány módosítása",
        ref_transfer_label: "Átadás",
        ref_update_estimate_code_label: "Becslési kód frissítése",
        ref_change_commercial_label: 'Change Commercial',
        ref_change_spot_rate_label: 'Spot árfolyam módosítása',
        change_time_range_dialog_header: "Időtartomány módosítása",
        start_time_label: "Kezdési idő",
        to_time_label: 'Időhöz',
        transfer_dialog_header: "Átadás",
        transfer_to_date_label: 'Átvitel dátumig',
        change_spot_rate_dialog_header: 'Spot árfolyam módosítása',
        change_spot_rate_label: 'Spot árfolyam módosítása',
        change_commercial_dialog_header: "Reklámok módosítása",
        change_commercial_label: "Change Commercial",
        update_product_estimate_code_dialog_header: "Termékbecslési kód frissítése",
        update_button_text: 'Frissítés',
        update_all_button_text: 'Összes frissítése',
        add_file_label: 'Fájl hozzáadása',
        import_file_label: "Fájlok importálása",
        file_name_column: 'Fájlnév',
        message_column: 'Üzenet',
        file_upload_tooltip: 'Fájlfeltöltés',
        import_file_name_column: 'Fájlnév importálása',
        comment_load_data_label: 'Az adatok betöltéséhez kattintson a betöltés gombra',
        program_label: 'Program',
        select_program_booking_collection_header: 'Program kiválasztása a foglaláshoz',
        export_report_dialog_header: 'Export EPG',
        import_template_dialog_heade: 'Sablon importálása',
        filters_label: 'Szűrők',
        operator_label: 'Operator',
        operator_column: 'Operator',
        export_button_tooltip: "Exportálás",
        export_button_text: 'Exportálás',
        export_playlist_button_tooltip: 'Lejátszási lista exportálása',
        export_and_sftp_playlist_button_tooltip: "Exportálás és SFTP lejátszási lista",
        export_playlist_button_text: 'Lejátszási lista exportálása',
        up_button_tooltip: 'Fel',
        down_button_tooltip: "Le",
        export_template_editpageheader: "Export EPG sablon",
        save_template_as_label: 'Sablon mentése másként',
        module_name_label: 'Modul neve',
        selected_Columns_label: 'Kiválasztott oszlopok',
        available_Column_label: 'Elérhető oszlop',
        display_name_label: 'Megjelenítési név',
        add_blank_button_tooltip: "Üres hozzáadása",
        add_blank_button_text: 'Üres hozzáadása',
        add_column_button_tooltip: 'Oszlop hozzáadása',
        add_column_button_text: 'Oszlop hozzáadása',
        available_Column: 'Elérhető oszlop',
        display_column: 'Megjelenítési név',
        format_name_column: 'Formátum',
        id_label: 'azonosító',
        source_label: 'Forrás',
        segment_position_label: "Szegmens pozíciója",
        group_label: 'Csoport',
        select_media_episode_collection_header: 'Select Media Episode',
        start_type_label: "Kezdő típus",
        start_offset_label: 'Kezdő eltolás',
        time_hh_mm_ss_ff_label: 'óó:pp:ss:ff',
        negatív_label: 'Negatív',
        end_type_label: 'Végtípus',
        end_offset_label: 'Végeltolás',
        add_secondary_event_button_toottip: "Másodlagos események hozzáadása",
        text_number_column: "Szöveg száma",
        prefix_column: "Előtag",
        rule_column: "Szabály",
        text_number_label: "Szöveg száma",
        prefix_label: 'Előtag',
        rule_label: "Szabály",
        style_sheet_editpageheader: "Stíluslap",
        add_prototype_button_tooltip: 'Prototípus hozzáadása',
        id_column: 'ID',
        protoType_source_column: 'ProtoType Source',
        group_column: 'Csoport',
        select_prototype_collection_header: 'Prototípus kiválasztása',
        default_prototype_editpageheader: 'Alapértelmezett prototípus',
        create_secondary_event_dynamic_rule_dialog_header: "Másodlagos esemény dinamikus szabályának létrehozása",
        formula_label: 'Képlet',
        Secondary_event_overview_dialog_header: "Másodlagos esemény áttekintése",
        start_type_column: "Kezdő típus",
        start_offset_column: "Kezdő eltolás",
        end_type_column: 'EndType',
        end_offset_column: 'Vége eltolás',
        megerősítés_button_text: 'Megerősítés',
        billing_period_label: "Számlázási időszak",
        upto_label: 'Upto',
        gener_bill_button_tooltip: "Számla generálása",
        gener_bill_button_text: 'Számla generálása',
        agency_column: "Ügynökség",
        client_column: 'kliens',
        comission_column: 'Jutalék %',
        from_column: 'From',
        to_column: 'Címzett',
        total_budget_spot_column: "Célhelyek",
        total_booked_spot_column: "Összes lefoglalt helyek",
        Missing_spot_column: "Hiányzó helyek",
        reconciled_spots_column: "Egyeztetett helyek",
        genered_bill_Spots_column: "Generált számlahelyek",
        contact_label: 'Kapcsolat',
        contact_info_label: 'Kapcsolattartási adatok',
        phone_label: 'Telephone',
        address1_label: 'Cím1',
        address2_label: 'Cím2',
        agency_info_label: "Ügynökségi adatok",
        spots_label: 'Foltok',
        summas_label: 'Összegek',
        total_booked_label: 'Összesen lefoglalt',
        Missing_label: 'Hiányzik',
        genered_bill_label: "Generált számla",
        payment_recived_label: 'Befizetés megérkezett',
        due_amount_label: "Esedékes összeg",
        credit_balance_label: 'Hitelegyenleg',
        selected_campaign_info_label: "Kiválasztott kampányadatok",
        booked_label: 'Foglalva',
        detail_for_selected_date_range_and_campaign_label: "Részletek a kiválasztott dátumtartományhoz és kampányhoz",
        invoice_denomination_dialog_header: "Számla címlete",
        invoice_period_label: "Számla időszaka",
        invoice_campaign_brabd_label: "Kampánymárkák",
        select_period_label: 'Időszak kiválasztása',
        show_button_tooltip: "Megjelenítés",
        show_button_text: 'Megjelenítés',
        details_label: 'Részletek',
        caption_column: "Felirat",
        spots_column: 'Foltok',
        tax_column: "Adó",
        tax_label: "Adó",
        tax_not_applicable_label: "Az adó nem vonatkozik",
        discount_amount_label: "Kedvezményösszeg",
        invoice_date_label: "Számla dátuma",
        bank_account_label: "Bankszámla",
        gross_total_label: "Bruttó összesen",
        tax_amount_label: "Adóösszeg",
        Commission_amount_label: "Jutalék összege",
        target_amount_label: 'Célösszeg',
        invoice_no_column: "Számla száma",
        campaign_no_column: 'Kampányszám',
        invoice_date_column: "Számla dátuma",
        period_from_column: 'Period From',
        period_to_column: 'Period To',
        validated_amount_column: "Érvényesített összeg",
        discount_percentage_column: 'Kedvezmény százaléka',
        discount_amount_column: "Kedvezményösszeg",
        company_menu: 'Vállalat',
        logo_url_label: "Logo URL",
        logo_width_label: "Logo Width",
        suffix_label: 'Utótag',
        next_number_label: "Következő szám",
        full_channel_name_label: "Csatorna teljes neve",
        short_channel_name_label: "Rövid csatornanév",
        epg_code_label: "EPG kód",
        as_run_code_label: "Futtatási kódként",
        automation_channel_name_label: "Automatizálási csatorna neve",
        color_label: 'Szín',
        automation_label: 'Automatizálás',
        repeat_pattern_details_dialog_header: 'Ismétlődő minta részletei',
        add_repeat_button_tooltip: 'Ismétlés hozzáadása',
        create_repeat_pattern_editpage_header: "Ismétlési minta létrehozása",
        create_variation_editpage_header: "Változat létrehozása",
        create_break_format_editpage_header: "Szünetformátum létrehozása",
        edit_variation_editpage_header: "Változat szerkesztése",
        edit_break_format_editpage_header: "Szünetformátum szerkesztése",
        add_primary_pattern_button_tolltip: "Elsődleges hozzáadása",
        elsődleges_events_no_column: "Elsődleges események száma",
        repeat_events_no_column: 'Repeat Events No',
        nominal_start_column: 'Névleges indítás',
        elsődleges_events_no_label: "Elsődleges események száma",
        days_label: 'napok',
        times_label: 'Times',
        create_invoice_content_dialog_header: "Számlatartalom létrehozása",
        number_length_label: 'Szám hossza',
        címke: "Címke",
        sequence_label: 'Sequence',
        entity_name_label: 'Entitás neve',
        max_length_label: "Maximális hossz",
        width_label: 'Szélesség',
        required_label: 'Kötelező',
        edit_label: 'Szerkesztés',
        slot_time_column: 'Slot Time',
        please_generate_segment_to_load_media_label: 'Kérjük, generáljon szegmenst a média betöltéséhez!',
        filter_button_tooltip: "Szűrő",
        search_content_dialog_header: 'Tartalom keresése',
        clear_button_tooltip: 'Törlés',
        clear_button_text: 'Törlés',
        search_button_tooltip: 'Keresés',
        search_button_text: 'Keresés',
        select_preference_for_dialog_header: 'Válassza ki a következő oszloppreferenciát',
        available_label: 'Elérhető',
        preferencia_label: 'Preferencia',
        note_preference: 'Megjegyzés: - Alapértelmezett oszlopok esetén hagyja üresen a beállítást',
        house_number_label: "Házszám",
        category_type_label: 'Kategória típusa',
        slot_time_label: 'Slot Time',
        fact_duration_label: "Tényleges időtartam",
        nominal_duration_label: "Névleges időtartam",
        segments_label: "Szegmensek",
        recursive_button_text: 'Rekurzív',
        recursive_dialog_header: 'Rekurzív',
        gener_button_toottip: 'Generál',
        gener_button_text: 'Excel',
        inclusion_range_label: "Befogadási tartomány",
        episode_range_label: 'Episode Range',
        example_label: 'Példa',
        exclusion_range_label: "Kizárási tartomány",
        include_days_label: 'Napok kizárása',
        format_icon_tooltip: "Formátum",
        no_segment_icon_tooltip: "Nincs szegmens",
        contract_icon_tooltip: "Szerződés",
        slot_duration_title_label: 'Slot Duration',
        maximize_button_tooltip: 'Maximize',
        copy_Schedule_button_tooltip: 'Másolás',
        planing_preference_button_tooltip: 'Tervezési preferencia',
        export_planning_button_tooltip: "Exporttervezés",
        selected_label: 'Kiválasztva',
        copied_label: 'Másolva',
        select_channels_dialog_header: "Csatornák kiválasztása",
        date_label: 'Dátum',
        copy_Schedule_dialog_header: 'Ütemezés másolása',
        copy_from_label: 'Másolás innen',
        copy_to_label: 'Másolás ide',
        selected_date_should_be_equal_error_message: "A kiválasztott dátumtartománynak egyenlőnek kell lennie",
        from_channel_label: 'Csatornáról',
        to_channel_label: "Csatornához",
        activity_label: 'Tevékenység',
        create_button_tootltip: "Létrehozás",
        create_button_text: 'Létrehozás',
        planing_preference_dialog_header: 'Tervezési preferencia',
        events_label: 'Események',
        columns_label: 'Oszlopok',
        general_label: 'Általános',
        note_select_the_events_you_want_to_change: 'Válassza ki a módosítani kívánt eseményeket',
        events_type_labe: 'Esemény típusa',
        foreground_Color_label: "Előtér színe",
        background_color_label: "Háttérszín",
        available_columns_label: 'Elérhető oszlopok',
        view_type_label: "Nézet típusa",
        show_format_label: 'Formátum megjelenítése',
        show_no_seg_label: 'Show No Seg',
        show_contract_label: 'Szerződés megjelenítése',
        day_Start_time_label: 'Nap kezdési ideje',
        prime_end_time_label: 'Prime end time',
        prime_Start_time_label: 'Prime Start Time',
        episode_Column: 'Episode',
        season_Column: 'Szezon',
        versions_column: 'Verziók',
        search_filter_dialog_header: "Keresési szűrő",
        release_year_label: "Kiadás éve",
        is_live_label: 'IsLive',
        save_as_template_label: 'Mentés sablonként',
        show_search_options_media_liberary_tooltip: "Keresési beállítások megjelenítése",
        place_holder_dialog_header: 'Helytartó',
        please_choose_one_publishing_rights_collection_header: "Kérjük, válasszon egy közzétételi jogot",
        export_excel_dialog_header: "Excel exportálása",
        export_excel_button_tooltip: "Excel exportálása",
        export_csv_button_tooltip: "CSV exportálása",
        export_excel_button_text: "Excel exportálása",
        history_dialog_header: "Előzmények",
        slot_date_column: 'Slot Date',
        kiállítás_no_column: 'Szám. kiállítás',
        repeat_no_column: 'Nem ismétlés',
        planing_loaded_label_note: 'Tervezés betöltve',
        planing_loading_label_note: 'Betöltés tervezése....',
        time_column: 'Time',
        prototypes_column: 'Prototípusok',
        info_column: 'Információ',
        cut_button_tooltip: "Vágás",
        paste_button_tooltip: "Beillesztés",
        download_pdf_button_tooltip: 'PDF letöltése',
        open_planning_button_tooltip: "Nyitott tervezés",
        delete_all_footer_button_tooltip: "Az összes lábléc törlése",
        delete_All_secondary_events_button_tooltip: "Minden másodlagos esemény törlése",
        global_replacement_button_tooltip: "Globális csere",
        apply_style_sheet_button_tooltip: "Stíluslap alkalmazása",
        apply_button_tooltip: 'Alkalmaz',
        apply_button_text: 'Alkalmaz',
        schedule_preference_button_tooltip: 'Ütemezési beállítások',
        auto_save_button_tooltip: "Automatikus mentés",
        Secondary_events_label: "Másodlagos események",
        text_1_column: 'Szöveg 1',
        text_2_column: 'Szöveg 2',
        text_3_column: "3. szöveg",
        prototypes_label: 'Prototípusok',
        insert_break_actionbutton_menutext: 'Szünet beszúrása',
        delete_header_actionbutton_menutext: 'Fejléc törlése',
        program_replacement_actionbutton_menutext: 'Programcsere',
        attach_format_reload_actionbutton_menutext: "Formátum csatolása",
        history_actionbutton_menutext: "Előzmények",
        select_program_to_replace_with_collection_title: 'Cserélni kívánt program kiválasztása',
        global_replacement_dialog_header: "Globális csere",
        change_button_tooltip: 'Csere',
        change_button_text: 'Csere',
        change_method_label: "Cseremódszer",
        include_isBreak_label: 'Szünetet tartalmaz',
        change_with_same_duration_only: 'Cserélje csak azonos időtartamra',
        enable_cross_category_replacement: "Keresztkategória engedélyezése",
        change_material_label: "Csereanyag",
        delete_all_button_tooltip: "Összes törlése",
        delete_all_button_text: 'Összes törlése',
        group_all_button_tooltip: "Group Media Episode",
        group_all_button_text: 'Group Media Episode',
        select_media_episode_dialoag_header: 'Select Media Episode',
        select_media_episode_group_dialoag_header: 'Select Media Episode Group',
        remove_filter_actionbutton_menutext: 'Szűrő eltávolítása',
        filter_actionbutton_menutext: 'Szűrő',
        copy_actionbutton_menutext: 'Másolás',
        paste_actionbutton_menutext: "Beillesztés",
        se_overview_actionbutton_menutext: 'SE áttekintése',
        global_replacement_actionbutton_menutext: "Globális csere",
        sales_team_label: "Értékesítési csapat",
        Department_label: 'Osztály',
        password_label: 'Jelszó',
        phone_no_label: 'Telefonszám',
        pobox_label: 'PO Box',
        reporting_to_lable: 'Jelentés készítése',
        role_label: 'Szerep',
        issalesexecutive_label: "IsSalesExecutive",
        sales_executive_editpageheader: "Értékesítési vezető",
        email_column: 'E-mail',
        phone_no_column: 'Telefonszám',
        select_sales_executive_colllection_header: "Értékesítési vezető kiválasztása",
        select_collection_button_text: 'Kiválasztás',
        export_planet_cast_button_tooltip: "Export Planet Cast",
        check_list_button_tooltip: "Ellenőrző listák",
        check_lists_dialog_header: "Ellenőrző listák",
        success_label: 'Siker',
        fail_lable: 'Failure',
        module_menu: 'Modul',
        sales_team_dailog_header: "Értékesítési csapat létrehozása",
        module_dialog_header: 'Modul',
        role_dialog_header: 'Szerep',
        admin_label: "Adminisztrátor",
        sales_label: 'Sales',
        media_management_label: 'Médiakezelés',
        Rights_manager_label: 'Jogkezelő',
        role_editpageheader: 'Szerep',
        select_module_collection_header: 'Modul kiválasztása',
        users_editpage_header: 'Felhasználó',
        select_Role_collection_header: 'Select Role',
        module_column: 'Modul',
        role_column: 'Szerep',
        add_role_collection_text: 'Szerep hozzáadása',
        add_role_button_text: 'Hozzáadás a szerepkörből',
        add_module_collection_text: 'Modul hozzáadása',
        sales_executive_editpage_header: "Értékesítési vezető",
        timeline_page_breadcrumb: "Idővonal",
        linear_timeline_page_breadcrumb: "Lineáris idővonal",
        series_timeline_page_breadcrumb: "Sorozat idővonala",
        property_type_page_breadcrumb: 'Eszköztípus',
        rails_type_page_breadcrumb: "Rails Type",
        posters_type_page_breadcrumb: "Poszterek típusa",
        Department_page_breadcrumb: "Osztály",
        users_page_breadcrumb: 'Felhasználók',
        role_page_breadcrumb: "Szerep",
        property_page_breadcrumb: "Eszközök",
        posters_page_breadcrumb: "Poszterek",
        client_page_breadcrumb: "Ügyfél",
        agency_page_breadcrumb: "Ügynökség",
        sales_team_page_breadcrumb: "Értékesítési csapat",
        trailer_page_breadcrumb: 'Előzetes',
        sales_executive_page_breadcrumb: "Értékesítési vezető",
        content_page_breadcrumb: "Tartalom",
        channel_page_breadcrumb: "Csatorna",
        currency_page_breadcrumb: 'Pénznem',
        repeat_pattern_page_breadcrumb: "Minta ismétlése",
        invoice_content_page_breadcrumb: "Számla tartalma",
        segment_type_page_breadcrumb: "Szegmens típusa",
        contract_page_breadcrumb: "Szerződés",
        series_page_breadcrumb: 'Parent Series',
        season_page_breadcrumb: "Series",
        programs_page_breadcrumb: 'Programok',
        episode_page_breadcrumb: 'Epizód',
        movies_page_breadcrumb: "Filmek",
        interstitial_page_breadcrumb: "Közbeiktatott",
        commercial_page_breadcrumb: "Kereskedelmi",
        music_page_breadcrumb: "Zene",
        filler_page_breadcrumb: "Filler",
        break_page_breadcrumb: "Szünet",
        group_page_breadcrumb: "Csoport",
        program_group_page_breadcrumb: "Programcsoport",
        interstital_group_page_breadcrumb: "Közbeiktatott csoport",
        schedule_constraints_page_breadcrumb: "Ütemezési kényszerek",
        campaign_page_breadcrumb: "Kampány",
        utilied_label: 'Utilied',
        over_booked_label: 'Túlfoglalt',
        counts_label: 'Számlások',
        active_label: 'Aktív',
        top_10_agency_label: "A 10 legjobb ügynökség",
        top_10_client_label: "A 10 legjobb ügyfél",
        pending_vs_on_air_booking_label: "Függőben vs OnAirBooking",
        bevétel_by_location_label: "Bevétel hely szerint",
        bevétel_by_months_label: "Bevétel hónapok szerint",
        booking_by_deal_type_label: "Foglalás DealType szerint",
        time_range_label: "Időtartomány",
        language_page_breadcrumb: 'Nyelv',
        region_page_breadcrumb: "Régió",
        brand_page_breadcrumb: "Márka",
        product_page_breadcrumb: "Termék",
        rails_page_breadcrumb: "Sínek",
        page_breadcrumb: 'Oldalok',
        content_caegory_page_breadcrumb: "Tartalomkategória",
        ingestion_page_breadcrumb: "Lenyelés",
        jobs_page_breadcrumb: 'Jobs',
        prototype_page_breadcrumb: "Prototípus",
        prototype_style_sheet_page_breadcrumb: "Prototípus stíluslap",
        default_prototype_style_sheet_page_breadcrumb: "Alapértelmezett prototípus stíluslap",
        prototype_source_page_breadcrumb: "Prototípus forrása",
        export_template_page_breadcrumb: "Export sablon",
        form_fields_page_breadcrumb: "Űrlapmezők",
        Secondary_event_dynamic_rule_page_breadcrumb: "Másodlagos eseménydinamikai szabály",
        format_page_breadcrumb: "Formátum",
        time_range_page_breadcrumb: "Időtartomány",
        company_page_breadcrumb: 'Vállalat',
        bank_account_page_breadcrumb: "Bankszámla",
        tax_page_breadcrumb: "Adó",
        licensor_page_breadcrumb: "Licensz",
        delete_successfully_grid_data_success_toast_message: "Sikeres törlés",
        delete_all_successfully_grid_data_success_toast_message: 'Minden törlés sikeresen',
        please_select_first_contract_collection_error_message: 'Kérjük, először válasszon!!',
        please_enter_contarct_number_contract_error_message: "Kérjük, adja meg a szerződés számát",
        please_select_platform_type_error_message: "Kérjük, válassza ki a platform típusát",
        please_select_licensor_error_message: "Kérjük, válassza ki a licencadót",
        please_select_payee_error_message: "Kérjük, válassza ki a kedvezményezettet",
        please_select_platform_error_message: "Kérjük, válasszon platformot",
        please_select_channel_error_message: 'Kérjük, válasszon csatornát',
        please_select_region_error_message: 'Kérjük, válasszon régiót',
        please_select_content_error_message: "Kérjük, válasszon tartalmat",
        please_select_play_time_error_message: "Kérjük, válassza ki a lejátszási időt",
        please_select_media_category_type_error_message: "Kérjük, válassza ki a médiakategória típusát",
        please_select_genres_media_episode_error_message: "Kérjük, válasszon műfajt",
        please_select_department_error_message: "Kérjük, válassza ki az osztályt",
        please_enter_title_error_message: "Kérjük, adja meg a címet",
        please_enter_description_error_message: "Kérjük, adja meg a leírást",
        please_enter_name_error_message: "Kérem, adja meg a nevet",
        please_enter_phone_no_error_message: "Kérjük, adja meg telefonszámát",
        please_enter_email_error_message: "Kérjük, adjon meg érvényes e-mail-címet",
        please_select_roletype_error_message: "Kérjük, válasszon RoleType-ot",
        please_enter_user_name_users_error_message: "Kérjük, adja meg a felhasználónevet",
        please_enter_password_users_error_message: "Kérjük, adja meg a jelszót",
        invalid_duration_error_message: "Kérjük, adja meg az érvényes időtartamot",
        please_attach_atleast_one_media_episode_group_error_message: "Kérjük, csatoljon legalább egy adathordozót",
        please_add_atleast_one_module_rights_users_error_message: "Kérjük, adjon hozzá legalább egy moduljogot",
        please_select_reportingto_user_error_message: "Kérjük, válassza a Jelentési cím lehetőséget",
        please_select_sales_team_error_message: "Kérjük, válassza ki az értékesítési csapatot",
        exhibition_should_not_be_zero_error_message: "A kiállításnak nagyobbnak kell lennie nullánál",
        repeat_should_not_be_zero_error_message: "Az ismétlésnek nagyobbnak kell lennie nullánál",
        play_time_number_should_not_be_zero_error_message: "A lejátszási idő számának nagyobbnak kell lennie nullánál",
        end_date_should_be_greater_than_start_date_error_message: "A befejezési dátumnak nagyobbnak kell lennie, mint a kezdő dátum",
        please_attach_atleast_one_media_contract_error_message: "Kérjük, csatoljon legalább egy adathordozót",
        please_select_season_content_series_error_message: "Kérjük, válassza ki az évad tartalmát",
        value_is_not_greater_then_zero_season_number_series_error_message: "Az évad számának nagyobbnak kell lennie nullánál",
        please_select_epiosde_content_series_error_message: "Kérjük, válassza ki az epizód tartalmát",
        value_is_not_greater_then_zero_episode_number_series_error_message: "Az epizódszámnak nagyobbnak kell lennie nullánál",
        please_attach_series_season_error_message: "Kérjük, csatolja a sorozatot",
        please_add_atleast_one_season_series_error_message: "Kérjük, adjon hozzá legalább egy évadot",
        entering_same_season_number_twice_series_error_message: 'Azonos évadszám kétszeri megadása',
        enter_title_expender: "Adja meg a címet",
        please_select_poster_type_first_media_episode_poster_error_message: "Kérjük, válassza ki a poszter típusát",
        please_select_url_first_media_episode_poster_error_message: "Először válassza ki az URL-t",
        please_select_the_value_in_start_date_media_episode_publishing_error_message: 'Kérjük, válassza ki az értéket a Kezdő dátum mezőben',
        please_select_the_value_in_end_date_media_episode_publishing_error_message: "Kérjük, válassza ki az értéket a Befejezés dátuma mezőben",
        you_delete_this_deal_right_from_contract_only_media_episode_publishing_error_message: 'Ezt az ügyletet csak a szerződésből törli!!',
        please_select_ottvideo_type_media_episode_video_error_message: "Kérjük, válassza ki a videó típusát",
        create_dialog_header: "Létrehozás",
        synopsis_can_not_be_null_media_episode_Synopsis_error_message: 'Az összefoglaló nem lehet nulla',
        please_select_language_media_episode_Synopsis_error_message: 'Kérjük, válasszon nyelvet',
        please_enter_name_cast_crew_media_episode_error_message: "Kérjük, adja meg a nevet",
        please_select_casttype_cast_crew_media_episode_error_message: "Kérjük, adja meg a leadási típust",
        please_select_segment_type_media_episode_version_error_message: "Kérjük, válassza ki a szegmens típusát",
        please_generate_segments_first_media_episode_version_error_message: "Kérjük, generáljon szegmenseket",
        media_episode_entity_duration_segment_error_message: 'A tényleges időtartam nulla. Kérjük, frissítse az érvényes időtartamot a szegmentálás alkalmazásának időtartama mezőben',
        please_select_brand_media_episode_error_message: "Kérjük, válasszon márkát",
        please_select_product_media_episode_error_message: "Kérjük, válassza ki a terméket",
        please_enter_value_media_episode_error_message: "Kérjük, adja meg az értéket",
        please_enter_valid_value_tcin_should_not_be_greater_than_tcout_media_episode_error_message: 'Kérjük, adjon meg érvényes értéket, a TcIn nem lehet nagyobb, mint a TcOut',
        error_while_generating_house_number_media_episode_error_message: "Hiba a házszám generálásakor",
        jau_exists_global_error_message: 'Már létezik !!',
        you_can_update_this_deal_right_from_contract_only_media_episode_publishing_error_message: 'Ezt az ügyletet csak a szerződéstől kezdve frissítheti!!',
        this_segment_is_already_been_scheduled_segmnet_media_episode_error_message: 'Ez a szegmens már ütemezve van',
        please_enter_title_display_rails_error_message: "Kérjük, adja meg a cím megjelenítését",
        atleast_attach_one_ottassets_rails_error_message: 'Legalább egy OttAssets csatolás',
        please_enter_enter_icon_uel_error_message: "Kérjük, adja meg az ikon URL-jét",
        create_label: 'Létrehozás',
        edit_lable: 'Szerkesztés',
        select_label: 'Kiválasztás',
        please_select_media_category_type_first_media_episode_group_error_message: "Kérjük, először válassza ki a médiakategória típusát",
        please_select_role_users_error_message: "Kérjük, válasszon szerepet",
        user_name_error_message: 'User/Sale Executive azonos felhasználónévvel',
        no_data_found_scheduling_reconciliation_error_message: 'Nem található adat!',
        schedule_and_as_run_data_load_successfully_scheduling_reconciliation_success_message: "Az ütemezés és az AsRun adatok sikeresen betöltve",
        error_while_loading_as_run_data_scheduling_reconciliation_error_message: 'Hiba az AsRun adatok betöltésekor:',
        auto_recocile_successfully_scheduling_reconciliation_success_message: 'Automatikus egyeztetés sikeresen!!',
        select_first_scheduling_reconciliation_error_message: 'Kérjük, válassza ki az Ütemezést és a Futtatási módot az egyező tételt!',
        jau_reconsiled_scheduling_reconciliation_error_message: 'Már újra egyeztetve!',
        select_item_have_different_assetid_scheduling_reconciliation_error_message: 'A kiválasztott tétel eltérő AssetId-vel rendelkezik!',
        force_unmatch_successfully_scheduling_reconciliation_success_message: 'Az unmatch sikeres kényszerítése!!',
        please_select_schedule_and_as_run_item_scheduling_reconciliation_error_message: 'Kérjük, válassza ki az ütemezést és az AsRun elemet!',
        select_item_is_not_reconsiled_scheduling_reconciliation_error_message: 'A kiválasztott tétel nincs újra egyeztetve!',
        select_schedule_and_asrun_item_not_reconciled_together_scheduling_reconciliation_error_message: 'A kiválasztott ütemezés és az asrun elem nincs összehangolva',
        select_schedule_item_already_billed_error_message: 'A kiválasztott ütemezési tétel már ki van számlázva.',
        saved_successfully_scheduling_reconciliation_success_message: 'Sikeresen elmentve!!!',
        role_type_label: 'Szereptípus',
        please_load_first_scheduling_reconciliation_error_message: 'Kérjük, először töltse be !!',
        tx_mode_label: 'TX mód',
        segment_count_label: "Szegmensek száma",
        create_segment_type_dialog_header: "Szegmenstípus létrehozása",
        please_enter_type_name_segment_type_error_message: "Kérjük, adja meg a típus nevét",
        please_select_tx_mode_segment_type_error_message: 'Kérjük, válasszon TX módot',
        please_enter_segment_count_segment_type_error_message: "Kérjük, adja meg a szegmensek számát",
        interstitial_group_sub_menu: "Közbeiktatott csoport",
        program_group_sub_menu: 'Programcsoport',
        variation_page_breadcrumb: "Változat",
        breakformat_page_breadcrumb: "Break Format",
        payment_provider_page_breadcrumb: "Fizetési szolgáltató",
        ott_period_type_page_breadcrumb: "Ott időszak típusa",
        payment_type_page_breadcrumb: "Fizetési típus",
        ott_period_page_breadcrumb: "Időszak",
        subscriber_page_breadcrumb: 'Feliratkozó',
        media_type_label: 'Médiatípus',
        atleast_attach_one_item_variation_error_message: "Legalább egy elem csatolása",
        please_select_media_type_error_message: "Kérjük, válassza ki a médiatípust",
        season_number_should_not_be_zero_error_message: "Az évad számának nagyobbnak kell lennie nullánál",
        number_of_epiosde_should_not_be_zero_error_message: "Az epizód számának nagyobbnak kell lennie nullánál",
        start_epiosde_should_not_be_zero_error_message: "A kezdő epizódnak nagyobbnak kell lennie nullánál",
        please_select_potraitimageurl_otteditform_error_message: "Kérjük, válasszon állókép URL-t",
        please_select_landscapeimageurl_otteditform_error_message: "Kérjük, válassza ki a fekvő kép URL-címét",
        include_pre_opening_label: 'Include Pre Opening',
        include_closing_label: 'Bezárás',
        break_number_column: "Break Number",
        break_duration_column: "Szünet időtartama",
        commercial_duration_column: "Kereskedelmi időtartam",
        promo_duration_Column: "Promóció időtartama",
        total_break_duration_label: "A szünet teljes időtartama",
        segment_count_should_be_zero_error_message: "A szegmensek számának nagyobbnak kell lennie egynél",
        invalid_slot_duration_error_message: 'Érvénytelen időköz időtartama',
        invalid_total_break_duration_error_message: "Érvénytelen teljes szünetidő",
        break_not_distribute_breakformat_error_message: 'A szünetek nincsenek terjesztve',
        slot_duration_should_Be_greater_than_total_break_duration_breakformat_error_message: "A slot időtartamának nagyobbnak kell lennie, mint a szünet teljes időtartama",
        break_count_segment_count_does_not_match_breakformat_error_message: "A törésszám és a szegmensszám nem egyezik",
        please_enter_template_name_error_toast: "Kérjük, adja meg a sablon nevét",
        please_select_module_type_error_message: "Kérjük, válassza ki a modul típusát",
        please_select_ingestion_template_type_error_message: "Kérjük, válassza ki a feldolgozási sablon típusát",
        saved_successfully_message: 'Sikeresen mentve',
        please_enter_code_error_message: "Kérjük, adja meg a kódot",
        please_select_agency_error_message: "Kérjük, válassza ki az ügynökséget",
        please_select_default_tax_error_message: "Kérjük, válassza ki az alapértelmezett adót",
        please_select_agency_type_error_message: "Kérjük, válassza ki az ügynökség típusát",
        please_select_atleast_one_Sales_executive: "Kérjük, válasszon legalább egy értékesítési vezetőt",
        add_sales_executive_button_tooltip: "Értékesítési vezető hozzáadása",
        please_enter_prefix_error_message: "Kérem, adja meg az előtagot",
        please_enter_suffix_error_message: "Kérjük, írja be az utótagot",
        please_attach_atleast_one_media_error_message: "Kérjük, csatoljon legalább egy adathordozót",
        please_enter_full_Channel_name_error_message: "Kérjük, adja meg a csatorna teljes nevét",
        please_enter_short_Channel_name_error_message: "Kérjük, adja meg a csatorna rövid nevét",
        please_select_atleast_one_repeat_pattern_error_message: 'Kérjük, válasszon legalább egy ismétlést!',
        elsődleges_delete_succesfully_repeat_pattern_error_message: "Elsődleges törlés sikeresen",
        repeat_delete_succesfully_repeat_pattern_error_message: "A törlés ismétlése sikeresen",
        please_select_atleast_one_days_repeat_pattern_error_message: 'Kérjük, válasszon legalább egy napot!',
        please_enter_automation_channel_name_error_message: "Kérjük, adja meg az automatizálási csatorna nevét",
        please_enter_epg_code_error_message: "Kérem, adja meg az EPG kódot",
        please_select_automation_error_message: "Kérjük, válassza az automatizálást",
        please_enter_color_error_message: "Kérjük, adja meg a színt",
        please_add_atleast_one_module_role_error_message: 'Kérjük, adjon hozzá legalább egy modult!',
        data_loaded_successfully_ingestion_template_message: "Az adatok sikeresen betöltve",
        please_enter_positive_value_in_creditlimit_error_message: "Kérjük, adjon meg pozitív értéket a CreditLimitben",
        please_enter_gst_no_error_message: "Kérjük, adja meg a GST-számot",
        please_enter_campaign_no_error_message: "Kérjük, adja meg a kampány számát",
        please_select_client_error_message: 'Kérjük, válasszon klienst',
        period_from_should_be_less_then_periodto_campaign_error_message: "A PeriodFrom kisebbnek kell lennie, mint a PeriodTo",
        Commission_exceeded_from_limit_campaign_error_message: 'Jutalék túllépve a korláton.',
        discount_exceeded_from_limit_campaign_error_message: 'A kedvezmény túllépte a korlátot.',
        please_enter_target_budget_error_message: "Kérjük, adja meg a célköltségkeretet",
        please_enter_target_spots_error_message: "Kérjük, adja meg a célpontokat",
        please_enter_target_seconds_error_message: "Kérjük, adja meg a célmásodperceket",
        please_attach_atleast_one_commercials_campaign_error_message: "Kérjük, csatoljon legalább egy reklámot",
        please_attach_atleast_one_channel_campaign_error_message: "Kérjük, csatoljon legalább egy csatornát",
        please_select_campaign_type_error_message: "Kérjük, válassza ki a kampány típusát",
        please_enter_rate10sec_error_message: "Kérjük, válasszon Rate10sec",
        please_enter_fct_error_message: "Kérjük, adja meg az FCT-t",
        please_enter_from_date_error_message: "Kérjük, adja meg a kezdő dátumot",
        please_enter_to_date_error_message: "Kérjük, adja meg a dátumot",
        please_enter_amount_error_message: "Kérjük, adja meg az összeget",
        data_loading_error_message: 'Adatok betöltése...',
        no_record_found_error_message: 'Nem található rekord!',
        total_sum_spot_rate_success_message: "Teljes összegű azonnali árfolyam",
        total_fct_success_message: 'Total FCT',
        booking_is_used_in_schedule_show_spot_error_message: 'A foglalás az ütemezésben használatos',
        changes_Will_Reflect_in_new_planned_items_only_segmenttype_error_message: "A változtatások csak az új tervezett tételekben fognak tükröződni",
        please_select_campaign_first_booking_error_message: "Kérjük, először válassza ki a kampányt",
        error_reading_file_booking_error_message: "Hiba a fájl olvasása közben",
        wrong_month_selected_booking_error_message: 'Rossz hónap van kiválasztva',
        wrong_year_selected_booking_error_message: 'Rossz év van kiválasztva',
        error_downloading_template_booking_error_message: "Hiba a sablon letöltése közben",
        please_select_a_value_to_update_booking_error_message: 'Kérjük, válasszon egy értéket a frissítéshez',
        exceding_target_spots_limit_booking_error_message: "Túllépi a célhelyek korlátját",
        exceding_target_budget_booking_error_message: "Célköltségkeret túllépése",
        commercials_not_updated_in_line_no_booking_error_message: "Reklámok nincsenek frissítve a sorszámban",
        exceding_target_seconds_booking_error_message: 'Célmásodperc túllépése',
        booking_saved_booking_error_message: 'Foglalás mentve',
        no_data_found_booking_error_message: "Nem található adat",
        from_time_should_be_less_than_To_time_booking_error_message: "Az időtől kevesebbnek kell lennie, mint az időnek",
        please_enter_spot_booking_error_message: "Kérjük, adja meg a helyet",
        please_enter_rate_booking_error_message: "Kérjük, adja meg az árfolyamot",
        please_select_transfer_from_date_booking_transfer_error_message: "Kérjük, válassza ki az átutalás dátumát",
        please_select_transfer_date_booking_transfer_error_message: "Kérjük, válassza ki az átutalás dátumát",
        please_select_item_booking_transfer_error_message: 'Kérjük, először válassza ki a tételt!',
        booking_transfer_succesfully_to_booking_transfer_error_message: "A transzfer foglalása sikeresen",
        exceding_target_spots_limit_update_booking_line_number_error_message: "Túllépi a célhelyek korlátját",
        exceding_target_budget_update_booking_line_number_error_message: "Célköltségkeret túllépése",
        exceding_target_seconds_update_booking_line_number_error_message: "Célmásodpercek túllépése",
        loading_data_update_booking_line_number_error_message: 'Adatok betöltése !!',
        data_loaded_update_booking_line_number_success_message: 'Az adatok sikeresen betöltve!!',
        loading_booking_update_booking_line_number_success_message: "Foglalás betöltése...",
        bill_is_already_generated_for_this_linenumber_update_booking_line_number_success_message: 'Erre a sorszámra már létrejött a számla!!',
        please_select_file_error_message: 'Kérjük, válasszon fájlt',
        downlaod_file_error_message: 'Fájl letöltése',
        no_import_type_defined_error_message: 'Nincs importálási típus definiálva',
        upload_Successfully_import_success_message: 'Feltöltés sikeresen',
        asrun_Save_Successfully_import_success_message: 'AsRun Save Successfully',
        asrun_save_failed_import_error_message: 'AsRun mentés nem sikerült',
        update_failed_import_error_message: 'A feltöltés sikertelen',
        assest_not_found_import_message: 'Assest nem található',
        planning_imported_successfully_import_message: 'Sikeres importálás tervezése',
        import_planning_failed_import_message: 'Az importtervezés nem sikerült.',
        read_to_upload_import_message: "Olvasás a feltöltéshez",
        please_select_from_date: 'Kérjük, válasszon a dátumtól',
        please_select_to_date_greater_than_from_date_error_message: 'Kérjük, válassza a Dátumig, nagyobb, mint a Kezdő dátumot',
        please_select_the_value_in_template_name_first_export_report_error_message: 'Kérjük, először válassza ki a sablonnévben szereplő értéket!',
        please_select_the_value_in_format_first_export_report_error_message: "Kérjük, először válassza ki a formátumban lévő értéket",
        please_add_at_least_one_item_list_export_report_error_message: 'Kérjük, adjon hozzá legalább egy cikklistát.',
        please_select_the_value_in_filters_first_export_report_error_message: 'Kérjük, először válassza ki az értéket a szűrőkben.',
        Please_select_the_value_in_Operator_first_export_report_error_message: 'Kérjük, először válassza ki az értéket az Operator mezőben.',
        value_can_not_be_null_export_report_error_message: 'Az érték nem lehet nulla',
        report_is_exported_successfully_message: 'Az EPG exportálása sikeres volt',
        content_report_is_exported_successfully_message: 'A jelentés exportálása sikeres volt',
        please_select_valid_dates_export_template_error_message: "Kérjük, válasszon érvényes dátumokat",
        exporting_data_please_wait_export_template_error_message: 'Az adatok exportálása, kérjük, várjon...',
        success_exported_export_template_message: 'Sikeresen exportálva',
        no_data_found_to_export_template_message: "Nem található exportálandó adat",
        please_select_the_value_in_available_column_export_template_error_message: "Kérjük, válassza ki az értéket az Elérhető oszlopban",
        please_enter_display_name_error_message: "Kérjük, adja meg a megjelenített nevet",
        please_enter_savetempleteas_export_template_error_message: "Mentés másként",
        please_add_column_atleast_one_item_export_template_error_message: "Kérem, adjon hozzá legalább egy oszlopot",
        is_saved_successfully_export_template_message: ' sikeresen elmentve',
        please_select_module_error_message: 'Kérjük, válassza ki a modult',
        please_enter_id_error_message: "Kérjük, adja meg az azonosítót",
        please_select_source_error_message: "Kérjük, válassza ki a forrást",
        please_select_atleast_one_secondary_events_error_message: "Kérjük, válasszon legalább egy másodlagos eseményt",
        invalid_startoffset_error_message: 'Érvénytelen kezdési eltolás',
        invalid_endoffset_error_message: 'Érvénytelen végeltolás',
        please_enter_text_no_error_message: "Kérjük, írja be a szöveg számát",
        please_select_the_value_in_rule_first_error_message: 'Kérjük, először válassza ki az értéket a szabályban',
        please_attach_atleast_one_prototype_stylesheet_error_message: "Kérjük, csatoljon legalább egy prototípust",
        please_enter_formula_error_message: "Kérjük, adja meg a képletet",
        please_wait_loading_data_billing_error_message: 'Kérjük, várjon, adatok betöltése...',
        data_loaded_successfully_billing_template_message: "Az adatok sikeresen betöltve",
        please_select_a_billing_detail_first_billing_template_message: 'Kérjük, először válasszon egy számlázási adatot !',
        no_reconciled_spots_found_for_selected_details_billing_template_message: 'A kiválasztott részletekhez nem található egyeztetett hely!',
        please_select_bank_billing_error_message: 'Kérjük, válasszon bankot !',
        please_select_tax_billing_error_message: 'Kérjük, válasszon adót!',
        please_select_brand_billing_error_message: 'Kérjük, válasszon márkát !',
        no_invoice_details_are_available_to_bill_billing_error_message: "Nincsenek számlaadatok a számlázáshoz!",
        campaign_brands_label: "Márka",
        all_label: 'Mind',
        selected_brand: 'Kiválasztott márka',
        selected_channel: 'Kiválasztott csatorna',
        brand_label: "Márka",
        please_select_file_first_datamigration_error_message: 'Először válassza ki a fájlt !!!',
        empty_media_grid_datamigration_error_message: 'Kérjük, töltse be az adatokat az alábbi rácsba az importáláshoz!!',
        please_select_type_datamigration_error_message: 'Kérjük, válasszon típust !!',
        imported_successfully_datamigration_success_message: 'Sikeresen importálva',
        please_select_language_error_message: "Kérjük, válasszon nyelvet",
        please_select_logo_url_first_error_mesage: 'Először válassza ki a logó URL-jét.',
        please_select_segment_type_and_channel_format_error_message: "Kérjük, válassza ki a szegmens típusát és csatornáját",
        new_create_formfield_dialog_header: 'Új létrehozás',
        please_select_segment_type_format_error_message: "Kérjük, válassza ki a szegmens típusát",
        not_allowed_for_segments_format_error_message: "Szegmenseknél nem engedélyezett",
        cant_delete_segments_format_error_message: "A szegmens nem törölhető",
        select_atleast_one_mediaDealRight_planner_error_message: "Válasszon legalább egy médiaszerződési jogot",
        first_copy_planner_items_you_want_to_paste_planner_error_message: "A beilleszteni kívánt tervezőelemek első másolása.",
        please_select_area_on_planner_where_to_paste_planner_error_message: 'Kérjük, válassza ki azt a területet a tervezőn, ahová be szeretné illeszteni.',
        from_date_cant_be_greater_than_to_date_paste_planner_error_message: 'A dátumtól kezdve nem lehet nagyobb, mint a dátumig!',
        call_planner_error_message: 'hívás',
        data_copy_schedule_please_wait_copyschedule_error_message: 'A másolási ütemezés érvényesítésének ellenőrzése, kérjük, várjon...',
        copy_schedule_data_copyschedule_successfully_message: 'Ütemezési adatok másolása sikeresen...',
        no_data_found_to_copy_schedule_error_message: "Nem található adat az ütemezés másolásához",
        applying_recursive_pattern_please_wait_planner_error_message: 'Rekurzív minta alkalmazása, kérjük, várjon...',
        recursive_pattern_applied_successfully_planner_success_message: 'Rekurzív minta sikeresen alkalmazva',
        pasted_pattern_planner_error_message: 'Beillesztett',
        items_pattern_planner_error_message: 'elemek',
        to_date_is_mandatory_recursive_error_message: 'A dátum kötelező.',
        to_date_should_be_greater_than_base_program_start_date_recursive_error_message: "A dátumnak nagyobbnak kell lennie, mint az alapprogram kezdő dátuma",
        select_one_item_to_open_schedule_planner_helper_error_message: 'válasszon ki egy elemet a megnyitáshoz',
        copy_button_text: 'Másolás',
        open_schedule_button_text: 'Ütemezés megnyitása',
        paste_button_text: "Beillesztés",
        delete_button_text: 'Törlés',
        error_fetching_channel_list_planning_wrapper_error_message: "Hiba a csatornalista lekérésekor",
        please_select_planning_item_planning_wrapper_error_message: "Kérjük, válassza ki a tervezési tételt",
        recursive_applied_successfully_planning_wrapper_message: 'Recursive Applied Successfully!!',
        select_program_group_label: 'Programcsoport kiválasztása',
        select_break_format__label: 'Szünetformátum kiválasztása',
        please_enter_template_name_to_save_template_planningfilter_error_message: 'Kérjük, adja meg a sablon nevét a sablon mentéséhez',
        selected_content_text_planning_footer: "Kiválasztott tartalom",
        copied_content_text_planning_footer: "Másolt tartalom",
        first_copy_planner_items_you_want_to_paste_planning_performance_error_message: "Először másolja be a beilleszteni kívánt tervezőelemeket.",
        please_select_area_on_planner_where_to_paste_planning_performance_error_message: 'Kérjük, válassza ki azt a területet a tervezőn, ahová be szeretné illeszteni.',
        select_atleast_one_mediadealright_planning_performance_error_message: 'válasszon legalább egy ügyletet helyesen',
        first_select_replace_items_global_replacement_error_message: "Először válassza ki az elemek cseréjét",
        please_select_content_to_delete_planning_performance_error_message: "Kérjük, válassza ki a törölni kívánt tartalmat",
        not_allowed_Control_with_schedule_planning_performance_error_message: "Nem engedélyezett, vezérlés ütemezéssel",
        entry_already_exist_try_with_different_values_collection_error_message: 'A bejegyzés már létezik, próbálkozzon más értékekkel.',
        please_select_first_collection_error_message: 'Kérjük, először válassza ki!',
        jau_attached_collection_error_message: 'Már csatolva !!',
        export_current_booking_tooltip: "Aktuális foglalás exportálása",
        export_saved_booking_tooltip: "Mentett foglalás exportálása",
        please_select_poster_type_error_message: "Kérjük, válassza ki a poszter típusát",
        browser_button_text: 'Tallózás',
        file_selected_label: 'Fájl kiválasztva',
        only_jpg_jpeg_and_png_files_are_allowed_msg: 'Csak jpg/jpeg és png fájlok engedélyezettek!',
        please_add_programs_format_error_message: 'Kérem adjon hozzá programformátumot',
        please_select_atleast_one_item: 'Kérjük, válasszon ki legalább egy elemet.',
        please_enter_season_number_error_message: "Kérjük, adja meg az évad számát",
        repeat_pattern_label: 'Minta ismétlése',
        select_repeat_pattern_collection_header: "Ismétlési minta kiválasztása",
        please_select_from_date_error_message: "Kérjük, válasszon a dátumtól",
        please_select_to_date_error_message: "Kérjük, válasszon a dátumig",
        please_select_to_date_grater_then_from_date_error_message: 'Kérjük, válassza ki a dátumtól nagyobb dátumot, mint a Kezdő dátum',
        parent_content_category_label: "Szülőtartalom kategória",
        rail_will_be_added_soon2_label: 'A vasút hamarosan hozzáadásra kerül2!',
        rail_will_be_added_soon3_label: 'A vasút hamarosan hozzáadásra kerül3!',
        no_select_image_error_message: 'Nincs képválasztás',
        please_enter_key_error_message: "Kérjük, adja meg a kulcsot",
        please_enter_value_error_message: "Kérjük, adja meg az értéket",
        please_wait_generating_bill: 'Számla generálása. Kérlek várj...',
        bill_generated_successfully: 'Számla sikeresen generálva',
        please_select_template_error_message: 'Kérjük, válasszon sablont',
        please_select_file_first_error_message: 'Először válassza ki a fájlt!',
        please_enter_first_error_message: 'Kérjük, először írja be!',
        please_select_channel_first: "Kérjük, először válassza ki a csatornát",
        please_select_start_date_error_message: "Kérjük, válassza ki a kezdési dátumot",
        please_select_end_date_error_message: "Kérjük, válassza ki a befejezési dátumot",
        please_enter_valid_sequnce_number_error_message: "Kérjük, adjon meg érvényes sorozatszámot",
        program_schedule_clash_breadcrumb: 'Programütemezési összecsapás',
        clash_channel_column: "Clash Channel",
        clashed_time_Column: 'Clashed Time',
        source_time_Column: 'Forrás ideje',
        no_data_found_error_message: 'Nem található adat!',
        movie_name_column: "Film neve",
        create_ott_period_type_dialog_header: "Ott periódus létrehozása",
        create_subscriber_dialog_header: 'Előfizető létrehozása',
        play_type_label: 'Play Type',
        ott_period_type_label: "Ott időszak típusa",
        please_enter_play_time_error_message: "A játékidőnek nullánál nagyobbnak kell lennie",
        please_select_play_type_error_message: "Kérjük, válassza ki a lejátszási típust",
        please_select_ott_period_type_error_message: "Kérjük, válassza ki az Ott időszak típusát",
        ott_period_label: 'Ott Period',
        payment_type_label: "Fizetési típus",
        trials_tab_label: 'Próbák',
        fix_trials_tab_label: "Rögzített próbaverziók",
        Rememberers_tab_label: "Emlékeztetők",
        payment_Provider_label: 'Fizetési szolgáltató',
        send_label: 'Emlékeztető',
        dayPrior_label: 'Előzetes emlékeztető napja',
        engedélyezése: 'Engedélyezés',
        trials_dialog_header: "Próbák",
        Rememberers_dialog_header: "Emlékeztetők",
        add_trial_button_tooltip: "Próbaverzió hozzáadása",
        add_reminders_button_tooltip: "Emlékeztetők hozzáadása",
        paymentPlan_sub_menu: 'Fizetési terv',
        please_select_Payment_Provider_error_message: "Kérjük, válassza ki a fizetési szolgáltatót",
        please_select_PlayType_error_message: 'Kérjük, válasszon lejátszási típust',
        please_select_OttPeriod_error_message: 'Kérjük, válasszon Ott időszakot',
        please_select_Currency_error_message: 'Kérjük, válassza ki a pénznemet',
        please_select_PaymentType_error_message: "Kérjük, válassza ki a fizetés típusát",
        ott_product_sub_menu: "Termék",
        ott_product_label: "Termék",
        sales_status_label: "Értékesítési állapot",
        geo_Region_label: 'Földrajzi régió',
        create_ott_product_type_dialog_header: "Ot termék létrehozása",
        please_select_geo_region_error_message: "Kérjük, válassza ki a földrajzi régiót",
        please_select_sales_status_error_message: "Kérjük, válassza ki az értékesítési állapotot",
        please_select_Payment_Plan_error_message: "Kérjük, válasszon fizetési tervet",
        show_app_bar_label: "Alkalmazássáv megjelenítése",
        isHomePage_label: 'IsHomePage',
        route_type_label: 'Útvonal típusa',
        page_label: 'Oldal',
        rails_l_label: "L",
        rails_uat_label: "U",
        live_label: 'Élő',
        uat_label: 'UAT',
        media_is_already_attached_with_another_asset_error_message: 'A média már egy másik eszközhöz van csatolva',
        add_payment_plan_tooltip: "Fizetési terv hozzáadása",
        trial_price_label: 'Próbaár',
        trial_days_label: 'Próbanapok',
        sort_index_label: 'Index rendezése',
        elrejtés: 'Hide',
        select_payment_plan_collection: 'Válasszon fizetési tervet',
        payments_dialog_header: "Kifizetések",
        daysBefore_label: "Napokkal ezelőtt",
        subscription_id_label: 'SubscriptionID',
        package_label: 'Csomag',
        last_updated_label: 'Utolsó frissítés',
        please_enter_subscription_id_error_message: "Kérjük, adja meg az előfizetés azonosítóját",
        please_enter_package_error_message: "Kérjük, adja meg a csomagot",
        please_enter_last_update_error_message: "Kérjük, adja meg az utolsó frissítést",
        please_select_route_type: "Kérjük, válassza ki az útvonal típusát",
        please_select_video_playback_url: "Kérjük, válassza ki a videó lejátszási URL-jét",
        please_select_page: 'Kérjük, válasszon oldalt',
        ott_campaign_page_breadcrumb: "Kampány",
        edit_campaign_editpage_header: "Ott kampány szerkesztése",
        add_rails_button_tootip: "Sínek hozzáadása",
        select_rails_collection: "Sínek kiválasztása",
        publish_column: "Publsih",
        from_date_should_be_less_than_to_date_error_message: 'A dátumtól kisebbnek kell lennie, mint a dátumig',
        please_select_rails_error_message: "Kérjük, válasszon legalább egy sínt",
        ott_rails_type_column: "Ott Rails típusa",
        add_above_option: 'Hozzáadás fent',
        add_below_option: 'Hozzáadás lent',
        select_any_one_collection_selection_error_message: 'Válasszon ki egyet',
        please_attach_media_first: 'Kérem csatolja a médiát',
        edit_actionbutton_option: 'Szerkesztés',
        profile_label: 'Profil',
        asset_label: 'Eszközazonosító',
        job_id_label: 'Munkaazonosító',
        job_started_label: 'Kezdve',
        job_finished_label: 'Befejezve',
        elapsed_label: 'Eltelt',
        job_input_file_label: "Beviteli fájl",
        media_type_column: 'Média típusa',
        file_location_column: 'Fájl helye',
        attach_media_button_tooltip: 'Média csatolása',
        attach_media_button_text: 'Média csatolása',
        select_media_collection_header: "Select Media",
        property_label_ott_collection: "Eszközök",
        select_assets_collection_header: "Select Assets",
        some_bookings_are_already_Scheduled_Could_not_transfer_error_message: 'Néhány foglalás már ütemezett, nem sikerült átvinni',
        jobs_title: 'Jobs',
        total_assets_label: "Összes eszköz",
        makegoodspot_sub_menu: 'Make Good Spot',
        makegoodspot_title: "Tedd jó helyre",
        makegoodspottransfer_dialog_header: "Jó helyszíni átvitel",
        select_item_date_between_from_and_to_error_message: "A kiválasztott átviteli dátumnak a kampányidőszak és a dátum közötti időszaknak kell lennie",
        please_transfer_error_date_greater_than_bookingdate_message: 'Kérjük, válasszon az aktuális foglalási dátumnál nagyobb átutalási dátumot!',
        latest_jobs_label: "Legújabb állások",
        invalid_date_range_copy_to_planning_error_message: "Érvénytelen másolat a dátumtartományhoz",
        invalid_date_range_copy_from_planning_error_message: "Érvénytelen másolat a dátumtartományból",
        date_range_between_seven_day_copy_from_planning_error_message: "A másolás dátumának 31 napon belülinek kell lennie",
        date_range_between_seven_day_copy_to_planning_error_message: "A másolás dátuma tartománynak 31 napon belül kell lennie",
        height_label: "Magasság",
        create_ott_asset_label: "Ott eszköz létrehozása",
        media_label: 'Média',
        latest_jobs_label: 'RECENT JOBS',
        please_select_type_error_message: "Kérjük, válassza ki a típust",
        create_schedule_constraints_editpage_header: "Ütemezési kényszerek létrehozása",
        schedule_constraints_error_message: 'Ütemezési kényszerek',
        constraints_labe: 'Korlátozások',
        fill_under_run_button_tooltip: "Kitöltési ütemezés a változatok és az alapértelmezett formátum alapján",
        resetautofill_button_tooltip: 'Automatikus kitöltés visszaállítása',
        please_select_amount_error_message: "Kérjük, válassza ki az összeget",
        please_enter_sort_index_error_message: "Kérjük, adja meg a rendezési indexet",
        please_enter_trial_price_error_message: "Kérjük, adja meg a próbaárat",
        please_enter_trial_days_error_message: "Kérjük, adja meg a próbaidőszakot",
        please_select_reminder_error_message: "Kérjük, válasszon emlékeztetőt",
        please_enter_days_before_error_message: 'Kérjük, napokkal korábban adja meg',
        enable_reminder_label: 'Emlékeztető engedélyezése',
        coupon_page_breadcrumb: "Kupon",
        discount_type_label: "Kedvezmény típusa",
        discount_value_label: "Kedvezményérték",
        create_coupon_dialog_header: "Kupon létrehozása",
        please_select_discount_type_error_message: "Kérjük, válassza ki a kedvezmény típusát",
        percent_can_not_be_greater_than_error_message: 'A százalék nem lehet nagyobb 100-nál',
        enable_fixed_trial_label: "Rögzített próbaverzió engedélyezése",
        limited_period_label: 'Korlátozott időszak',
        valid_from_label: 'Érvényes innen',
        valid_to_label: 'Valid to',
        please_select_valid_from_date_error_message: 'Kérjük, válasszon érvényes dátumot',
        please_select_valid_to_date_error_message: 'Kérjük, válasszon érvényességet',
        discount_should_be_greater_then_zero_error_message: 'A kedvezménynek nagyobbnak kell lennie nullánál',
        please_select_valid_date_error_message: 'Kérjük, válasszon érvényes dátumot',
        payment_plan_label: 'Fizetési terv',
        coupon_label: "Kupon",
        add_coupon_tooltip: "Kupon hozzáadása",
        select_coupon_collection: 'Szupon kiválasztása',
        code_column: "Kód",
        discount_type_column: "Kedvezmény típusa",
        discount_value_column: "Kedvezményérték",
        audit_log_menu: "Ellenőrzési napló",
        audit_log_breadcrumb: "Ellenőrzési napló",
        genre_sub_menu_: 'Műfaj',
        media_category_sub_menu: 'Médiakategória',
        genre_page_breadcrumb: "Műfaj",
        media_category_page_breadcrumb: "Médiakategória",
        module_label: 'Modul',
        event_label: 'Esemény',
        please_select_event_error_message: 'Kérjük, válasszon eseményt',
        download_button_tooltip: 'Letöltés',
        date_time_label: 'DateTime',
        megerősítés_password_label: 'Jelszó megerősítése',
        password_do_not_match_error_message: "Nem egyezik a jelszó",
        please_enter_confirm_password_users_error_message: "Kérjük, adja meg a jelszó megerősítését",
        atleast_attach_atleast_one_platform_error_message: "Kérjük, válasszon legalább egy platformot",
        upload_file_button_tooltip: 'Fájl feltöltése',
        role_tab_label: 'Szerep',
        add_channel_button_text: "Csatorna hozzáadása",
        select_channel_collection_header: "Csatorna kiválasztása",
        please_add_atleast_one_channel_users_error_message: "Kérjük, adjon hozzá legalább egy csatornát",
        please_select_order_date_error_message: "Kérjük, válassza ki a rendelés dátumát",
        please_select_period_from_date_error_message: "Kérjük, válasszon időszakot",
        please_select_period_to_date_error_message: "Kérjük, válasszon időtartamot",
        please_select_deal_type_error_message: "Kérjük, válassza ki az ügylet típusát",
        please_select_location_error_message: 'Kérjük, válasszon helyet',
        please_select_product_error_message: "Kérjük, válasszon terméket",
        ott_segment_sub_menu: "Szegmens",
        payment_plan_page_breadcrumb: "Fizetési terv",
        ott_segment_page_breadcrumb: "Szegmens",
        create_segment_dialog_header: "Szegmens létrehozása",
        segment_label: "Szegmens",
        please_select_segment_error_message: "Kérjük, válassza ki a szegmenst",
        monetization_dashboard: 'Bevételszerzés',
        segment_by_subscribe_label: "Szegmentálás előfizető szerint",
        segment_by_product_label: "Termék szerinti szegmentálás",
        products_column: "Termékek",
        total_coupon_column: "Összes kupon",
        total_subscriber_column: "Összes előfizető",
        coupon_name_column: "Kupon neve",
        pgrating_sub_menu: 'PG besorolás',
        pgrating_page_breadcrumb: 'PG Rating',
        open_in_a_new_tab_label: "Megnyitás új lapon",
        column_preference_label: 'Oszloppreferencia',
        parent_label: 'Szülő',
        overrun_underrun_label: 'OverRun & UnderRun',
        copy_count_label: 'Példányszám',
        selected_header_label: 'Kiválasztott fejléc',
        selected_count_label: 'Kiválasztott szám',
        platform_column: 'Platform',
        please_enter_old_password_users_error_message: "Kérjük, adja meg a régi jelszót",
        old_password_does_not_match_error_message: 'A régi jelszó nem egyezik',
        please_enter_new_password_error_message: "Kérjük, írjon be új jelszót",
        megerősítés_password_do_not_match_error_message: 'A jelszó megerősítése, hogy nem egyezik',
        old_password_label: 'Régi jelszó',
        new_password_label: 'Új jelszó',
        account_label: "Fiók",
        change_password_label: 'Jelszó módosítása',
        log_out_label: 'Kijelentkezés',
        media_by_category_menu: "Média kategória szerint",
        movie_label: "Film",
        season_label: 'Szezon',
        view_details_label: "Részletek megtekintése",
        executive_label: 'Vezető',
        subscriber_label: 'Feliratkozó',
        megerősítés_logout_label: 'Kijelentkezés megerősítése',
        are_you_sure_you_want_to_generate_payment: "Biztosan fizetést akar generálni ?",
        yes_label: 'Igen',
        no_label: "Nem",
        megerősítés_delete_label: 'Törlés megerősítése',
        are_you_sure_you_want_to_delete: 'Biztosan törölni akarja ?',
        scheduling_label: 'Ütemezés',
        planning_label: 'Tervezés',
        options_label: 'Opciók',
        un_archive_label: 'Archiválás visszavonása',
        create_from_label: "Létrehozás innen",
        category_label: 'Kategória',
        select_category_label: 'Kategória kiválasztása',
        grid_view_label: "Rács nézet",
        tile_view_label: "Csempe nézet",
        linear_label: 'Lineáris',
        non_linear_label: "Nem lineáris",
        audit_log_label: "Ellenőrzési napló",
        entry_date_and_time_column: "Belépés dátuma, idő",
        event_column: 'Esemény',
        user_column: 'Felhasználó',
        close_button_tooltip: 'Bezárás',
        apply_recursive_button_text_planning: 'Rekurzív alkalmazása',
        history_button_text_planning: "Előzmények",
        open_schedule_button_text_planning: 'Ütemezés megnyitása',
        insert_program_group_label_planning: 'Programcsoport beszúrása',
        export_planner_button_text: 'Exportálási tervező',
        export_epg_button_text: 'Export EPG',
        planning_loaded_label: 'Tervezés betöltve',
        planning_loading_error_label: "Betöltési hiba tervezése",
        error_fetching_planning_data_error_message: 'Hiba a tervezési adatok lekérésekor',
        planning_loading_label: 'Betöltés tervezése',
        create_label: 'Létrehozás',
        success_created_group_label: 'Csoport sikeresen létrehozva!',
        pasted_label: 'Beillesztett',
        items_label: 'elemek',
        last_updated_from_label_msg: 'Utolsó frissítés innen:',
        cant_delete_segment_label_msg: "A szegmens nem törölhető",
        cant_delete_header_label_msg: "A fejléc nem törölhető, a fejléc törlése a jobb gombbal",
        select_item_to_error_message: 'Elem kiválasztása',
        cant_cut_footer_msg_scheduling: 'A lábléc nem vágható ki.',
        cant_delete_multiple_footer_msg_scheduling: 'Több lábléc nem törölhető.',
        cant_delete_multiple_footer_please_select_one_footer_at_a_time_msg_scheduling: 'Több lábléc nem törölhető, kérjük, válasszon egyszerre egy láblécet.',
        no_item_selected_to_copy_msg_scheduling: 'Nincs más elem kiválasztva',
        cant_copy_segment_msg_scheduling: "Nem másolható - SEGMENT",
        Cannot_copy_break_msg_scheduling: 'Nem másolható - Megszakítás',
        cant_copy_header_msg_scheduling: 'Nem másolható - Fejléc',
        deleting_footer_msg_scheduling: 'Lábléc törlése',
        footer_deleted_msg_scheduling: ' lábléc törölve',
        no_footer_to_deleted_error_message: "Nincs törölhető lábléc",
        all_footer_deleted_error_message: 'Minden lábléc törölve',
        there_are_some_at_server_side_please_contact_admin: 'Van néhány a szerver oldalon, kérjük, forduljon a rendszergazdához',
        loading_schedule_please_wait_msg_scheduling: 'Ütemterv betöltése, kérjük, várjon...',
        loading_schedule_completed_msg_scheduling: 'Betöltési ütemterv kész!!',
        please_selct_one_item_msg_scheduling: 'Kérjük, válasszon ki egy elemet',
        no_media_selected_msg_scheduling: "Nincs kiválasztva média",
        deleted_secondary_events_msg_scheduling: "Törölt másodlagos események",
        all_secondary_events_deleted_successfully_msg_scheduling: 'Minden másodlagos esemény sikeresen törölve!!',
        style_sheet_applied_successfully_msg_scheduling: 'Stíluslap sikeresen alkalmazva !!',
        Secondary_event_updated_msg_scheduling: 'Másodlagos esemény frissítve',
        no_secondary_events_error_message: "Nincsenek másodlagos események",
        select_target_item_from_schedule_error_message: 'Célelem kiválasztása az ütemezésből',
        first_cut_or_copy_item_error_message: 'Elem első kivágása vagy másolása.',
        please_select_Item_to_paste_error_message: 'Kérjük, válassza ki a beillesztendő elemet.',
        Please_select_one_Item_where_need_to_paste_error_message: 'Kérjük, válasszon egy elemet, ahová be kell illeszteni.',
        delete_msg: 'delete',
        cut_msg: 'delete',
        cant_segment_please_unselect_segment_error_message: "A szegmens nem törölhető, kérjük, törölje a szegmens kijelölését",
        cant_delete_header_please_unselect_header_error_message: 'A fejléc nem törölhető. Kérjük, törölje a fejléc kijelölését, vagy használja a jobb gombbal a fejléc törlése opciót.',
        Confirmation_label: 'Megerősítés',
        are_you_sure_you_want_to_delete_footer_label: "Biztosan törölni szeretné a láblécet?",
        Are_you_sure_you_want_to_items_label_confirm_alert: "Biztosan akarod",
        cant_select_footer_error_message: 'A lábléc nem választható ki.',
        cant_multi_select_items_from_different_headers_error_message: 'Nem lehet több elemet kiválasztani a különböző fejlécekből.',
        please_select_first_error_message: 'Kérjük, először válasszon.',
        cant_select_items_from_different_headers_error_message: 'Nem lehet elemeket kiválasztani különböző fejlécekből.',
        please_choose_right_media_categor_error_message: "Kérjük, válassza ki a megfelelő médiakategóriát",
        prototype_drop_not_allowed_for_headers_error_message: "A prototípus ledobása nem engedélyezett a fejléceknél",
        break_type_item_is_not_allowed_error_message: 'A törés típusú elem nem engedélyezett.',
        cant_move_segment_to_different_program_schedule_error_message: 'A szegmens nem helyezhető át más programütemezésbe',
        prototype_drop_not_allowed_for_headers_and_footers_error_message: "A prototípus ledobása nem engedélyezett fejlécekhez és láblécekhez",
        please_select_header_firsts_error_message: "Kérjük, először válassza a fejlécet",
        Cannot_delete_selected_header_contains_booked_commercials_error_message: 'Nem lehet törölni!! A kiválasztott fejléc lefoglalt reklámokat tartalmaz',
        cant_delete_selected_header_contains_reconciled_items_error_message: 'Nem lehet törölni!! A kiválasztott fejléc egyeztetett tételeket tartalmaz',
        megerősítés_delete_header_confirm_alert_msg: "A fejléc törlésének megerősítése",
        are_you_sure_you_want_to_delete_confirm_alert_msg: "Biztosan törölni akarja",
        select_one_program_to_replace_with_error_message: 'Válasszon ki egy programot, amellyel lecseréli',
        header_from_confirm_alert_msg: "fejléc innen",
        please_select_schedule_item_error_message: 'Kérjük, válasszon ütemezési tételt',
        not_allowed_on_this_postion_error_message: 'Nem engedélyezett ezen a poszton',
        please_select_one_item_error_message: "Kérjük, válasszon egy elemet",
        no_secondary_events_attached_to_delete_error_message: "Nincs másodlagos esemény csatolva a törléshez",
        prototype_drop_not_allowed_for_break_error_message: "A prototípus ledobása nem engedélyezett a szünetben",
        added_secondary_events_success_message: 'Másodlagos események hozzáadva',
        please_load_schedule_first_error_message: 'Először töltse be az ütemezést.',
        variations_are_not_available_info_message: 'Változatok nem állnak rendelkezésre',
        process_completed_success_message: 'A folyamat befejeződött',
        select_atleast_one_header_error_message: 'Válasszon ki legalább egy fejlécet',
        user_favourite_page_breadcrumb: "Kedvenc",
        please_enter_template_name_to_save_template_error_message: 'Kérjük, adja meg a sablon nevét a sablon mentéséhez',
        rmn_label: 'RMN',
        please_enter_rmn_error_message: "Kérjük, adja meg az RMN-számot",
        expand_collapse_headers_label: "Fejlécek kibontása/összecsukása",
        pages_label: 'Oldalok',
        total_product_column: "Összes termék",
        update_synopsis: 'Frissítési összefoglaló',
        invalid_time_range: 'Érvénytelen időtartomány',
        schedule_automatic_break_tooltip: "Automatikus szünetek létrehozása",
        select_icon_url_collection_header: "Ikon kiválasztása",
        planningdistributionformat_sub_menu: "Elosztási formátum tervezése",
        planningdistributionformat_page_breadcrumb: "Terjesztési formátum tervezése",
        edit_planningdistributionformat_editpage_header: "Tervezési elosztási formátum szerkesztése",
        create_planningdistributionformat_editpage_header: "Tervezési elosztási formátum létrehozása",
        subtitle_label: 'Felirat',
        subtitle_type_labe: 'Felirat típusa',
        please_select_segment_type_error_message: "Kérjük, válassza ki a szegmens típusát",
        audio_track_label: 'Hangsáv',
        track_number_label: 'Track Number',
        add_language_group_prototype_button_tooltip: 'Nyelvcsoport hozzáadása',
        add_language_group_prototype_button_text: 'Nyelvcsoport hozzáadása',
        please_enter_track_number_error_message: "Kérjük, adja meg a szám számát",
        please_select_atleast_one_language_error_message: "Kérjük, válasszon legalább egy nyelvet",
        language_already_added_error_message: 'A nyelv már hozzáadva',
        track_number_already_added_error_message: 'A szám száma már hozzáadva',
        please_select_atleast_one_rule_error_message: "Kérjük, válasszon ki legalább egy szabályt",
        update_template_label: 'Sablon frissítése',
        media_category_type_sub_menu: 'Médiakategória típusa',
        work_order_dashboard: 'WORK ORDER',
        todo_tile_label: "Teendő",
        in_progress_tile_label: 'Folyamatban',
        done_tile_label: "Kész",
        workflow_label: 'Munkafolyamat',
        notes_label: 'Jegyzetek',
        please_select_atleast_one_role_error_message: "Kérjük, válasszon legalább egy szerepet",
        workflow_dialog_header: "Munkafolyamat létrehozása",
        workorder_dialog_header: "Munkarendelés létrehozása",
        roles_label: 'Szerepek',
        workflow_page_breadcrumb: "Munkafolyamat",
        workflow_menu: 'Munkafolyamat',
        current_status_column: 'Jelenlegi állapot',
        Created_date_column: "Létrehozás dátuma",
        please_select_workflow_error_message: 'Kérjük, válasszon munkafolyamatot',
        media_column: 'Média',
        Transmission_label: 'Transmission',
        transmission_column: 'Transmission',
        mamID_label: "Anya azonosító",
        apply_distribution_button_text_planning: 'Elosztási tervezés',
        min_gap_label: 'My Gap',
        apply_fix_gap_label: "Fix Gap alkalmazása",
        plan_till_label: 'Tervezés',
        max_placement_label: "Maximális elhelyezés",
        valid_days_label: 'Érvényes napok',
        retry_gap_label: 'Retry Gap',
        planning_distribution_label: "Elosztás tervezése",
        please_enter_minimum_gap_error_message: "Kérjük, adja meg a minimális rést",
        please_select_plan_till_date_error_message: 'Kérjük, válassza ki a dátumig tartó tervet',
        please_enter_max_placement_error_message: "Kérjük, adja meg a maximális elhelyezést",
        please_select_days_error_message: "Kérjük, válasszon napokat",
        please_enter_retry_gap_error_message: "Kérjük, adja meg az újrapróbálkozási szünetet",
        please_select_starting_role_error_message: 'Kérjük, válassza ki a kezdő szerepet',
        start_role_label: 'Starting Role',
        plan_till_date_cannot_be_less_than_original_planned_item_error_message: "A dátumig tervezett terv nem lehet kevesebb, mint az eredeti tervezett tétel",
        Applying_planning_distribution_template_please_wait_planner_status_message: "A tervezési terjesztési sablon alkalmazása, kérjük, várjon...",
        planning_distribution_template_applied_success_planner_status_message: "Terjesztési terv sablon sikeresen alkalmazva",
        note_for_parent_select_null_label: 'Megjegyzés: a szülőnek válasszon nullát',
        payments_label: 'Kifizetések',
        schedule_autofill_button_tooltip: "Lefoglalt reklám automatikus kitöltése",
        schedule_reset_all_header_to_nominal_start_time_button_tooltip: "Az összes fejléc kezdési időpontjának visszaállítása a tervezett névleges időre",
        work_orders_label: 'WORK ORDERS',
        role_wise_work_orders_label: 'ROLE WISE WORK ORDERS',
        user_wise_work_orders_label: 'USER WISE WORK ORDERS',
        select_media_info_message: 'Select Media',
        history_label: 'HISTORY',
        booking_details_label: 'Foglalási adatok',
        show_jobs_button_text: 'Megjelenítés',
        please_check_label: 'Kérjük, ellenőrizze',
        category_label: 'Kategóriák',
        job_status_label: 'Munka állapota',
        invalid_start_date: 'Érvénytelen kezdő dátum',
        invalid_end_date: 'Érvénytelen befejezési dátum',
        target_budget_should_be_greater_then_zero: "A célköltségvetésnek nagyobbnak kell lennie nullánál",
        target_spots_should_be_greater_then_zero: "A célpontoknak nagyobbnak kell lenniük nullánál",
        target_seconds_should_be_greater_then_zero: "A cél másodpercnek nagyobbnak kell lennie a negatív értéknél",
        please_select_date_format_error_message: "Kérjük, válassza ki a dátumformátumot",
        no_data_schedule_to_save_scheduling_reconciliation_error_message: "Nem található adat ütemezés",
        no_data_asrun_to_save_scheduling_reconciliation_error_message: "Nem található adat AsRun",
        reset_password_label: 'Jelszó visszaállítása',
        date_column_is_not_present_in_this_csv_file_label: 'A dátum oszlop nem található ebben a csv-fájlban',
        time_column_is_not_present_in_this_csv_file_label: 'Az időoszlop nem található ebben a csv-fájlban',
        house_number_column_is_not_present_in_this_csv_file_label: 'A HouseNumber oszlop nem található ebben a csv-fájlban',
        user_favourite_add_button_title: "Kedvencek hozzáadása",
        user_favourite_menu: 'Kedvenc',
        user_favorite_menu_dropdown_label: "Menü",
        user_favorite_menu_text_label: 'Név',
        please_select_user_favourite_menu_error_message: 'Kérjük, válassza ki a menüt',
        please_select_user_favourite_name_error_message: "Kérjük, adja meg a nevet",
        vodtype_label: 'VOD-típusok',
        change_existing_planning_label: "Cserélje ki a meglévő tervezést",
        region_column: 'Régió',
        live_events_menu: "Élő események",
        vodtype: 'VOD Type',
        version_sub_menu: 'Verzió',
        version_page_breadcrumb: 'Verzió',
        spot_can_not_be_negative_error_message: 'A folt nem lehet negatív',
        rate_can_not_be_negative_error_message: 'Az arány nem lehet negatív',
        please_add_booking_first_booking_error_message: "Kérjük, először adjon hozzá foglalást",
        transfer_from_and_transfer_to_are_same_date_error_message: 'Nem vihető át ugyanazon a napon',
        tournament_dialog_header: 'Verseny létrehozása',
        live_match_dialog_header: 'Egyezés létrehozása',
        no_booking_data_error_message: 'Nem található foglalási adat!',
        ott_assets_video: 'Videó',
        ott_assets_poster: 'Poszter',
        update_successfully_booking_success_toast_message: "A foglalás frissítése sikeres",
        please_select_a_value_to_delete_booking_error_message: "Kérjük, válasszon egy értéket a törléshez",
        ott_assets_video_url_error_message: "Kérjük, adja meg az URL-t",
        LiveEventRound_sub_menu: 'Élő esemény forduló',
        LiveEventType_sub_menu: "Élő esemény típusa",
        TournamentType_sub_menu: 'Tournament Type',
        Commission_negative_value_campaign_error_message: "A jutalék nem lehet negatív",
        discount_negative_value_campaign_error_message: "A kedvezmény nem lehet negatív",
        invalid_spots_value_line_no_booking_error_message: "Negatív helyek értéke a sorszámban",
        channels_not_updated_in_booking_error_message: "A csatorna nincs frissítve a sorszámban",
        attach_media_label: 'Média csatolása',
        media_episode_localization: 'Lokalizáció',
        media_episode_id_column: "Médiaepizód azonosítója",
        manage_content_template_sub_menu: "Tartalomsablon kezelése",
        fct_can_not_be_negative_error_message: "Az FCT nem lehet negatív",
        rate_10_sec_can_not_be_negative_error_message: 'A Rate10Sec nem lehet negatív',
        summa_can_not_be_negative_error_message: 'Az összeg nem lehet negatív',
        booked_spots_scheduled_error_message: 'A kiválasztott foglalások egy része már használatban van az ütemezésben.',
        booking_line_no: "Sorszám",
        please_select_import_type_error_message: "Kérjük, válassza az importálás típusát",
        optimisation_sun_menu: 'Optimalizálás',
        optimisation_page_breadcrumb: "Optimalizálás",
        booking_date_label: 'Foglalási dátum',
        agency_name_column: "Ügynökség neve",
        assurance_type_column: 'Assurance Type',
        assured_value_column: "Biztosított érték",
        please_select_booking_date_error_message: "Kérjük, válassza ki a foglalás dátumát",
        optimization_label: 'Optimalizálás',
        please_show_atleast_one_item_error_message: 'Kérjük, mutasson meg legalább egy elemet!',
        please_enter_valid_percentage_error_message: "Kérjük, adjon meg érvényes százalékot",
        campaign_target_seconds_actual_seconds_booking_error: "A cél másodpercek száma nem lehet kevesebb, mint az összes lefoglalt másodperc",
        campaign_target_budget_actual_budget_booking_error: "A célköltségkeret nem lehet kisebb, mint a teljes lefoglalt költségkeret",
        campaign_target_spots_actual_spots_booking_error: "A megcélzott helyek száma nem lehet kevesebb, mint az összes lefoglalt helyek száma",
        assured_value_is_greater_than_total_fct_error_message: "A biztosított érték nagyobb, mint a teljes fct",
        assured_value_is_less_than_zero_error_message: 'A biztosított érték kisebb, mint nulla',
        booking_schedule_status: 'Foglalási ütemterv állapota',
        makegood_column: 'Make Good',
        booked_spots_unique_line_no_selection_error_message: 'Kérjük, válasszon olyan helyeket, amelyeknél ugyanaz a sor nem frissíthető',
        booking_file_import_error_message: 'Nem sikerült beolvasni az adatokat a fájlból. Hiba - ',
        spot_status_column: "Állapot",
        booking_transfer_from_date_greater_than_transfer_to_date_error_message: "Az átvitel dátuma nem lehet nagyobb, mint az átvitel dátuma",
        spot_time_from_time_to_error_message: "Az időtől rövidebbnek kell lennie, mint az időnek",
        material_type_label: 'Anyagtípus',
        cancreatedeal_label: "Üzletet hozhat létre",
        please_enter_material_type_error_message: "Kérjük, adja meg az anyag típusát",
        please_select_media_category_error_message: "Kérjük, válassza ki a média kategóriát",
        automation_type_label: 'Automatizálás típusa',
        download_button_text: 'Letöltés',
        edit_black_out_date_button_tooltip: "Az eltiltás dátumának szerkesztése",
        add_black_out_date_button_tooltip: "Elsötétítési dátum hozzáadása",
        edit_black_out_date_dialog_header: "Edit Black Out",
        add_black_out_date_dialog_header: "Fekete kihagyás hozzáadása",
        black_out_date_dialog_header: 'Black Out Date',
        please_add_atleast_one_black_out_date_error_message: 'Kérjük, adjon meg legalább egy eltüntetési dátumot',
        update_successfully_grid_data_success_toast_message: 'Frissítés sikeresen',
        black_out_channel_column: "Black Out Channel",
        black_out_start_date_column: 'A bezárás kezdő dátuma',
        black_out_end_date_column: 'A bezárás befejezési dátuma',
        black_out_date_should_be_within_publishing_dates_range_error_message: "A letiltás dátumának a közzétételi dátumtartományon belül kell lennie",
        some_bookings_are_out_of_campaign_date_range_could_not_transfer_error_message: "Néhány foglalás kívül esik a kampány dátumtartományán, nem sikerült átvinni",
        report_menu: 'Jelentés',
        interstitial_history_sub_menu: "Közbeiktatott hirdetések előzményei",
        interstitial_history_report_dialog_header: "Közbeiktatott előzmények jelentés",
        client_agency_booking_report_sub_menu: "Ügyfélügynökségi foglalási jelentés",
        first_channel_column: "Elsődleges csatorna",
        order_date_error_message: 'A rendelés dátumának rövidebbnek kell lennie, mint az időszak kezdete',
        please_select_tournament_type: "Kérjük, válassza ki a bajnokság típusát",
        please_enter_tournament_ID: "Kérjük, adja meg a versenyazonosítót",
        tournament_type_label: 'Tournament Type',
        tournament_ID_label: 'Tournament ID',
        as_run_label: 'AsRun',
        schedule_label: 'Ütemezés',
        update_booking_multiple_dialog_header: "Foglalás frissítése",
        commercial_duration_labe: "Időtartam",
        no_as_run_found_error_message: 'Nem található AsRun',
        copy_from_and_copy_to_date_range_should_be_same: "A (Másolás innen) kiválasztott napoknak meg kell egyeznie a (Másolás ide) kiválasztott napokkal.",
        exkluzív_label: 'Exkluzív',
        exkluzív_start_date_column: "Kizárólagos kezdő dátum",
        exkluzív_end_date_column: "Kizárólagos befejező dátum",
        Technical_details_prototype_sub_menu: "Technikai részletek Prototípusok",
        Technical_details_prototype_page_breadcrumb: "Technical Details Prototypes",
        audio_codec_page_breadcrumb: "Audiokodek",
        video_codec_page_breadcrumb: "Videókodek",
        delivery_method_page_breadcrumb: "Kézbesítési mód",
        video_aspect_ratio_page_breadcrumb: "Videó képaránya",
        video_type_page_breadcrumb: "Videótípus",
        audio_codec_sub_menu: 'Audiokodek',
        video_codec_sub_menu: 'Videókodek',
        delivery_method_sub_menu: 'Kézbesítési mód',
        video_aspect_ratio_sub_menu: 'Videó képaránya',
        video_type_sub_menu: 'Videótípus',
        is_exclusive_column: "Kizárólagos",
        ref_off_setting_label: 'Eltolás beállítása',
        offset_time_minus_label: 'Eltolási idő mínusz',
        offset_time_plus_label: 'Offset Time Plus',
        ignore_duration_labe: 'Igonre Duration',
        reference_no_label: 'Hivatkozási szám',
        please_enter_reference_no_error_message: "Kérjük, adja meg a hivatkozási számot",
        create_technical_details_prototype_header_dialog: "Technikai részletek prototípus létrehozása",
        audio_codec_label: 'Audiokodek',
        video_codec_label: 'Videókodek',
        video_aspect_ratio_label: 'Video Aspect Ratio',
        delivery_method_label: 'Szállítási mód',
        is_quality_checked_label: 'A minőség ellenőrizve van',
        enable_caption_label: "Felirat engedélyezése",
        distributer_label: 'Forgalmazó',
        please_select_audio_codec_error_message: 'Kérjük, válasszon audiokodeket',
        please_select_video_codec_error_message: 'Kérjük, válasszon videokodeket',
        please_select_delivery_method_error_message: "Kérjük, válassza ki a kézbesítési módot",
        please_select_video_aspect_ratio_error_message: "Kérjük, válassza ki a videó képarányát",
        please_select_video_type_error_message: "Kérjük, válassza ki a videó típusát",
        offsetsetting_dialog_header: 'Kikapcsolási beállítás',
        please_enter_OffSet_Time_Minus_error_message: "Kérjük, adja meg az OffSet Time Minus értéket",
        please_enter_offSet_time_plus_error_message: "Kérjük, adja meg az OffSet Time Plust",
        booking_schedule_status_sub_menu: "Foglalási ütemterv állapota",
        edit_multiple_tooltip: 'Több szerkesztése',
        select_commercial_error_message: "Kérjük, válassza a Kereskedelmi lehetőséget",
        invalid_spotRate_error_message: 'Kérjük, adja meg az érvényes helyszíni árfolyamot',
        invalid_rate10Sec_error_message: 'Kérjük, adjon meg érvényes sebességet 10 másodpercig',
        please_select_atleast_one_value_to_update_error_message: 'Kérjük, válasszon ki legalább egy értéket a frissítéshez',
        rate_10_sec_column: 'Rate10Sec',
        Missing_media_report_dialog_header: "Hiányzó médiajelentés",
        Missing_media_report_sub_menu: "Hiányzó médiajelentés",
        schedule_date_label: 'Ütemezési dátum',
        please_select_schedule_date_error_message: 'Kérjük, válassza ki az ütemezés dátumát',
        mam_assets_sub_menu: "Mam Assets",
        mamassets_page_breadcrumb: "Mam Assets",
        create_mamasset_dialog_header: "Mam Asset létrehozása",
        please_enter_programeditstatus_error_message: "Kérjük, adja meg a programszerkesztési állapotot",
        end_time_label: 'Vége',
        program_edit_status_label: 'Programszerkesztési állapot',
        tx_ready_label: 'TX kész',
        subtitle_availble_label: 'Felirat elérhető',
        censorship_report_available_label: "Cenzúrajelentés elérhető",
        qcpass_label: 'QC Pass',
        please_enter_valid_end_time_message: "Kérjük, adja meg az érvényes befejezési időt",
        please_enter_valid_actual_duration_message: "Kérjük, adja meg az érvényes tényleges időtartamot",
        time_in_label: 'Beérkező idő',
        time_out_label: 'Time Out',
        commercial_limit_label: "Kereskedelmi korlát",
        please_enter_valid_commercial_limit_error_message: "Kérjük, adja meg az érvényes kereskedelmi korlátot",
        contract_number_column: "Szerződés száma",
        Duration_should_be_greater_than_zero_error_message: "Az időtartamnak nagyobbnak kell lennie nullánál",
        number_of_episode_can_be_greater_than_zero_error_message: "Az epizódok számának nagyobbnak kell lennie nullánál",
        staring_episode_can_be_greater_than_zero_error_message: "A kezdő epizódnak nagyobbnak kell lennie nullánál",
        segment_qc_page_header: "Szegmens minőségellenőrzése",
        segment_qc_button_tooltip: "Segment QC",
        media_title_label: 'Média címe',
        qc_status_label: 'QC állapot',
        frame_rate_label: 'Frame Rate',
        note_label: "Megjegyzés",
        please_select_qc_status_error_message: "Kérjük, válassza ki a QC állapotot",
        please_enter_note_error_message: "Kérem, írja be a megjegyzést",
        please_select_frame_rate_error_message: 'Kérjük, válassza ki a képkockasebességet',
        please_enter_positive_value_in_pin_code_error_message: "Kérem, írjon be pozitív értéket a Pin-kódba",
        please_enter_commission_error_message: "Kérem, adja meg a jutalékot",
        please_enter_discount_error_message: "Kérem, adja meg a kedvezményt",
        please_configure_checklist_preference_error_message: 'Kérjük, állítsa be az ellenőrzőlista beállítást !!',
        preferencia_saved_successfully: 'A beállítás sikeresen mentve!!',
        please_select_csv_file_error_message: 'Kérjük, válasszon csv fájlt!',
        couldn_delete_channel_campaign_already_has_booking_error_message: "Nem lehet törölni a csatornakampányt, amelynek már van foglalása",
        cant_delete_commercial_campaign_already_has_booking_error_message: "Nem törölhető a kereskedelmi kampány, amelynek már van foglalása",
        ref_change_rate10sec_label: 'Változási sebesség 10 mp',
        change_rate10sec_dialog_header: 'Változási sebesség 10 mp',
        change_rate10sec_label: 'Változási sebesség 10 mp',
        import_pdf_file: 'PDF fájl importálása',
        please_select_atleast_one_media_category_type_error_message: "Kérjük, válasszon legalább egy médiakategória-típust",
        please_select_episode_content_error_message: "Kérjük, válassza ki az epizód tartalmát",
        iso_code_label: 'ISO kód',
        google_api_code_label: "Google API kód",
        create_language_dialog_header: 'Nyelv létrehozása',
        please_enter_iso_code_error_message: "Kérjük, adja meg az ISO kódot",
        please_enter_google_api_code_error_message: "Kérjük, adja meg a Google API kódot",
        click_here_to_check_ISO_code_error_message: 'Az ISO-kód ellenőrzéséhez kattintson ide',
        booking_update_successfully: "A foglalás sikeresen frissítve",
        cast_Type_page_breadcrumb: 'Cast típusa',
        cast_Type_sub_menu: 'Cast típusa',
        spots_out_of_campaign_date_range_error_message: 'Van néhány pont a kampány dátumtartományán kívül. Kérem ellenőrizze',
        import_pdf_booking_file: "PDF foglalás importálása",
        import_booking_label: ' Foglalás importálása',
        download_template_label: "Sablon letöltése",
        export_saved_booking_label: "Mentett foglalás exportálása",
        export_current_booking_label: "Aktuális foglalás exportálása",
        planing_is_locked_on_some_days_in_this_date_range: "A tervezés bizonyos napokon zárolva van ebben a dátumtartományban",
        payment_schedule_label: 'Fizetési ütemezés',
        promotional_excerpts_label: "Promóciós kivonatok",
        governing_laws_label: "Irányadó törvények",
        add_linear_page_header: "Lineáris hozzáadása",
        add_linear_button_tooltip: "Lineáris hozzáadása",
        summa_should_be_negative_error_message: 'Az összeg nem lehet negatív',
        currency_column: "Pénznem",
        total_booked_spots_label: "Foglalt helyek",
        total_booked_seconds_label: "Lefoglalt másodpercek",
        total_booked_amount_label: "Lefoglalt összeg",
        booking_exceeded_target_budget: 'Cél költségkeret túllépése, kérjük, frissítse és próbálja újra',
        booking_exceeded_target_seconds: 'Cél költségkeret túllépése, kérjük, frissítse, és próbálja újra',
        booking_exceeded_target_amount: 'Cél költségkeret túllépése, kérjük, frissítse, és próbálja újra',
        broadcaster_id_label: "Műsorszolgáltató azonosítója",
        restriction_label: 'Korlátozás',
        create_restriction_dialog_header: 'Korlátozás létrehozása',
        dynamic_rules_label: "Dinamikus szabályok",
        censorship_details_label: "Cenzúra részletei",
        term_label: 'Feltételek',
        reason_label: 'Reason',
        hold_all_payment_label: "Minden fizetés visszatartása",
        gener_payment_button_text: 'Fizetés generálása',
        contract_payment_schedule_dialog_header: "Szerződéses fizetési ütemezés",
        gener_payment_schedule_dialog_header: 'Fizetési ütemezés generálása',
        due_date_label: 'Esedékesség',
        interest_rate_label: "Kamatláb",
        no_of_installment_label: 'Nem. Részletfizetésből',
        recurring_label: 'Recurring',
        due_date_column: 'Esedékesség',
        due_amount_column: "Esedékes összeg",
        approve_status_column: "Jóváhagyási állapot",
        summa_paid_column: "Kifizetett összeg",
        balance_amount_column: "Egyenlegösszeg",
        please_select_recurring_error_message: "Kérjük, válassza az Ismétlődő lehetőséget",
        interest_rate_should_be_negative_error_message: "A kamatlábnak negatívnak kell lennie",
        no_of_installment_should_be_greater_than_zero_error_message: "A törlesztőrészletek számának nagyobbnak kell lennie nullánál",
        gener_payment_label: 'Fizetés generálása',
        are_you_sure_you_want_to_generate_payment_schedule: "Biztosan újra szeretné generálni a fizetési ütemezést",
        summa_paid_label: "Fizetett összeg",
        approve_status_label: "Jóváhagyási állapot",
        remark_column: 'Megjegyzés',
        edit_contract_title_button_text: "Szerződés címének szerkesztése",
        edit_black_out_date_button_text: "Az eltiltás dátumának szerkesztése",
        delete_contract_title_button_text: "A szerződés címének törlése",
        classification_label: 'Osztályozás',
        cut_tc_in_label: 'Cut Tc In (óó:pp:ss:ff)',
        cut_tc_out_label: "Cut Tc Out (óó:pp:ss:ff)",
        done_date_label: "Kész dátum",
        result_label: 'Eredmény',
        office_label: "Tiszt",
        cut_label: 'Vágás',
        classification_column: 'Osztályozás',
        cut_tc_in_column: 'Cut Tc In',
        cut_tc_out_column: "Cut Tc Out",
        done_date_column: "Kész dátum",
        reference_no_column: 'Hivatkozási szám',
        result_column: 'Eredmény',
        office_column: 'Tiszt',
        cut_column: 'Vágás',
        create_censorship_details_dialog_header: "Cenzúra részleteinek létrehozása",
        please_enter_valid_value_cut_tcin_error_message: "Kérjük, adjon meg érvényes CutTcIn-t",
        can_not_delete_error_message: 'Az irányítópult nem törölhető helyesen',
        add_brand_button_tooltip: "Márka hozzáadása",
        add_product_button_tooltip: "Termék hozzáadása",
        ratecard_page_breadcrumb: "Díjtáblázat",
        ratecard_sun_menu: "Díjtábla",
        create_ratecard_dialog_header: "Kapcsolat létrehozása",
        rate_10sec_label: 'Rate 10 Sec',
        please_enter_time_in_error_message: 'Kérjük, adja meg az időt',
        please_enter_time_out_error_message: "Kérjük, adja meg az időtúllépést",
        view_label: 'Megtekintés',
        other_option_label: 'Egyéb opció',
        prime_time_label: "Főműsoridő",
        no_rights_scheduling_error_message: "Nincs ütemezési jog",
        used_to_configure_prefix_suffix_and_incremental_next_number_for_assetid_tooltip: "Ez az eszközazonosító előtag utótagjának és növekményes következő számának konfigurálására szolgál",
        sales_executive_label: "Értékesítési vezető",
        please_select_sales_executive_error_message: "Kérjük, válasszon értékesítési vezetőt",
        material_content_page_breadcrumb: "Anyagtartalom",
        material_content_sub_menu: 'Anyagtartalom',
        added_by_column: 'Hozzáadta',
        modified_by_column: 'Módosította',
        show_history_button_text: 'Előzmények megjelenítése',
        sėkmingai_download_success_message: 'Sikeres letöltés',
        top_5_sales_executive_label: "Az 5 legjobb értékesítési vezető",
        add_job_url_button_tooltip: "Munka URL hozzáadása",
        checklist_preference_label: 'Checklist Preference',
        select_playback_url_header: 'Lejátszási URL kiválasztása',
        Duration_mismatch_error_message: "Időtartam eltérés",
        no_invoice_details_are_available_to_preview_bill_error_message: "Nincsenek számlaadatok az előnézethez!",
        selected_commercial_label: 'Kiválasztott reklám',
        no_data_schedule_to_download_error_message: "Nincs letölthető adatütemezés",
        from_date_can_not_be_less_than_campaign_start_date_error_message: "A kezdő dátum nem lehet rövidebb, mint a kampány kezdő dátuma",
        to_date_can_not_be_greater_than_campaign_end_date_error_message: "A jelenlegi dátum nem lehet hosszabb, mint a kampány befejezési dátuma",
        cancel_invoice_waiting_message: 'Számla törlése, kérjük, várjon...',
        series_dialog_header: "Sorozat",
        manage_content_template_breadcrumb: "Tartalomsablon kezelése",
        ottmenu_sub_menu: "Menü",
        ottmenu_page_breadcrumb: "Menü",
        cardlist_pages_menu_title: "Oldalok",
        select_pages_header_collection: 'Oldalok',
        ottmenu_title_editpageheader: "Menü",
        sidefixmenu_rails_pages_tooltip: "Oldalok",
        atleast_attach_one_ott_pages_rails_error_message: "Legalább egy oldal csatolása",
        menu_type_label: "Menü típusa",
        team_a_label: "A csapat",
        team_b_label: "B csapat",
        round_label: "Kerek",
        bottom_menu_sub_menu: "Alsó menü",
        bottom_menu_page_breadcrumb: "Alsó menü",
        top_menu_sub_menu: "Felső menü",
        top_menu_page_breadcrumb: "Felső menü",
        please_select_asset_type_to_media_asset_error_message: "Kérjük, válasszon tartalomtípust a médiaeszközhöz",
        multi_versioning_tooltip_button: 'Több verzió',
        title_view_tooltip_button: "Cím nézet",
        close_title_view_tooltip_button: "Címnézet bezárása",
        sidefix_episode_tooltip: 'Epizód',
        please_select_valid_start_date_error_message: 'Kérjük, válasszon érvényes kezdési dátumot',
        please_select_valid_end_date_error_message: "Kérjük, válasszon érvényes befejezési dátumot",
        please_select_exclusive_start_date_error_message: "Kérjük, válassza ki a kizárólagos kezdő dátumot",
        please_select_exclusive_end_date_error_message: "Kérjük, válassza ki a kizárólagos befejezési dátumot",
        please_select_start_date_smaller_than_end_date_media_episode_publishing_error_message: "A kezdő dátumnak rövidebbnek kell lennie, mint a befejezés dátuma",
        summa_paid_can_not_be_negative_error_message: 'A fizetett összeg nem lehet negatív',
        print_button_tooltip: "Nyomtatás",
        print_telecast_certificate_in_pdf_button_tooltip: "Telecast Certificate nyomtatása PDF-ben",
        print_telecast_certificate_in_excel_button_tooltip: "Telecast Certificate nyomtatása Excelben",
        cancel_invoice_button_tooltip: "Számla törlése",
        campagn_type_page_breadcrumb: "Kampánytípus",
        deal_type_page_breadcrumb: "Ügylet típusa",
        location_page_breadcrumb: 'Location',
        campaigntype_sub_menu: "Kampány típusa",
        dealtype_sub_menu: 'Ügylet típusa',
        location_sub_menu: 'Helyszín',
        ott_setting_sub_menu: 'Beállítások',
        ott_setting_page_breadcrumb: "Beállítások",
        application_name_label: 'Alkalmazás neve',
        logo_label: 'Logo',
        logo_position_label: 'Logo Position',
        pi_page_template_label: "PiPage Template",
        show_bottom_menu_label: "Az alsó menü megjelenítése",
        home_page_label: "Kezdőlap",
        show_hamburger_menu_label: "Hamburger menü megjelenítése",
        image_cdn_base_url_label: 'Kép CDN alap URL-címe',
        video_cdn_base_url_label: 'Video CDN alap URL-címe',
        image_cdn_credentials_label: 'Kép CDN CRED',
        video_cdn_credentials_label: 'Video CDN CRED',
        key_name_label: "Kulcs neve",
        key_value_label: "Kulcsérték",
        add_image_cdn_credentials_dialog_header: 'Kép hozzáadása CDN CRED',
        add_video_cdn_credentials_dialog_header: "Videó CDN CRED hozzáadása",
        please_enter_key_name_error_messgae: "Kérjük, adja meg a kulcs nevét",
        please_enter_key_value_error_message: "Kérjük, adja meg a kulcs értékét",
        settings_label: 'Beállítások',
        please_enter_application_name_error_message: "Kérjük, adja meg az alkalmazás nevét",
        please_select_logo_error_message: 'Kérjük, válasszon logót',
        please_select_logo_position_error_message: "Kérjük, válassza ki a logó pozícióját",
        please_select_pi_page_template_error_message: 'Kérjük, válasszon PiPage sablont',
        please_select_home_page_error_message: "Kérjük, válassza ki a kezdőlapot",
        please_select_theme_error_message: 'Kérjük, válasszon témát',
        please_enter_image_cdn_base_url_error_message: "Kérjük, adja meg a kép CDN alap URL-jét",
        please_enter_video_cdn_base_url_error_message: "Kérjük, adja meg a Video CDN alap URL-címét",
        icon_label: "Ikon",
        please_select_icon_error_message: 'Kérjük, válasszon ikont',
        please_select_hamburger_menu_error_message: "Kérjük, válassza ki a hamburger menüt",
        hamburger_menu_label: "Hamburger menü",
        select_package_header: 'Csomag kiválasztása',
        please_select_package_error_message: 'Kérjük, válasszon csomagot',
        vod_type_validation_error_message: `A VOD típus INGYENES csak AVOD esetén alkalmazható`,
        server_health_sub_menu: 'Szerver állapota',
        server_health_page_breadcrumb: "Szerver állapota",
        text_number_can_not_be_negative_error_message: 'A szöveg száma nem lehet negatív',
        prelog_postlog_report_sub_menu: 'naplózás előtti/utáni jelentés',
        pre_log_report_title_button: "Prelog Report",
        post_log_report_title_button: 'Postlog Report',
        download_pre_log_report_tooltip_button: 'Prelog jelentés letöltése',
        download_post_log_report_tooltip_button: "Postlog Report letöltése",
        credit_line_report_sub_menu: "Hitelkeret jelentés",
        download_credit_line_report_tooltip_button: "Hitelkeret-jelentés letöltése",
        please_select_date_error_message: "Kérjük, válassza ki a dátumot",
        logo_size_label: 'Logo Size',
        application_color_label: 'Alkalmazás színe',
        purge_Spot_report_sub_menu: 'Purge Spot Report',
        download_purge_Spot_report_tooltip_button: "Tisztítási helyszín jelentés letöltése",
        download_client_agency_booking_report_tooltip_button: "Ügyfélügynökségi foglalási jelentés letöltése",
        download_purge_spot_report_tooltip_button: "Tisztítási helyszín jelentés letöltése",
        client_agency_booking_report_header: "Ügyfélügynökségi foglalási jelentés",
        pre_post_log_report_header: "Napló előtti/utáni jelentés",
        credit_line_report_header: "Hitelkeret jelentés",
        purge_spot_report_header: "Purge Spot Report",
        interstitial_history_report_header: "Közbeiktatott előzmények jelentés",
        download_interstitial_history_report_tooltip_button: "A közbeiktatott hirdetések előzményeinek jelentésének letöltése",
        telecast_certificate_details_not_found_error_message: "A televíziós adás részletei nem találhatók",
        air_time_consumption_report_sub_menu: "Levegőidő-felhasználási jelentés",
        download_air_time_consumption_report_tooltip_button: "Levegőidő-felhasználási jelentés letöltése",
        air_time_consumption_report_header: 'Műsoridő-felhasználási jelentés',
        prototypecontent_sub_menu: "Prototípus tartalom",
        prototypecontent_page_breadcrumb: "Prototype Content",
        create_prototypecontent_dialog_header: "Prototípus tartalom létrehozása",
        please_enter_max_length_error_message: "Kérjük, adja meg a maximális hosszt",
        manual_prototype_id_label: 'Kézi azonosító',
        prototype_id_label: 'ID',
        error_while_generating_prototype_number_error_message: "Hiba a prototípusszám generálása közben",
        refresh_generated_segments_tooltip: "Generált szegmensek frissítése",
        generated_segments_selected_segmentType_mismatch_error_message: "A generált szegmensek száma nem egyezik meg a kiválasztott szegmenstípussal",
        materialID_mediaID_mismatch_generated_segment_error_message: 'Az anyagazonosító nem egyezik meg a generált szegmens MediaID-jével ,Kérjük, frissítsen',
        please_select_subtitle_type_error_message: "Kérjük, válassza ki a felirat típusát",
        number_of_generated_segments_is_not_same_as_selected_segment_Type_error_message: "A generált szegmensek száma nem egyezik meg a kiválasztott szegmenstípussal",
        select_material_content_first_error_message: 'Először válassza ki az anyagtartalmat',
        segment_already_exist_with_same_material_id_and_segment_type_error_message: 'A szegmens már létezik azonos anyagazonosítóval és szegmenstípussal',
        amazon_delivery_group_page_breadcrumb: "Amazon Delivery Group",
        amazon_delivery_group_sub_menu: "Amazon Delivery Group",
        amazon_delivery_group_edit_page_header: "Amazon Delivery Group",
        tv_preview_label: "TV előnézet",
        mobile_preview_label: "Mobil előnézet",
        ditribute_by_percentage_label: 'Elosztás % szerint',
        ditribute_by_percentage_error_message: 'A kiválasztott kereskedelmi terjesztés százalékos összegének 100-nak kell lennie',
        select_commercial_for_booking_error_message: "Kérjük, válasszon legalább egy reklámot a lefoglaláshoz",
        Distribut_selected_equal_lable: 'Kiválasztottak egyenlő elosztása',
        feature_label: 'Jellemzők',
        select_secondary_event_error_message: 'Először válassza ki a másodlagos eseményt',
        delete_secondary_event_tooltip: 'Kiválasztott másodlagos esemény törlése',
        select_campaign_header_dialog: "Kampány kiválasztása",
        select_pages_header_dialog: "Oldalok kiválasztása",
        display_name_column: 'Megjelenítési név',
        spot_separation_label: 'Spot elválasztás',
        please_enter_valid_spot_separation_error_message: "Kérjük, adja meg az érvényes helyelválasztást",
        ott_package_delivery_schedule_menu: "Ott csomagszállítási ütemterv",
        service_menu: 'Szolgáltatás',
        ott_package_delivery_schedule_page_breadcrumb: "Ott csomagkézbesítési ütemterv",
        schedule_delivery_button_tooltip: 'Kézbesítés ütemezése',
        schedule_delivery_button_text: 'Kézbesítés ütemezése',
        schedule_delivered_successfully_success_message: 'Sikeres kézbesítés ütemezése',
        schedule_auto_fill_interstitial_page_breadcrumb: "Közbeiktatott hirdetés automatikus kitöltésének ütemezése",
        schedule_auto_fill_interstitial_sub_menu: "Közbeiktatott hirdetés automatikus kitöltésének ütemezése",
        schedule_auto_fill_interstitial_edit_page_header: "Közbeiktatott hirdetés automatikus kitöltésének ütemezése",
        interstitial_label: "Közbeiktatott",
        filler_label: "Fillers",
        music_label: 'Zene',
        new_subscriber_in_week_label: "Új előfizetők a héten",
        no_pack_users_label: "Nincsenek csomagfelhasználók",
        users_subscription_expiring_in_current_week_label: 'Lejáró felhasználó a héten',
        user_by_plan_label: 'Felhasználó terv szerint',
        media_asset_label: 'Médiaeszköz',
        vod_label: 'VOD',
        dummy_page_breadcrumb: "Dummy",
        dummy_sub_menu: 'Dummy',
        ref_attach_formats_label: "Formátum csatolása",
        format_attached_success_message: 'Formátum csatolva sikeresen',
        ref_delete_formats_label: "Minden formátum törlése",
        formats_deleted_success_message: "Minden formátum törlése sikeresen",
        ad_tag_label: "Hirdetéscímke",
        insert_break_label: "Szünet beszúrása",
        slot_duration_label: 'Slot Duration',
        please_enter_slot_duration_error: 'Kérjük, adja meg a slot időtartamát',
        fact_duration_slot_duration_format_error_message: "A tényleges időtartam nem lehet hosszabb, mint a Slot Duration",
        total_amount_is_smaller_than_amount_paid_error_message: 'A teljes összeg kisebb, mint a kifizetett összeg',
        is_dummy_label: "IsDummy",
        downloading_log_report_label: 'Naplójelentés letöltése',
        bill_generate_label: "Számla generálása",
        contract_run_report_button_tooltip: "Szerződés végrehajtási jelentés",
        contract_run_report_label: 'Szerződés végrehajtási jelentés',
        total_run_column: 'Total Run',
        preview_button_tooltip: "Előnézet",
        preview_image_title_label: "Kép előnézete",
        poster_dimension_title_label: 'Poszter dimenzió',
        show_poster_dimension_title_label: "Poszterek dimenzió megjelenítése",
        mam_asset_report_sub_menu: "Mam eszközjelentés",
        mam_asset_report_page_breadcrumb: "Mam Asset Report",
        schedule_duration_column: "Ütemezés időtartama",
        mam_duration_column: "Mam Duration",
        total_column: "Összesen",
        schudule_column: 'Ütemezés',
        pending_colun: 'Függőben',
        holnap_pending_booking_status_label: "Holnap függőben lévő foglalási állapot",
        pending_approval_sun_menu: "Jóváhagyásra vár",
        pending_approval_page_breadcrumb: "Jóváhagyásra vár",
        approve_button_text: 'Jóváhagy',
        reject_button_text: 'Elutasítás',
        booking_status_updated_successfully: "A foglalás állapota sikeresen frissítve",
        total_segment_duration_lable: "A szegmens teljes időtartama",
        other_label: "Egyéb",
        comment_label: 'Megjegyzés',
        please_enter_comment_error_message: 'Kérjük, írjon be megjegyzést',
        unpurged_label: 'Unpurged',
        please_add_deeplink_in_video_list_error_message: "Kérjük, adjon hozzá mélylinket a videólistához",
        please_attach_atleast_one_video_error_message: "Kérjük, csatoljon legalább egy videót",
        please_attach_atleast_one_poster_error_message: "Kérjük, csatoljon legalább egy plakátot",
        deeplink_url_label: "Mélylink URL",
        rental_wholesale_price_label: "Bérleti nagykereskedelmi ár",
        rental_retail_price_label: "Bérleti kiskereskedelmi ár",
        fact_on_air_column: "Actual On Air",
        nominal_on_air_column: "Nominal On Air",
        parent_series_code_label: "Szülősorozat kódja",
        series_code_label: "Sorozat kód",
        Duration_only_label: "Időtartam",
        reference_code_label: 'Referencia kód',
        material_type_column: 'Anyagtípus',
        break_configuration_page_breadcrumb: "Konfiguráció megszakítása",
        break_configuration_sub_menu: "Konfiguráció megszakítása",
        create_break_configuration_dialog_header: "Szünetbeállítás létrehozása",
        please_select_atleast_one_allow_media_category_type_error_message: 'Kérjük, válasszon legalább egy engedélyező médiakategória-típust',
        please_select_atleast_one_day_error_message: "Kérjük, válasszon legalább egy napot",
        please_enter_from_time_label: "Kérjük, lépjen be az időponttól",
        please_enter_to_time_label: "Kérjük, adja meg az időt",
        fct_should_be_greater_than_zero_error_message: "Az FCT-nek nagyobbnak kell lennie nullánál",
        from_time_should_be_less_than_To_time_error_message: 'Az időtől kevesebbnek kell lennie, mint az időig',
        to_date_should_be_greater_than_from_date_error_message: "A dátumnak nagyobbnak kell lennie, mint a Kezdő dátumnak",
        fct_already_exists_error_message: "Az FCT már létezik ugyanabban a csatornában/időtartományban/napokban",
        fct_should_not_be_greater_than_campaign_target_seconds_error_message: "Az FCT nem lehet nagyobb, mint a kampány cél másodpercei",
        sort_by_label: 'Rendezés',
        billing_summary_report_sub_menu: "Számlázási összesítő jelentés",
        no_scheduling_found_auto_fill_commercial_error: 'Nem található ütemezés',
        no_break_item_found_auto_fill_commercial_error: "E napra nincsenek beütemezve törési tételek",
        no_booked_spot_found_auto_fill_commercial_error: "A lefoglalt helyek nem állnak rendelkezésre",
        save_bill_button_text: "Számla mentése",
        save_bill_button_tooltip: "Számla mentése",
        preview_button_text: 'Előnézet',
        parent_series_labe: 'Szülő sorozat',
        ott_setting_label: 'OTT BEÁLLÍTÁS',
        bottom_menu_label: "Alsó menü",
        series_only_label: 'sorozat',
        add_insert_break_label: 'Insert Break hozzáadása',
        playlist_lock_status_sub_menu: 'Lejátszási lista zárolási állapota',
        playlist_lock_page_breadcrumb: "Lejátszási lista zárolási állapota",
        gener_pdf_message: 'Kérjük, várjon Pdf generálásával...',
        gener_pdf_successfully_message: 'Pdf generálása sikeresen',
        payment_received_label: 'Befizetés megérkezett',
        payment_received_button_tooltip: 'Befizetés megérkezett',
        payment_received_button_text: 'Befizetés érkezett',
        print_button_text: 'Nyomtatás',
        to_txt_button_toolip: "TXT-hez",
        to_txt_button_text: 'TXT-hez',
        pdf_button_text: 'PDF',
        excel_button_text: 'Excel',
        Received_date_label: 'Átvétel dátuma',
        payment_mode_label: 'Fizetési mód',
        check_no_label: 'Csekk sz.',
        payment_received_successfully: 'A fizetés sikeresen megérkezett',
        is_paymnet_received_column: 'Beérkezett a fizetés',
        payment_received_date_column: 'A fizetés beérkezésének dátuma',
        payment_mode_column: "Fizetési mód",
        cheque_no_column: "Csekk száma",
        payment_already_received_error_message: 'A fizetés már megérkezett',
        please_select_received_date_error_message: "Kérjük, válassza ki a beérkezés dátumát",
        please_select_payment_mode_error_message: "Kérjük, válassza ki a fizetési módot",
        please_enter_cheque_no_error_message: 'Kérem írja be a csekk számát',
        booked_commercial_label: "Lefoglalt reklám",
        booked_announcement_label: "Lefoglalt hirdetmény",
        közlemény_label: 'Hirdetések',
        export_commercial_break_playlist_button_tooltip: "Export Commercial Break Playlist",
        credit_line_report_page_breadcrumb: "Hitelkeret-jelentés",
        brand_column: "Márka",
        time_range_column: "Időtartomány",
        schedule_spot_column: 'Ütemezési pont',
        total_duration_column: "Teljes időtartam",
        booking_schedule_status_header: "Foglalási ütemterv állapota",
        no_data_found_for_selected_filter_error_message: "Nem található adat a kiválasztott szűrőkhöz!",
        artist_label: "Művész",
        please_enter_artist_error_message: "Kérjük, adja meg az előadó nevét",
        bejelentés_reconcile_sun_menu: 'Hirdetések egyeztetése',
        bejelentés_reconcile_page_breadcrumb: "Announcement Reconcile",
        edit_header_dialog: 'Szerkesztés',
        fact_on_air_label: "ActualOnAir",
        reconciled_successfully_message: 'Sikeres egyeztetés',
        reconcile_label: 'Reconcile',
        please_enter_actualonair_error_message: "Kérjük, írja be az ActualOnAirt",
        please_select_atleast_one_saleteam_error_message: "Kérjük, válasszon legalább egy értékesítési csapatot",
        export_announcement_tooltip: 'Hirdetmény exportálása',
        export_jazzler_automation_playlist: "Export Jazzler Commercial Break",
        point_of_contact_label: 'Kapcsolattartási pont',
        please_enter_point_of_contact_error_message: "Kérjük, adja meg a kapcsolattartót",
        please_enter_pin_code_error_message: "Kérjük, adja meg a PIN-kódot",
        epg_menu: 'EPG',
        epg_channel_sub_menu: 'Csatornák',
        epg_channel_page_breadcrumb: "Csatornák",
        create_channel_dialog_header: "Csatorna létrehozása",
        please_enter_image_url_error_message: "Kérjük, adja meg a kép URL-jét",
        faq_category_page_breadcrumb: "GYIK kategória",
        faq_category_sub_menu: "GYIK kategória",
        faq_page_breadcrumb: "GYIK",
        faq_sub_menu: 'Faq',
        please_select_faq_Category_error_message: 'Kérjük, válasszon kategóriát',
        faq_category_label: 'GYIK kategória',
        question_label: 'Kérdés',
        answer_label: 'Válasz',
        please_enter_question_error_message: "Kérjük, írja be a kérdést",
        please_enter_answer_error_message: 'Kérem írja be a választ',
        select_a_category_column: 'Válasszon kategóriát',
        faqs_column: 'GYIK',
        faqs_dailog_header: 'GYIK',
        faqs_page_breadcrumb: 'GYIK',
        top_news_menu: "Legnépszerűbb hírek",
        top_news_page_breadcrumb: "Legnépszerűbb hírek",
        favorite_channel_sub_menu: 'Kedvenc csatorna',
        favorite_channel_page_breadcrumb: "Kedvenc csatorna",
        create_favorite_channel_dialog_header: 'Kedvenc csatorna létrehozása',
        logo_column: 'Logo',
        please_select_atleast_one_channel_error_message: "Kérjük, válasszon legalább egy csatornát",
        tutorial_videos_page_breadcrumb: "Oktatóvideók",
        tutorial_videos_sub_menu: "Oktatóvideók",
        summary_label: 'Összegzés',
        playback_url_label: 'Lejátszási URL',
        create_tutorial_videos_dialog_header: "Oktatóvideók létrehozása",
        please_enter_summary_error_message: "Kérjük, adja meg az összegzést",
        please_enter_playback_url_error_message: "Kérjük, adja meg a PlaybackUrl-t",
        create_top_news_dialog_header: "Legjobb hírek létrehozása",
        source_id_label: 'Forrásazonosító',
        featured_image_url_label: "Kiemelt kép URL-je",
        image_caption_label: 'Képfelirat',
        time_stamp_label: 'Időbélyeg',
        pull_latest_top_news_button_tooltip: "Legutóbbi legfrissebb hírek lehívása",
        thumbnail_url_label: "Indexkép URL",
        please_enter_thumbnail_url_error_message: "Kérjük, adja meg a miniatűr URL-t",
        please_enter_source_id_error_message: "Kérjük, adja meg a forrásazonosítót",
        please_enter_image_caption_error_message: "Kérjük, írja be a képaláírást",
        header_address_label: 'Fejléc címe',
        footer_address_label: "Lábléc címe",
        ok_label: 'OK',
        session_expired_please_login_again_label: 'A munkamenet lejárt. Kérem jelentkezzen be újra',
        please_select_episodes_first: "Kérjük, először válassza ki az epizódokat",
        sėkmingai_saved_updated_message: 'Sikeresen mentve/frissítve !!!',
        please_select_all_platforms_message: "Kérjük, válassza ki az összes platformot a pozíció megváltoztatásához",
        please_book_spots_within_campaign_date_message: "Kérjük, foglaljon helyet a kampány dátumtartományán belül: ",
        invalid_file_format: "Érvénytelen fájlformátum",
        import_already_in_progress: 'Az importálás már folyamatban van. Folyamat megszakítva',
        invalid_template_file: 'Érvénytelen sablonfájl !!',
        date_time_houseNumber_column_is_mandatory: "A dátum, idő és házszám oszlop kötelező az importfájlban",
        commercial_used_in_booking_cannot_change_duration_message: 'A foglaláshoz használt reklám nem módosíthatja az időtartamot !!',
        please_enter_team: "Kérjük, adja meg a csapatot",
        please_select_round_error: 'Kérjük, válasszon kört',
        please_select_start_date_between_tournament_date_range_error: "Kérjük, válassza ki a kezdő dátumot a verseny dátumtartománya között",
        match_scheduled_successfully_message: 'A mérkőzés sikeresen ütemezve !!',
        some_spots_are_reconciled_bill_generated_selected_spots: "Egyes spotok egyeztetve vannak, vagy számlát generáltak a kiválasztott helyeken",
        media_master_report_sub_menu: 'Média főjelentés',
        media_master_report_page_breadcrumb: "Média főjelentés",
        video_column: 'Videó',
        product_column: "Termék",
        data_load_successfully_message: 'Az adatok sikeresen betöltve',
        please_enter_address_error_message: "Kérem, adja meg a címet",
        target_seconds_should_be_greater_then_zero_error_message: "A cél másodpercnek nullánál nagyobbnak kell lennie",
        Missing_seasone_detail_form_error_message: "Hiányzó szezonrészlet",
        ott_menu: 'OTT',
        manage_content_menu: 'Tartalom kezelése',
        to_do_column: "Teendő",
        in_progress_column: 'Folyamatban',
        done_column: 'Kész',
        work_order_button_tooltip: "Munkarendelés",
        show_spots_button_tooltip: 'Szpotok megjelenítése',
        show_spots_button_text: 'Spotok megjelenítése',
        save_and_create_work_order_button_tooltip: "Munkarendelések mentése és létrehozása",
        save_and_create_work_order_button_text: 'Save WO',
        planning_prime_time_sub_menu: 'Prime Time tervezése',
        breaks_label: 'Szünetek',
        add_line_button_tooltip: "Sor hozzáadása",
        add_line_button_text: 'Sor hozzáadása',
        perday_label: 'Per Day',
        perweek_label: 'Hetente',
        trp_label: 'TRP',
        booking_yearly_sub_menu: 'Éves foglalás',
        booking_yearly_page_breadcrumb: 'Éves foglalás',
        days_of_week_column: "A hét napjai",
        edit_multiple_button_text: 'Több szerkesztése',
        delete_multiple_button_tooltip: 'Több törlése',
        delete_multiple_button_text: 'Több törlése',
        közlemények_label: 'Hirdetések',
        record_commercial_label: 'Recorded Commercial',
        read_outs_column: 'Kiolvasások',
        scripts_column: "Szkriptek",
        booking_status_column: "Foglalás állapota",
        asset_id_column: "Eszközazonosító",
        delete_strand_label: "Szín törlése",
        delete_strand_items_confirm_message: "Színelemek törlése",
        press_yes_to_delete_all_the_strand_from_the_selected_slot_onwards_confirm_message: 'Nyomja meg a YES billentyűt az összes szál törléséhez a kiválasztott slottól kezdve',
        show_media_label: 'Média megjelenítése',
        lock_unlock_label: 'Zár / Unlock',
        show_exhibitions_label: "Kiállítások bemutatása",
        expand_all_breaks_label: "Az összes törés kibontása",
        mnimize_all_breaks_label: "Minimize All Breaks",
        please_select_atleast_one_days_error_message: "Kérjük, válasszon legalább egy napot",
        session_time_out_label: 'Session Time Out',
        please_enter_session_time_out_error_message: "Kérjük, adja meg a munkamenet időkorlátját",
        session_time_out_should_be_greater_than_one_hour_error_message: "A munkamenet időtúllépésének nagyobbnak kell lennie egy óránál",
        non_reconciled_spot_column: "Nem egyeztetett helyek",
        time_in_should_be_less_than_time_out_error_message: "A beérkezési időnek kisebbnek kell lennie, mint az időkorlát",
        promotional_screens_sub_menu: "Promóciós képernyők",
        promotional_screens_page_breadcrumb: "Promóciós képernyők",
        marketing_screens_sub_menu: "Marketing képernyők",
        marketing_screens_page_breadcrumb: "Marketingképernyők",
        Frequency_type_label: 'Frekvencia típusa',
        Frequency_label: 'Frekvencia',
        enable_label: 'Engedélyezés',
        marketing_screens_editpageheader: "Marketingképernyők",
        promotional_screens_editpageheader: "Promóciós képernyők",
        Frequency_should_be_greater_than_zero_error_message: "A frekvenciának nagyobbnak kell lennie nullánál",
        verbiage_key_label: "Igazság",
        access_level_label: 'Hozzáférési szint',
        ottcampaign_label: "Ott-kampány",
        ott_campaign_dialog_header: "Kampány",
        success_add_campaign_message: "Kampány sikeres hozzáadása",
        rail_is_already_attach_in_selected_campaign_info_message: "A vasút már csatolva van a kiválasztott kampányban",
        deattach_ott_campaign_dialog_header: "Kampány eltávolítása",
        deattach_successfully_message: 'Sikeres leválasztás',
        megerősítés_deattach_label: 'Leválasztás megerősítése',
        are_you_sure_do_you_want_to_deattach_campaign_label: "Biztosan le szeretné választani a kampányt",
        ott_camapign_status_label: "Kampány állapota",
        expire_label: 'Lejárt',
        rails_dialog_header: "Sínek",
        please_select_provider_error_message: "Kérjük, válassza ki a Szolgáltatót",
        are_you_sure_do_you_want_to_deattach_rail_label: 'Biztosan le akarja választani a sínt',
        rail_is_already_attach_in_selected_page_info_message: "A vasút már csatolva van a kiválasztott oldalon",
        sėkmingai_add_rails_message: 'Sínek hozzáadása sikeresen',
        provider_sub_menu: 'Szolgáltató',
        provider_page_breadcrumb: "Szállító",
        logourl_label: 'Logo URL',
        please_enter_logourl_error_message: "Kérjük, adja meg a LogoURL-t",
        please_select_at_least_one_product_error_message: "Kérjük, válasszon legalább egy terméket",
        products_label: 'Termékek',
        active_ottcampaign_label: "Aktív kampány",
        total_active_subscriber_label: "Összes aktív előfizető",
        preview_menu: 'Előnézet',
        module_sub_menu: 'Modul',
        module_page_breadcrumb: 'Modul',
        path_label: 'Path',
        create_module_header_dialog: 'Modul létrehozása',
        select_product_header_dialog: "Termék kiválasztása",
        success_add_product_succes_message: "Sikeres termék hozzáadása",
        campaign_prefix_label: "Kampány előtag",
        please_enter_campaign_prefix_error_message: "Kérjük, adja meg a kampány előtagját",
        please_enter_valid_release_year_error_message: 'Kérjük, adja meg az érvényes kiadási évet !',
        traffic_sub_menu: 'Forgalom',
        adSales_sub_menu: "Ad-Sales",
        curate_sub_menu: 'Curate',
        monetize_sub_menu: 'Bevételszerzés',
        sms_sub_menu: 'SMS',
        couponing_sub_menu: 'Kuponozás',
        print_pdf_button_tooltip: 'PDF nyomtatása',
        please_enter_code: 'Kérem, adja meg a kódot',
        external_description_label: "Külső leírás",
        alternate_description_label: "Alternatív leírás",
        please_select_access_level_error_message: "Kérjük, válassza ki a hozzáférési szintet",
        company_setting_label: "Vállalati beállítás",
        invoice_label: 'Számla',
        success_saved_message: 'Sikeresen mentve',
        export_edi_format_label: "EDI formátum exportálása",
        do_you_want_print_campaign_billing_lines_label: "Szeretné nyomtatni a kampány számlázási sorait?",
        cancel_invoice_label: "Számla törlése",
        do_you_want_cancel_this_invoice_label: 'Szeretné törölni ezt a számlát?',
        please_wait_cancel_invoice_message: "Kérjük, várjon, törölje a számlát...",
        please_select_menu_type_error_message: "Kérjük, válassza ki a menü típusát",
        is_parent_menu_label: "Szülő menüelem",
        submenu_label: 'Almenü',
        please_select_sub_menu_error_message: "Kérjük, válassza ki az almenüt",
        warning_label: 'Figyelmeztetés',
        user_channel_warning_message: 'A felhasználóhoz nincsenek csatornajogok. Akarod folytatni?',
        Financial_year_page_breadcrumb: "Pénzügyi év",
        sales_target_page_breadcrumb: "Értékesítési cél",
        Financial_year_dialog_header: "Pénzügyi év létrehozása",
        sales_target_dialog_header: "Értékesítési cél létrehozása",
        Financial_year_sub_menu: 'Pénzügyi év',
        sales_target_sub_menu: "Értékesítési cél",
        Financial_year_label: "Pénzügyi év",
        Quarter_label: 'Negyed',
        target_label: 'Cél',
        please_select_financial_year_error_message: "Kérjük, válassza ki a pénzügyi évet",
        please_enter_target_error_message: 'Kérjük, adja meg a célt',
        please_select_quarter_error_message: 'Kérjük, válassza ki a negyedévet',
        please_update_target_details_error_message: "Kérjük, frissítse a célpont adatait",
        please_update_target_wrong_distribution_error_message: "A célnak egyenlőnek kell lennie az elosztott célokkal",
        target_details_label: 'Célrészletek',
        sales_target_achived_label: "Értékesítési vezetők célja / cél elérve",
        total_target_label: 'Total Target :',
        Distributed_target_label: 'Elosztott cél:',
        please_enter_assetid_error_message: "Kérjük, adja meg az eszközazonosítót",
        end_time_should_be_greater_than_start_time_error_message: "A befejezési időpontnak nagyobbnak kell lennie, mint a kezdési időpont",
        please_select_vod_type_validation_error_message: 'Kérjük, válasszon VOD típust',
        sum_of_percentages_should_be_100_error_message: "A százalékok összegének 100-nak kell lennie",
        campaign_actionbutton_option: "Kampányok",
        upcoming_label: 'Közelgő',
        select_ott_assets_header_dialog: 'Válasszon OTT-eszközöket',
        ott_assets_label: "Ott Asset",
        fast_segmentation_actionbutton_menutext: "Gyors szegmentálás",
        is_negative_asrun_diff_label: "Negatív Asrun Diff",
        ott_enabled_label: 'Ott Enabled',
        create_provider_dialog_header: 'Szolgáltató létrehozása',
        insert_dummy_label_planning: 'Insert Dummy',
        please_enter_duration: "Kérjük, adja meg az időtartamokat",
        sum_of_entered_duration_should_be_less_then_or_equal_to_media_duration: "A megadott időtartamok összegének kisebbnek vagy egyenlőnek kell lennie, mint a média időtartama",
        please_select_area_on_planner_to_insert_dummy_planning_performance_error_message: 'Kérjük, válassza ki a területet a tervezőn a dummy beszúrásához.',
        insert_dummy_dialog_title: 'Insert Dummy',
        edit_dummy_actionbutton_menutext: 'Dummy szerkesztése',
        upload_fail_error_message: 'Feltöltés sikertelen',
        change_actionbutton_menutext: 'Csere',
        media_not_valid_for_selected_channel_error_message: "A média nem érvényes a kiválasztott csatornához",
        change_media_lost_error_message: 'Replacement Media Lost.',
        are_you_sure_you_want_to_logout: 'Biztosan ki akar jelentkezni?',
        translate_dialog_header: "Fordítás",
        text_area_label: "Szövegterület",
        translate_button_name: 'Fordítás',
        Missing_google_api_code_error_message: "Hiányzó Google API-kód",
        please_enter_text_area_first_error_message: "Kérem, először írja be a szöveges területet",
        please_translate_first_error_message: "Kérjük, először fordítsa le",
        megerősítés_saved_label: 'Mentés megerősítése',
        changes_you_made_may_not_be_saved_label: 'Az Ön által végrehajtott módosításokat nem lehet elmenteni.',
        sign_in_label: "Bejelentkezés",
        username_login_label: 'UserName',
        password_login_label: 'Jelszó',
        please_enter_user_name_login_label: "Kérjük, adja meg a felhasználónevet",
        enter_your_password_login_label: 'Adja meg jelszavát',
        login_lable: 'Bejelentkezés',
        material_id_and_media_id_mismatch_please_re_generate_segments_first_error_message: 'Az anyagazonosító és a médiaazonosító nem egyezik, először generálja újra a szegmenseket!',
        please_enter_material_id_error_message: "Kérjük, adja meg az anyagazonosítót",
        poster_note_image_size_label: 'Megjegyzés: A kép mérete kisebb, mint 1 MB',
        entry_already_exists_in_system_for_same_prefix_and_suffix_error_message: 'Már létezik bejegyzés a rendszerben ugyanarra az előtagra.',
        loop_till_selected_end_date: 'Megjegyzés: Jelölje be, hogy ismételje meg a kiválasztott befejezési dátumig',
        please_select_material_content_error_message: 'Kérjük, válasszon anyagtartalmat',
        document_page_breadcrumb: "Dokumentum",
        document_sub_menu: 'Dokumentum',
        document_type_label: 'Dokumentum típusa',
        please_select_document_type_error_message: "Kérjük, válassza ki a dokumentum típusát",
        please_enter_doc_error_message: 'Kérem írja be a dokumentumot',
        create_Document_dialog_header: 'Dokumentum létrehozása',
        upload_documents_label: 'Dokumentum feltöltése',
        doc_label: 'Doc',
        please_upload_documents_error_message: "Kérjük, töltsön fel dokumentumokat",
        delete_selected_label: 'Kijelöltek törlése',
        delete_slot_and_push_forward_in_the_strand_label: 'Slot törlése és előretolás a szálban',
        delete_slot_and_pull_backward_in_the_strand_label: "Epizód törlése és hátrahúzás a szálban",
        delete_all_the_events_forward_in_the_strand_label: 'Az összes esemény törlése továbbítja a szálban',
        delete_episode_in_future_from_selected_slot_forward_label: 'Epizód jövőbeli törlése a kiválasztott helyről előre',
        to_enable_other_options_select_only_one_item_label: 'Más opciók engedélyezéséhez csak egy elemet válasszon ki.',
        selected_item_should_be_episode_planning_item_error_message: 'A rekurzív csak az epizódmédia-kategóriához használható.',
        selected_item_already_part_of_another_strand_error_message: 'A kiválasztott elem egy másik szál része',
        select_documents_header_dialog: "Dokumentumok kiválasztása",
        bevétel_részesedés_label: 'Bevételrészesedés',
        bevétel_share_should_be_negative_error_message: "A bevételrészesedésnek negatívnak kell lennie",
        bevétel_részesedés_oszlop: 'Bevételrészesedés',
        screen_saver_page_breadcrumb: "Képernyőkímélő",
        screen_saver_sub_menu: 'Képernyőkímélő',
        screen_saver_editpageheader: "Képernyőkímélő",
        old_value_label: 'Régi érték',
        new_value_label: 'Új érték',
        show_changes_label: 'Változások megjelenítése',
        planning_slot_sub_menu: 'Slot tervezés',
        planning_slot_page_breadcrumb: "Tervezési hely",
        timerangefrom_should_be_greater_then_zero: "A TimeRangeFrom értéknek nagyobbnak kell lennie nullánál",
        timerangefrom_should_be_less_then_timerangeto: "A TimeRangeFromnak kisebbnek kell lennie, mint a TimeRangeTo",
        timerangeTo_should_be_greater_then_zero: "A TimeRangeTo nagyobbnak kell lennie nullánál",
        show_details_column: "Részletek megjelenítése",
        show_all_label: 'Összes megjelenítése',
        isImportable_label: 'Importálható',
        invalid_file_error_message: 'Érvénytelen kiválasztott fájl',
        enable_filter_label: "Szűrő engedélyezése",
        rails_label: 'Sínek',
        promotional_page_page_breadcrumb: "Promóciós oldal",
        promotional_page_sub_menu: "Promóciós oldal",
        slug_label: 'Slug',
        thumb_img_label: 'Indexkép',
        ban_img_label: "Szalaghirdetés képe",
        app_img_label: "Alkalmazás képe",
        tags_label: "Címkék",
        show_buy_button_label: "Vásárlás gomb megjelenítése",
        show_in_app_label: "Megjelenítés az alkalmazásban",
        please_enter_slug_error_message: "Kérjük, adja meg Slug",
        promotional_page_editpageheader: "Promóciós oldal",
        comma_seprated_value_should_be_enter_label: "A vesszővel elválasztott értéket be kell írni",
        please_enter_next_number_error_message: "A következő számnak nagyobbnak kell lennie 0-nál",
        please_enter_number_length_error_message: "A szám hosszának nagyobbnak kell lennie 0-nál",
        gener_button_tooltip: 'TC letöltése Excelben',
        gener_xml_message: 'Kérjük, várjon az Excel generálásával...',
        create_new_button_label: 'Új létrehozása',
        rating_label: 'Értékelés',
        please_enter_rating_error_message: "Kérjük, adja meg az értékelést 1 és 10 között",
        sponsor_type_page_breadcrumb: "Szponzor típusa",
        sponsor_type_sub_menu: 'Szponzor típusa',
        note_for_sponsor_type_select_null_label: "Megjegyzés: az értékelésnek 1 és 10 között kell lennie",
        please_enter_sponsor_type_error_message: "Kérjük, adja meg a szponzor típusát",
        sponsor_type_label: "Szponzor típusa",
        please_enter_currency_error_message: 'Kérjük, válassza ki a pénznemet',
        default_currency_label: 'Alapértelmezett pénznem',
        web_assets_sub_menu: 'Web Assets',
        web_assets_page_breadcrumb: "Web Assets",
        web_assets_page_editpageheader: "Web Assets",
        web_assets_label: 'Web Assets',
        logs_label: 'naplók',
        enable_audit_log_label: "Ellenőrzési napló engedélyezése",
        please_select_web_assets_error_message: "Kérjük, válasszon webes eszközöket",
        select_web_assets_dialog_header: 'Webeszközök kiválasztása',
        select_media_dialog_header: 'Select Media',
        create_new_button_tooltip: 'Új létrehozása',
        create_new_button_text: 'Új létrehozása',
        select_rule_label: 'Szűrő kiválasztása',
        from_date_should_be_less_then_to_date_error_message: "A dátumtól kevesebbnek kell lennie, mint a dátumig",
        show_repeat_pattern_detail_tooltip: "Az ismétlési minta részletének megjelenítése",
        please_select_repeat_pattern_error_message: "Kérjük, először válassza a minta ismétlését",
        account_name_label: "Fiók neve",
        bank_name_label: "Bank neve",
        account_number_label: 'Számlaszám',
        swift_code_label: "Swift kód",
        iban_number_label: "Iban-szám",
        branch_label: 'Branch',
        bank_details_label: "Banki adatok",
        hero_banner_mobile_label: "Hero Banner Mobile",
        hero_banner_tv_label: 'Hero Banner TV',
        square_label: 'négyzet',
        circle_label: "Kör",
        landscape_label: "Tájkép",
        partner_ingestion_media_deal_right_confirmation_message: "Biztosan ügyleti jogok nélkül kíván médiát importálni?",
        no_internet_connection_please_check_your_connection_and_try_again_label: 'Nincs internetkapcsolat. Kérjük, ellenőrizze a kapcsolatot, és próbálja újra.',
        there_is_no_product_assigned_to_your_company_kindly_contact_team_BMS_label: 'Nincs termék hozzárendelve az Ön cégéhez. Lépjen kapcsolatba a BMS csapattal',
        you_dont_have_any_module_access_please_contact_your_admin_label: "Nincs hozzáférése a modulokhoz. Kérjük, forduljon a rendszergazdához.",
        show_break_only_label: "Csak a szünet megjelenítése",
        locked_by_label: 'Lezárva',
        auto_plot_interstitial_label: "Automatikus nyomtatás közbeiktatott hirdetés",
        show_logs_label: "Naplók megjelenítése",
        default_label: 'Alapértelmezett',
        from_default_label: 'Alapértelmezettről',
        update_successfully_label: 'Frissítés sikeresen',
        show_provider_label: 'Show Provider',
        show_censor_rating_label: "Cenzor minősítés megjelenítése",
        show_episode_no_label: 'Show Episode No',
        pi_page_setting_sub_menu: 'Pi oldalbeállítás',
        pi_page_setting_page_breadcrumb: "Pi oldalbeállítás",
        pi_label: 'PI BEÁLLÍTÁS',
        seo_label: 'SEO BEÁLLÍTÁS',
        meta_tag_label: "Meta címke",
        meta_robot_label: 'Meta Robot',
        meta_googlebot_label: 'Meta Googlebot',
        pi_page_setting_page_editpageheader: 'Pi oldalbeállítás',
        show_description_label: 'Leírás megjelenítése',
        show_synopsis_label: "Show Synopsis Label",
        show_production_year_label: "A műsor gyártási éve",
        show_pg_rating_label: 'PG értékelés megjelenítése',
        show_cast_and_crew_label: "Show szereplők és stáb",
        show_language_label: 'Nyelv megjelenítése',
        show_genre_label: 'Műfaj megjelenítése',
        show_season_no_label: "Show Season No.",
        meta_title_label: 'Meta cím',
        meta_description_label: "Meta leírás",
        select_Field_tooltip: 'Select Field',
        screenshot_label: 'Screenshot',
        theme_sub_menu: "Téma",
        theme_page_breadcrumb: "Téma",
        cta_details_label: "CTA",
        general_details_label: "Általános",
        tray_glow_details_label: "Tray Glow",
        player_details_label: 'Játékos',
        theme_setting_dialog_header: "Téma beállítása",
        deal_rights_give_automatically_for_all_channels_label: "Az üzletjogok automatikusan minden csatornára érvényesek",
        add_channel_rights_button_tooltip: "Csatornajogok hozzáadása",
        you_are_not_authorized_to_edit_this_channel_error_message: "Nincs jogosultságod a csatorna módosítására",
        permalink_structure_label: 'Permalink Structure',
        plain_label: "Sima",
        numeric_label: "Numeric",
        post_name_label: "Bejegyzés neve",
        excrate_label: "Átváltási árfolyam",
        note_enter_exchange_rate_equal_to_usd_label: 'Megjegyzés: Adja meg az árfolyamot, amely megegyezik az USD-vel',
        excrate_should_not_be_negative_error_message: "Az árfolyam nem lehet negatív",
        you_delete_this_deal_right_right_from_parent_series_only_media_episode_publishing_error_message: "Ezt az ügyletet közvetlenül a szülősorozatból törli...",
        you_delete_this_deal_right_right_from_series_only_media_episode_publishing_error_message: "Ezt az ügyletet közvetlenül a sorozatból törli...",
        agency_type_sub_menu: "Ügynökség típusa",
        agency_type_label: "Ügynökség típusa",
        you_are_not_authorized_to_edit_please_go_to_parent_series_error_message: 'Nem jogosult szerkeszteni. Kérjük, lépjen a szülősorozathoz',
        you_are_not_authorized_to_edit_please_go_to_series_error_message: 'Nem jogosult szerkeszteni. Kérlek menj a sorozathoz',
        create_group_header_dialog: 'Csoport létrehozása',
        episode_group_page_breadcrumb: "Epizódcsoport",
        delete_media_episode_button_tooltip: "Médiaepizód törlése",
        rail_title_details_label: "Sín cím",
        menu_details_label: "Menü",
        segment_by_rc_label: 'Szegmentálás RC szerint',
        reference_code_column: 'Referencia kód',
        two_epiosde_per_day_label: "Két epizód/nap",
        open_theme_new_tab_label: "Téma megnyitása új lapon",
        refresh_theme_label: 'Téma frissítése',
        update_slot_duration_label: "Slot időtartamának frissítése",
        Duration_updated_success_message: "Az időtartam sikeresen frissítve",
        please_select_duration_error_message: "Kérjük, válassza ki az időtartamot",
        limited_genre_label: 'Korlátozott műfaj',
        application_configuration_menu: 'Alkalmazás konfigurációja',
        application_configuration_breadcrumb: "Alkalmazás konfigurációja",
        please_select_genre_error_message: "Kérjük, válasszon műfajt",
        font_size_should_be_greater_than_zero_error_message: "A betűméretnek nullánál nagyobbnak kell lennie",
        data_already_exist_error_message: 'Az adatok már léteznek',
        you_can_not_delete_in_edit_mode_error_message: "Szerkesztési módban nem törölhető",
        please_add_atleast_one_genre_value_error_message: "Kérjük, adjon meg legalább egy műfaji értéket",
        invalid_short_forms: 'Érvénytelen rövid űrlapok',
        invalid_tooltip: 'Érvénytelen',
        save_draft_button_tooltip: "Vázlat mentése",
        save_draft_button_title: "Vázlat mentése",
        publish_button_text: 'Közzététel',
        program_group_is_mandatory_when_applying_recursive_on_movie_error_message: "Kérjük, válassza ki a Programcsoportot a rekurzív filmre/programra való alkalmazásához",
        trigger_start_time_label: 'Trigger kezdési ideje',
        trigger_end_time_label: "Trigger befejezési ideje",
        please_select_all_data_while_importing_playlist: "Kérjük, válassza ki az összes adatot a lejátszási lista importálása közben",
        all_days_can_not_be_excluded_error_message: 'Nem zárható ki minden nap',
        dont_show_this_message_again: "Ne mutasd újra ezt az üzenetet",
        media_episode_group_grid_note: 'Megjegyzés: Rekurzív alkalmazásakor a sorrend megegyezik a fenti rács sorozatával',
        please_wait_export_report_message: 'Kérjük, várjon a jelentés exportálásával...',
        segment_can_not_be_variation_error_message: "A szegmens nem állítható be változatként",
        can_edit_duration_of_segment_error_message: "Csak a szegmens időtartama szerkeszthető",
        jobs_schedule_sub_menu: 'Munkaütemezés',
        jobs_schedule_page_breadcrumb: 'Munkaütemezés',
        enable_error_log_lebel: 'Hibanapló engedélyezése',
        hourly_button_tooltip: "Óránként",
        hourly_button_title: "Óránként",
        daily_button_tooltip: 'Napi',
        daily_button_title: "Napi",
        weekly_button_tooltip: 'Hetente',
        weekly_button_title: 'Hetente',
        monthly_button_tooltip: 'Havi',
        monthly_button_title: "Havi",
        yearly_button_tooltip: 'Évente',
        yearly_button_title: 'Évente',
        quick_schedule_lebel: 'Gyors ütemezés',
        create_jobs_schedule_dialog_header: "Munkaütemezés létrehozása",
        invalid_input_only_number_and_star_are_allow_error_message: 'Érvénytelen bevitel. Csak a számok és a * megengedettek',
        please_enter_command_error_message: "Kérem írja be a parancsot",
        can_not_greater_than_error_message: 'nem lehet nagyobb, mint',
        variance_sub_menu: "Szórás",
        variance_label: "Szórás",
        tc_in_without_timecode_label: 'Tc In',
        tc_out_without_timecode_label: 'Tc Out',
        Duration_without_timecode_label: "Időtartam",
        minute_label: 'Perc (0-59)',
        hour_label: 'Óra (0-23)',
        day_Of_month_label: 'Day (1-31)',
        week_label: 'Hét (1-7)',
        month_label: 'Hónap (1-12)',
        can_not_less_than_error_message: 'nem lehet kevesebb, mint',
        archived_column: 'Archivált',
        archived_label: 'Archivált',
        please_upload_doc_error_message: "Kérjük, töltse fel a dokumentumot",
        variation_type_column: "Változat típusa",
        create_variance_dialog_header: "Szórás létrehozása",
        global_search_bar_placeholder: 'Alkalmazások, tartalmak és egyebek keresése. ( Ctrl + / )',
        note_variance_link_from_interstitial_edit_form_label: "Megjegyzés: A közbeiktatott hirdetést ehhez az eltéréshez a közbeiktatott hirdetés szerkesztési űrlapjáról kapcsolhatja össze",
        duplicate_item_selected_error_message: 'Duplikált elem kiválasztva',
        please_select_same_media_category_media_only_global_replacement_error: "Kérjük, csak azonos médiakategóriájú médiát válasszon",
        restore_schedule_draft_validation_error_message: "Az aktuális dátumra és az aktuális dátum előtti napokra vonatkozó ütemezési vázlat nem állítható vissza",
        schedule_draft_3_month_auto_delete_note: '*Megjegyzés: A 3 hónapnál régebbi piszkozatokat a rendszer automatikusan eldobja. Mentse el a piszkozatot fájlba, ha hosszabb ideig szeretné megőrizni',
        delete_planning_log_message: 'A kijelölt tervezési tétel törlése',
        edited_using_form_log_message: 'Űrlap segítségével szerkesztve',
        add_new_planning_item_log_message: 'Új tervezési elem hozzáadása',
        edited_using_drag_drop_messgae: "Drag and drop segítségével szerkesztve",
        planning_logs_dialog_header: "Tervezési naplók",
        slot_column: 'Slot',
        Missing_slot_time_for_error_message: 'Hiányzó hely a következőhöz: -',
        slot_label: 'Slot',
        edit_slot_dialog_header: "Slot szerkesztése",
        attach_media_label: "MÉDIA",
        time_bound_label: 'Time Bound',
        live_events_label: "Élő események",
        tournament_label: 'Tournament',
        create_event_button_tooltip: 'Esemény létrehozása',
        create_event_button_text: 'Esemény létrehozása',
        match_label: 'Match',
        venue_label: 'Helyszín',
        poster_url_label: "Poszter URL",
        please_select_tournament_error_message: 'Kérjük, válasszon versenyt',
        publish_match_header_dialog: 'Egyezés közzététele',
        un_publish_match_label: 'Egyezés közzétételének visszavonása',
        publish_match_label: 'Egyezés közzététele',
        selected_days_label: 'Kiválasztott napok',
        copy_transfer_schedule_header_dialog: 'Másolás/átviteli ütemterv',
        Created_date_label: 'Létrehozás dátuma',
        States_sub_menu: 'Országok',
        States_page_breadcrumb: "Országok",
        pincode_sub_menu: 'Pincode',
        pincode_page_breadcrumb: 'Pincode',
        states_sub_menu: 'Államok',
        states_page_breadcrumb: "Államok",
        pincodes_label: 'Pincodes',
        states_label: 'Államok',
        States_label: 'Országok',
        show_media_button_tooltip: "Média megjelenítése",
        show_media_button_text: 'Média megjelenítése',
        create_genre_button_text: 'Műfaj létrehozása',
        time_zone_page_breadcrumb: "Időzóna",
        time_zone_sub_menu: 'Időzóna',
        is_negative_offset_default_label: 'IsNegative Offset',
        offset_label: "Eltolás (óó:pp:mm)",
        please_enter_valid_start_time_message: "Kérjük, adjon meg érvényes kezdési időt",
        time_zone_label: 'Időzóna',
        date_time_column: 'Dátum, idő',
        time_zone_column: 'Time Zone',
        insert_live_event_actionbutton_menutext: 'Élő esemény beszúrása',
        insert_live_event_actionbutton_menutext_tooltip: 'Élő esemény beszúrása',
        virtual_segmentation_actionbutton_menutext: "Virtuális szegmentálás",
        virtual_segmentation_actionbutton_menutext_tooltip: "Virtuális szegmentáció",
        edit_actionbutton_menutext_tooltip: "Szerkesztés",
        select_all_Header_actionbutton_menutext_tooltip: 'Minden fejléc kijelölése',
        delete_header_actionbutton_menutext_tooltip: "Fejléc törlése",
        insert_break_actionbutton_menutext_tooltip: "Szünet beszúrása",
        program_replacement_actionbutton_menutext_tooltip: 'Programcsere',
        expand_all_breaks_actionbutton_menutext_tooltip: "Az összes szünet kibontása",
        mnimize_all_breaks_actionbutton_menutext_tooltip: "Minimize All Breaks",
        attach_format_reload_actionbutton_menutext_tooltip: "Formátum csatolása",
        fast_segmentation_actionbutton_menutext_tooltip: "Gyors szegmentálás",
        remove_filter_actionbutton_menutext_tooltip: "Szűrő eltávolítása",
        filter_actionbutton_menutext_tooltip: "Szűrő",
        revert_virtual_segmentation_actionbutton_menutext: "Virtuális szegmens visszaállítása",
        revert_virtual_segmentation_actionbutton_menutext_tooltip: "Virtuális szegmens visszaállítása",
        copy_actionbutton_menutext_tooltip: 'Másolás',
        cut_actionbutton_menutext_tooltip: 'Vágás',
        paste_actionbutton_menutext_tooltip: "Beillesztés",
        delete_actionbutton_menutext_tooltip: 'Törlés',
        se_overview_actionbutton_menutext_tooltip: "SE áttekintése",
        global_replacement_actionbutton_menutext_tooltip: "Globális csere",
        delete_secondary_events_actionbutton_menutext: "Másodlagos események törlése",
        delete_secondary_events_actionbutton_menutext_tooltip: "Másodlagos események törlése",
        internal_drag_live_event_error_message: 'Az élő esemény nem módosítható. Kérjük, törölje és tegye közzé újra !!',
        search_name_label: 'Keresési név',
        imdb_details_label: 'IMDb Részletek',
        year_column: 'Év',
        imdb_id_column: 'IMDb ID',
        poster_column: 'Poszter',
        imdb_label: 'IMDb',
        actor_label: 'Színész',
        rated_label: 'Rated',
        country_label: "Ország",
        director_label: 'Rendező',
        writer_label: 'író',
        awards_label: 'Díjak',
        dvd_label: 'DVD',
        imdb_votes_label: 'IMDb szavazatok',
        imdb_id_label: 'IMDb azonosító',
        production_label: 'Produkció',
        website_label: 'Webhely',
        box_office_label: "Box Office",
        meta_score_label: 'Meta Score',
        release_label: 'Release',
        please_enter_search_name_error_message: "Kérjük, adja meg a keresési nevet",
        rails_type_details_dialog_header: "Sínek típusának részletei",
        no_image_found_error_message: 'Nem található kép',
        please_select_item_first_error_message: 'Kérjük, először válassza ki a tételt!',
        update_imdb_label: 'IMDb frissítése',
        subscription_label: 'Előfizetés',
        bevétel_label: "Bevétel",
        total_subscriber_label: "Összes előfizető",
        new_subscriber_label: 'Új előfizetők',
        total_deactive_subscriber_label: "Deaktív előfizetők",
        total_activation_label: 'Összes aktiválás',
        expiring_users_label: "Lejáró előfizetők",
        bevétel_by_month_label: "Hónapos bevétel",
        bevétel_by_platform_label: "Bevétel platformonként",
        bevétel_by_payment_gateway_label: "Bevétel fizetési átjáró szerint",
        bevétel_by_currency_label: "Bevétel pénznem szerint",
        customers_registration_count_graph: "Feliratkozók regisztrációs száma hónapok szerint",
        customers_registration_platform_wise: "Subscribers Registration Platform Wise",
        Buys_by_payment_gateway: "Purchases by Payment Gateway",
        subscriber_by_platform: 'Subscriber By Platform',
        maximum_devices_label: "Eszközök maximális száma",
        please_select_platform_type_error_msg: "Kérjük, válasszon platformot",
        maximun_device_should_not_be_less_than_one: "Az eszközök maximális száma nem lehet kevesebb 1-nél",
        region_details_monetization_dashboard_label: "A REGION TERMÉKEI, KUPONJAI ÉS ELŐFIZETŐI",
        subscribers_by_plan_label: "Feliratkozók terv szerint",
        show_provider_icon_label: "Show Provider Icon",
        subscriber_subscription_history: "Feliratkozási előzmények",
        provider_label: 'Szállító',
        auto_renew_subscription_label: "Auto Renew Pack",
        subscriber_login_history: "Bejelentkezési előzmények",
        create_payment_provider_dialog_header: "Fizetési szolgáltató létrehozása",
        currency_code_label: 'Pénznem kód',
        branding_name_label: "Márkanév",
        branding_logo_label: "Branding Logo",
        branding_color_label: "Branding Color",
        message_label: 'Üzenet',
        sand_box_key_id_label: "Sandbox Key ID",
        sand_box_secret_key_label: "Sandbox titkos kulcs",
        live_key_id_label: "Élő kulcsazonosító",
        live_secret_key_label: "Élő titkos kulcs",
        success_url_label: 'Sikeres URL',
        fail_url_label: "Hiba URL",
        please_enter_live_key_id_error_message: "Kérjük, adja meg az élő kulcs azonosítóját",
        please_enter_live_secret_key_error_message: "Kérjük, adja meg az élő titkos kulcsot",
        please_enter_key_id_error_message: "Kérjük, adja meg a kulcsazonosítót",
        please_enter_secret_key_error_message: "Kérjük, adja meg a titkos kulcsot",
        please_enter_currency_code_error_message: "Kérjük, adja meg a pénznemkódot",
        please_enter_branding_name_error_message: "Kérjük, adja meg a márkanevet",
        please_enter_branding_logo_error_message: "Kérjük, adja meg a márka logóját",
        please_enter_success_url_error_message: "Kérjük, adja meg a siker URL-címét",
        please_enter_failure_url_error_message: "Kérjük, adja meg a hiba URL-jét",
        locale_label: 'Locale',
        payment_gateway_url_label: "Fizetési átjáró URL-je",
        please_enter_payment_gateway_url_error_message: "Kérjük, adja meg a fizetési átjáró URL-jét",
        some_attached_rails_are_full_page_type_and_can_be_attached_independently_only_error_message: "Néhány csatolt sín teljes oldal típusú, és csak egymástól függetlenül csatlakoztatható",
        session_terminated_label: 'Munkamenet befejezve',
        your_session_has_been_terminated_label: 'A munkamenete megszakadt',
        next_publish_date_label: "Következő közzétételi dátum",
        create_tournament_type_dialog_header: "Versenytípus létrehozása",
        create_live_event_type_dialog_header: "Élő eseménytípus létrehozása",
        please_select_house_number_error_message: "Kérjük, válassza ki a házszámot",
        sėkmingai_exported_success_message: 'Sikeresen exportálva',
        please_enter_cast_and_crew_error_message: "Adja meg az előadót a Meta Data Cast and Crew-ban",
        music_category_sub_menu: 'Zene kategória',
        music_category_page_breadcrumb: "Zene kategória",
        create_music_category_dialog_header: "Zene kategória létrehozása",
        is_music_label: 'A zene',
        select_music_category_dialog_header: 'Zene kategória kiválasztása',
        music_category_label: 'Zene kategória',
        available_music_dialog_header: 'Elérhető zenék',
        please_select_music_category_error_message: 'Kérjük, válasszon zenei kategóriát',
        music_menu: 'Zene',
        more_button_tooltip: "Tovább",
        more_button_text: 'Tovább',
        text_color_label: "Szöveg színe",
        program_time_consumption_report_sub_menu: 'Program időfelhasználási jelentés',
        program_time_consumption_report_page_breadcrumb: "Program időfelhasználási jelentés",
        music_report_sub_menu: 'Zenei jelentés',
        music_report_page_breadcrumb: "Zenei jelentés",
        total_runs_column: 'Total Runs',
        total_run_time_column: "Teljes futási idő",
        translate_synopsis_level: 'Szinopszis fordítása',
        tx_mode_sub_menu: 'Tx mód',
        tx_mode_page_breadcrumb: "Tx mód",
        series_library_label: 'Series Library',
        digital_sign_menu: "Digitális jel",
        model_sub_menu: 'Modell',
        model_page_breadcrumb: "Model",
        dimensions_label: 'Méretek',
        model_number_label: "Modellszám",
        resolution_label: 'Felbontás',
        display_shape_label: 'Megjelenítési alak',
        brightness_label: 'Fényerő',
        display_size_label: "Kijelző mérete",
        mounting_type_label: 'Rögzítési típus',
        create_model_dialog_header: 'Modell létrehozása',
        display_shape_sub_menu: 'Megjelenítési forma',
        display_shape_page_breadcrumb: "Display Shape",
        resolution_sub_menu: 'Felbontás',
        resolution_page_breadcrumb: "Felbontás",
        please_select_brand_error_message: "Kérjük, válasszon márkát",
        please_enter_screen_dimensions_error_message: "Kérjük, adja meg a képernyő méreteit",
        please_enter_model_number_error_message: "Kérjük, adja meg a modellszámot",
        please_enter_mounting_type_error_message: "Kérjük, adja meg a rögzítési típust",
        please_select_module_resolution_error_message: 'Kérjük, válassza ki a modulfeloldást',
        please_select_display_shape_error_message: "Kérjük, válassza ki a megjelenítési formát",
        please_enter_brightness_error_message: "Kérjük, adja meg a fényerőt",
        please_enter_display_size_error_message: "Kérjük, adja meg a kijelző méretét",
        digital_sign_brand_sub_menu: "Márka",
        digital_sign_brand_page_breadcrumb: "Digital Sign Brand",
        create_node_dialog_header: 'Csomópont létrehozása',
        parent_node_label: "Szülőcsomópont",
        digital_sign_node_page_breadcrumb: "Digital Sign Node",
        node_sub_menu: "Csomópont",
        add_sign_board_button_tooltip: "Címbeadás hozzáadása",
        digital_sign_board_page_breadcrumb: "Digitális tábla",
        digital_sign_board_sub_menu: 'tábla',
        model_label: 'Model',
        node_label: "Csomópont",
        warranty_start_date_label: 'A garancia kezdő dátuma',
        warranty_End_date_label: 'A garancia befejezési dátuma',
        sign_board_id_label: 'Sign Board ID',
        model_column: 'Model',
        sign_board_id_column: "Jelzőtábla azonosítója",
        warranty_date_column: 'Garancia dátuma',
        delete_sign_board_button_tooltip: "Címtábla törlése",
        date_wise_sheet_label: 'Dátum Wise Sheet',
        tx_status_sub_menu: 'Tx állapot',
        tx_status_page_breadcrumb: "Tx állapot",
        update_txstatus_actionbutton_menutext: 'TX állapot frissítése',
        add_comment_actionbutton_menutext: 'Megjegyzések hozzáadása',
        update_comment_actionbutton_menutext: 'Megjegyzés frissítése',
        tx_status_label: "TX állapot",
        digital_sign_model_page_breadcrumb: "Digitális jelmodell",
        please_select_resolution_error_message: 'Kérjük, válasszon megoldást',
        please_enter_dimensions_error_message: "Kérjük, adja meg a méreteket",
        digital_sign_board_label: "Digitális tábla",
        warranty_end_date_label: 'A garancia lejárati dátuma',
        create_board_dialog_header: "Tábla létrehozása",
        please_select_model_error_message: 'Kérjük, válasszon modellt',
        please_enter_sign_board_id_error_message: "Kérjük, adja meg a tábla azonosítóját",
        create_resolution_dialog_header: 'Felbontás létrehozása',
        length_label: 'Length',
        please_enter_length_error_message: "A hossznak nagyobbnak kell lennie 0-nál",
        please_width_length_error_message: "A szélességnek 0-nál nagyobbnak kell lennie",
        megerősítés_delete_all_label: "Az összes törlésének megerősítése",
        are_you_sure_do_you_want_to_delete_all_label: "Biztosan törölni akarja az összeset",
        serial_number_label: "Sorozatszám",
        please_enter_serial_number_error_message: "Kérjük, adja meg a sorozatszámot",
        aspect_ratio_label: 'Képarány',
        width_should_be_greater_than_zero_error_message: "A szélességnek nullánál nagyobbnak kell lennie",
        height_should_be_greater_than_zero_error_message: "A magasságnak nagyobbnak kell lennie nullánál",
        playlist_sub_menu: 'Lejátszási lista',
        playlist_page_breadcrumb: 'Lejátszási lista',
        nodes_lable: "Csomópontok",
        digital_sign_overlay_label: "Fedvény",
        can_not_add_same_parent_node_error_message: "Nem lehet hozzáadni ugyanazt a szülőcsomópontot",
        publish_selected_match_label: 'Kiválasztott egyezés közzététele',
        select_another_parent_node_error_message: 'válasszon másik szülőcsomópontot',
        digital_sign_overlay_page_breadcrumb: "Digital Sign Overlay",
        overlay_page_breadcrumb: "Fedvény",
        digital_sign_overlay_sub_menu: "Fedvény",
        digital_sign_board_overlay_editpage_header: "Board Overlay",
        shape_label: "Shape",
        position_label: 'Pozíció',
        text_label: "Szöveg",
        font_weights_label: "Font Weight",
        font_color_label: "Betűszín",
        please_enter_shape_error_message: "Kérjük, adja meg az alakzatot",
        font_family_label: "Betűtípuscsalád",
        overlay_type_label: "Fedvénytípus",
        font_size_label: "Betűméret",
        border_radius_label: "Határsugár",
        opacity_label: 'Opacity',
        text_marquee_label: "Szövegkijelölő",
        opacity_note: 'Megjegyzés: az átlátszatlanságnak 0 és 1 között kell lennie',
        margin_lrtb_text_label: "Szövegmargó",
        width_percentage_should_be_greater_than_zero_and_less_than_hundred_error_message: "A szélesség százalékának 0-nál nagyobbnak és 100-nál kisebbnek kell lennie",
        height_percentage_should_be_greater_than_zero_and_less_than_hundred_error_message: "A magasság százalékának 0-nál nagyobbnak és 100-nál kisebbnek kell lennie",
        asset_bundle_sub_menu: "Asset Bundle",
        asset_bundle_page_breadcrumb: "Asset Bundle",
        edit_asset_bundle_editpage_header: "Edit Asset Bundle",
        create_asset_bundle_editpage_header: "Eszközcsomag létrehozása",
        add_ott_asset_button_tooltip: "Eszköz hozzáadása",
        channel_number_label: "Csatorna száma",
        create_tx_mode_dialog_header: 'Tx mód létrehozása',
        is_type_live_label: 'Típus élőben',
        sub_genre_label: "Al műfajok",
        current_active_version_label: 'Jelenlegi aktív verzió',
        disable_live_event_section_label: "Az élő esemény szakasz letiltása",
        export_segmentation_tooltip_button: "Szegmentáció exportálása",
        text_position_label: 'Szöveg pozíciója',
        text_opacity_label: "Szöveg átlátszatlansága",
        digital_sign_board_overlay_page_breadcrumb: "Digitális jelzőtábla fedvény",
        please_enter_valid_numbers_in_duration: "Kérjük, adjon meg érvényes számokat az időtartamhoz",
        text_shape_label: "Szöveg alakzat",
        layer_label: 'Réteg',
        spotify_label: 'Spotify',
        add_blank_label: 'Üres hozzáadása',
        sync_reference_code_message: "Frissíti a kapcsolt epizód hivatkozási kódjait a sorozatkód előtagként, majd az epizódszámmal.",
        geners_label: 'Geners',
        sub_geners_label: 'Sub Geners',
        languages_label: 'Nyelvek',
        downloading_please_wait_message: 'Letöltés, kérem várjon...',
        format_schedule_sub_menu: 'Ütemezés formátuma',
        format_schedule_page_breadcrumb: 'Formátumütemezés',
        create_schedule_format_dialog_header: 'Ütemezési formátum létrehozása',
        select_format_dialog_header: "Formátum kiválasztása",
        please_select_format_error_message: 'Kérjük, válasszon formátumot',
        please_enter_valid_from_error_message: "Kérjük, írja be az érvényes címet",
        please_enter_valid_to_error_message: "Kérjük, írja be az érvényes címet",
        please_select_items_to_update_message: "Kérjük, válassza ki a frissíteni kívánt elemeket",
        update_successfully_message: 'Frissítés sikeresen',
        please_select_pg_rating_error_message: "Kérjük, válassza ki a PG-besorolást",
        please_select_censor_rating_error_message: "Kérjük, válassza ki a cenzúrázott minősítést",
        please_select_languages_error_message: "Kérjük, válasszon nyelveket",
        please_select_categories_error_message: "Kérjük, válasszon kategóriákat",
        please_select_genres_error_message: "Kérjük, válasszon műfajt",
        please_select_sub_genres_error_message: "Kérjük, válasszon alműfajokat",
        please_enter_production_year_error_message: "Kérjük, adja meg a gyártás évét",
        please_select_technical_prototype_error_message: "Kérjük, válassza ki a műszaki prototípust",
        please_enter_keywords_error_message: "Kérjük, adja meg a kulcsszavakat",
        variation_label: 'Változat',
        execute_button_tooltip: 'Végrehajtás',
        execute_button_text: 'Végrehajtás',
        download_summary_tooltip: 'Letöltési összefoglaló',
        from_date_should_be_current_date_error_message: "A Kezdő dátumnak Aktuális dátumnak/Jövőbeni dátumnak kell lennie",
        next_number_can_not_be_negative_or_zero_error_meessage: 'A következő szám nem lehet negatív vagy nulla',
        number_length_should_be_between_1_to_10_error_message: "A szám hosszának 1 és 10 között kell lennie",
        create_fast_playlist_dialog_header: "Gyors lejátszási lista létrehozása",
        digital_sign_screen_group_page_breadcrumb: "Képernyőcsoport",
        digital_sign_screen_group_sub_menu: "Képernyőcsoport",
        activate_screen_button_tooltip: "Képernyő aktiválása",
        activate_button_text: 'Aktiválás',
        activate_button_tooltip: 'Aktiválás',
        activate_screen_dialog_header: 'Képernyő aktiválása',
        please_enter_screen_name_error_message: "Kérjük, adja meg a képernyő nevét",
        please_enter_otp_error_message: "Kérjük, adja meg az OTP-t",
        show_segmentation_actionbutton_menutext: "Szegmentációk megjelenítése",
        show_segmentation_actionbutton_menutext_tooltip: "Szegmentációk megjelenítése",
        screen_page_breadcrumb: "Képernyők",
        create_screen_group_dialog_header: "Képernyőcsoport létrehozása",
        screen_sub_menu: 'Képernyők',
        attach_screen_group_dialog_header: "Képernyőcsoport csatolása",
        digital_sign_content_page_breadcrumb: "Tartalom",
        digital_sign_content_sub_menu: 'Tartalom',
        create_content_dialog_header: "Tartalom létrehozása",
        please_select_content_type_error_message: "Kérjük, válassza ki a tartalomtípust",
        please_select_url_error_message: "Kérjük, válasszon URL-t",
        content_type_label: 'Tartalom típusa',
        Duration_type_label: "Időtartam",
        playlist_label: 'Lejátszási lista',
        screen_group_label: 'Képernyőcsoport',
        player_label: 'Játékos',
        orientation_label: 'Tájolás',
        play_now_label: 'Játszik most',
        restart_label: 'Újraindítás',
        restart_app_label: 'Alkalmazás újraindítása',
        cpu_usage_label: 'CPU-használat',
        do_you_really_want_to_delete_question: "Valóban törölni akarod?",
        százalék_label: 'százalék',
        digital_sign_content_label: "Tartalom",
        digital_sign_dashboard_sub_menu: "Irányítópult",
        digital_sign_dashboard_page_breadcrumb: "Irányítópult",
        new_screen_group_button_title: "Új képernyőcsoport",
        new_playlist_button_title: 'Új lejátszási lista',
        new_content_button_title: "Új tartalom",
        new_screen_button_title: "Új képernyő",
        add_screen_group_dialog_header: "Képernyőcsoport hozzáadása",
        playlist_dialog_header: 'Lejátszási lista',
        same_screen_group_error_message: "Nem lehet hozzáadni ugyanazt a képernyőcsoportot",
        add_more_label: 'Továbbiak hozzáadása',
        thumbnail_column: "Indexkép",
        overlays_column: "Fedvények",
        email_address_label: 'E-mail cím',
        sign_up_label: 'Regisztráljon',
        company_name_label: "Cég neve",
        country_code_label: "Országkód",
        industries_label: 'Iparágak',
        network_screen_size_label: "Hálózati képernyő mérete",
        how_did_you_found_us_label: "Hogyan talált ránk",
        please_enter_password_error_message: "Kérjük, adja meg a jelszót",
        please_enter_company_name_error_message: "Kérjük, adja meg a vállalat nevét",
        please_select_country_code_error_message: "Kérjük, válasszon országkódot",
        please_enter_phone_error_message: 'Kérjük, adja meg a telefonszámát',
        please_select_industry_error_message: "Kérjük, válassza ki az iparágat",
        please_select_network_screen_size_error_message: "Kérjük, válassza ki a hálózati képernyőméretet",
        please_select_how_did_you_found_us_error_message: 'Kérjük, válassza ki, hogyan talált ránk',
        sign_up_dialog_header: "Regisztráció",
        login_label: 'Bejelentkezés',
        do_not_have_an_account_label: 'Nincs fiókja?',
        forgot_password_label: 'Elfelejtette jelszavát?',
        screen_players_label: 'SCREEN/PLAYERS',
        username_label: 'Felhasználónév',
        manage_underoverrun_schedule_menu_text: 'Slot Auto Fill',
        add_program_menutext: "Program hozzáadása",
        instance_label: "Példány",
        instances_sub_menu: 'Példányok',
        instances_page_breadcrumb: "Példányok",
        forgot_your_password_label: 'Elfelejtette jelszavát?',
        enter_email_note: "Adja meg e-mail címét és linkjét, amelyre új generált jelszót küldünk.",
        Remember_password_label: 'Emlékszik jelszó? ',
        reset_password_button_text: 'Jelszó visszaállítása',
        progress_column: 'Haladás',
        select_interstitial_group_dialoag_header: 'Közbeiktatott csoport kiválasztása',
        interstitial_group_button_tooltip: "Közbeiktatott csoport",
        auto_planning_tooltip: "Automatikus tervezés",
        auto_planning_with_boss_ai_tooltip: "Automatikus tervezés Boss AI-val",
        day_part_sub_menu: 'napi rész',
        day_part_page_breadcrumb: 'napi rész',
        create_day_part_dialog_header: "Napi rész létrehozása",
        priority_label: 'Priority',
        please_enter_from_time_error_message: "Kérjük, lépjen be az időponttól",
        please_enter_to_time_error_message: "Kérjük, adja meg az időt",
        please_enter_priority_error_message: "Kérjük, adjon meg érvényes prioritást",
        please_select_valid_days_error_message: 'Kérjük, válasszon érvényes napokat',
        please_enter_youtube_link_error_message: "Kérjük, adja meg a Youtube linket",
        link_label: 'Link',
        add_new_button_tooltip: 'Új hozzáadása',
        attach_screens_column: "Képernyők csatolása",
        isAllChannel_label: 'AllChannel',
        day_part_label: 'Day Part',
        please_select_day_part_error_message: "Kérjük, válassza ki a napi részt",
        please_enter_reference_code_error_message: "Kérjük, adja meg a hivatkozási kódot",
        company_label: 'Vállalat',
        please_enter_correct_phone_number_error_message: "Kérjük, adja meg a helyes telefonszámot",
        header_address_font_size_label: 'Fejléc címének betűmérete',
        spots_details_font_size_label: "Spots Részletek Betűméret",
        digital_sign_company_plans_page_breadcrumb: "Vállalati tervek",
        myrepeatpattern_labe: 'Saját készítette',
        style_sheet_dialog_header: "Stíluslap",
        digital_sign_company_plans_sub_menu: "Céges tervek",
        download_the_app_label: 'Alkalmazás letöltése',
        in_house_label: "Házban",
        digital_sign_admin_dashboard_menu: 'Rendszergazdai irányítópult',
        digital_sign_admin_dashboard_page_breadcrumb: "Rendszergazdai irányítópult",
        last_five_user_login_label: 'Utolsó 5 felhasználói bejelentkezés',
        create_content_button_tooltip: "Tartalom létrehozása",
        create_genre_button_tooltip: "Műfaj létrehozása",
        create_sub_genre_button_tooltip: 'Alműfaj létrehozása',
        create_cast_type_button_tooltip: 'Create Cast Type',
        digital_sign_plans_sub_menu: 'Tervek',
        digital_sign_plans_page_breadcrumb: "Tervek",
        edit_image_url_dialog_header: "Kép URL-jének szerkesztése",
        attach_screen_dialog_header: 'Képernyő csatolása',
        attachments_label: 'Mellékletek',
        file_attachment_button_tooltip: 'Fájlmelléklet',
        file_column: 'Fájl',
        file_attachment_dialog_header: 'Fájlmelléklet',
        version_column: 'Verzió',
        targets_label: 'Célok',
        weightage_label: "Súly",
        weightage_column: "Súly",
        play_count_label: 'Play Count',
        play_count_column: 'Play Count',
        isplaybycount_label: 'Play by Count',
        isplaybycount_column: 'Play By Count',
        weightage_should_be_less_than_fifty_error_message: "A súlynak 50-nél kisebbnek kell lennie",
        please_enter_correct_weightage_error_message: "Kérjük, adja meg a helyes súlyt",
        please_enter_correct_play_count_error_message: "Kérjük, adja meg a helyes lejátszási számot",
        play_count_should_be_less_than_fifty_error_message: "A lejátszási számnak 50-nél kisebbnek kell lennie",
        isfetchfromlibrary_label: 'Fetch from Library',
        create_instance_dialog_header: "Példány létrehozása",
        base_url_label: 'Alap URL',
        db_name_label: 'DB neve',
        digisign_base_url_label: "Digisign Base URL",
        socket_base_url_label: 'Socket Base URL',
        storage_destination_label: "Tárolási hely",
        cloud_name_label: "Felhő neve",
        api_key_label: 'Api-kulcs',
        api_secret_label: "Api titkos",
        access_key_id_label: 'Hozzáférési kulcs',
        secret_access_key_label: 'Titkos hozzáférési kulcs',
        bucket_name_label: 'Vacsor neve',
        please_enter_base_url_error_message: "Kérjük, adja meg az alap URL-t",
        please_enter_bdname_error_message: "Kérjük, adja meg a BD-nevet",
        please_enter_digisign_base_url_error_message: "Kérjük, adja meg a Digisign Base URL-jét",
        please_enter_socket_base_url_error_message: "Kérjük, adja meg a Socket Base URL-jét",
        quality_label: 'Minőség',
        quality_should_be_less_than_100_error_message: "A minőségnek 100-nál kisebbnek kell lennie",
        file_label: 'Fájl',
        keep_org_label: "Eredeti megőrzése",
        cdn_url_label: 'Cdn URL',
        please_enter_cdn_url_error_message: "Kérjük, adja meg a Cdn URL-címét",
        please_cloud_name_error_message: "Kérjük, adja meg a felhő nevét",
        please_api_key_error_message: "Kérjük, adja meg az Api kulcsot",
        please_api_secret_error_message: "Kérjük, adja meg az Api titkos kódját",
        please_access_keyid_error_message: "Kérjük, adja meg a hozzáférési kulcs azonosítóját",
        please_secret_access_key_error_message: "Kérjük, adja meg a titkos hozzáférési kulcsot",
        please_region_error_message: 'Kérjük, adja meg a régiót',
        please_bucket_name_error_message: "Kérjük, adja meg a csoport nevét",
        column_label: 'Oszlop',
        please_select_column_error_message: "Kérjük, válassza ki az oszlopot",
        please_select_operator_error_message: "Kérjük, válassza ki az üzemeltetőt",
        fill_gaps_label: "Hézagok kitöltése",
        digital_sign_content_group_sub_menu: "Tartalomcsoport",
        digital_sign_content_group_page_breadcrumb: "Tartalomcsoport",
        content_group_editpage_header: "Tartalmi csoport létrehozása",
        add_content_button_tooltip: "Tartalom hozzáadása",
        digital_sign_add_content_dialog_header: "Tartalom hozzáadása",
        please_attach_atleast_one_content_error_message: "Kérjük, csatoljon legalább egy tartalmat",
        digital_sign_content_group_label: "Tartalomcsoport",
        minimum_gap_label: "Minimális hézag (órában)",
        segment_for_channel_rights_label: 'Egyes szegmensek le lesznek tiltva, ha nem rendelkezik csatornajogokkal.',
        jau_have_an_account_label: 'Van már fiókja?',
        min_gap_error_message: "Minimun Gap nem lehet negatív",
        min_gap_invalid_error_message: "Kérjük, adjon meg érvényes minimális hézagot",
        set_as_default_label: 'Beállítás alapértelmezettként',
        minimum_gap_in_primary_event_label: "Minimális hézag (napokban)",
        is_tx_status_label: 'Tx állapot',
        tx_status_column: "Tx állapot",
        limited_pg_rating_label: 'Korlátozott oldal értékelése',
        marker_label: "Jelölő",
        in_label: 'In',
        out_label: "Ki",
        marker_duration_label: "Időtartam",
        time_code_markers: 'TimeCode Markers',
        duration_label_tooltip: '(óó:pp:pp:ff)',
        create_marker_button_tooltip: "Jelölő létrehozása",
        please_enter_valid_value_in_error_message: 'Kérjük, írja be az érvényeset',
        please_enter_valid_value_out_error_message: 'Kérjük, adjon meg érvényes értéket, az In nem lehet nagyobb, mint az Out',
        in_column: 'In',
        out_column: "Ki",
        Tcm: 'Tcm',
        please_select_time_code_marker_error_message: 'Kérjük, válasszon időkódjelzőt',
        ott_platform_sub_menu: 'Platform',
        ott_platform_page_breadcrumb: "Platform",
        module_restrictions_label: 'Modul korlátozások',
        action_label: 'Action',
        please_select_segment_header: "Kérjük, válassza ki a szegmenst",
        restriction_actions_label: "Korlátozási műveletek",
        no_permission_to_delete_header_info: 'Nincs jogosultsága a fejléc törlésére.',
        please_contact_admin_message: "Kérjük, lépjen kapcsolatba adminisztrátorral",
        privacy_policy_label: 'Adatvédelmi szabályzat',
        ott_assets_used_in_archive_confirmation_message: "Ez az eszköz használatban van",
        ott_assets_archive_confirmation_message: "Továbbra is szeretné archiválni?",
        ingestion_report_sub_menu: "Beadási jelentés",
        ingestion_report_page_breadcrumb: "Beadási jelentés",
        cast_and_crew_column: 'Szereposztás és stáb',
        censor_rating_column: 'Censor Rating',
        production_year_column: "Gyártás éve",
        activity_dropdown_label: 'Tevékenység',
        asset_type_column: 'Eszköztípus',
        provider_column: 'Szállító',
        access_level_column: 'Hozzáférési szint',
        vod_type_column: 'VodType',
        potrait_image_url_column: "Állókép URL-címe",
        landscape_image_url_column: "Fekvő kép URL-je",
        playlist_import_buffer_label: 'Lejátszási lista importáló puffere',
        is_negative_playlist_import_buffer_label: "Is negatív lejátszási lista importáló puffer",
        add_user_dialog_header: 'Felhasználó hozzáadása',
        add_new_company_dialog_header: 'Új cég hozzáadása',
        tenure_label: 'Tenure',
        screens_label: 'Képernyők',
        storage_label: 'Tárolás',
        plan_label: 'Terv',
        users_label: 'Felhasználók',
        please_enter_plan_name_error_message: "Kérjük, adja meg a terv nevét",
        plan_tenure_should_be_greater_than_zero_error_message: "A futamidőnek 0-nál nagyobbnak kell lennie",
        plan_screens_should_be_greater_than_zero_error_message: "A képernyőknek 0-nál nagyobbaknak kell lenniük",
        plan_storage_should_be_greater_than_zero_error_message: "A tárhelynek nagyobbnak kell lennie 0-nál",
        please_add_atleast_one_user_error_message: "Kérjük, adjon hozzá legalább egy felhasználót",
        enter_your_pin_label: "Adja meg PIN-kódját",
        please_select_company_error_message: 'Kérjük válasszon vállalatot',
        event_country_level: 'Esemény országa',
        please_enter_event_country_error_message: "Kérjük, adja meg az esemény országát",
        team_a_poster_url_label: "A csapat poszter URL-je",
        team_b_poster_url_label: "B csapat poszter URL-je",
        company_type_label: 'Vállalat típusa',
        tournament_group_dialog_header: 'Tournament Group',
        tournament_group_page_breadcrumb: 'Tournament Group',
        tournament_group_sub_menu: 'Tournament Group',
        tournament_group_label: 'Tournament Group',
        please_select_tournament_group: 'Kérjük, válasszon versenycsoportot',
        add_playlist_button_tooltip: 'Lejátszási lista hozzáadása',
        plans_label: 'Tervek',
        change_password_button_tooltip: 'Jelszó módosítása',
        change_password_dialog_header: "Jelszó módosítása",
        success_change_password_message: "Sikeresen megváltoztatta a jelszót",
        asrun_report_dialog_header: 'Asrun jelentés',
        playlist_name_column: 'Lejátszási lista neve',
        screen_name_column: 'Képernyőnév',
        serial_number_column: "Sorozatszám",
        every_label: 'Minden',
        is_auto_restart_enabled_label: 'Automatikus újraindítás',
        daily_reboot_label: "Napi újraindítás",
        restart_time_label: 'Újraindítás időpontja',
        screen_group_column: "Képernyőcsoport",
        playlist_column: 'Lejátszási lista',
        epg_convertor_sub_menu: 'EPG konverter',
        source_epg_file_label: 'Forrás EPG-fájl',
        opta_file_label: 'OPTA fájl',
        image_url_file_label: "Kép URL-fájl",
        source_epg_tab_label: 'Forrás EPG',
        opta_tab_label: "OPT",
        image_url_tab_label: 'Kép URL-je',
        converted_epg_tab_label: 'Konvertált EPG',
        convert_button_label: "Konvertálás",
        global_label: 'Globális',
        media_template_sub_menu: 'Médiasablon',
        media_template_page_breadcrumb: "Médiasablon",
        media_template_dialog_header: 'Médiasablon',
        select_media_template_collection_header: "Médiasablon kiválasztása",
        save_and_create_media_template_button_tooltip: "Médiasablon mentése és létrehozása",
        select_media_template_button_tooltip: 'Select Media Template',
        save_as_media_template_button_text: 'Mentés sablonként',
        startup_button_tooltip: "Indítás",
        startup_button_title: "Indítás",
        task_label: "Feladat",
        curl_label: "Curl / API",
        please_select_task_error_message: "Kérjük, válasszon feladatot",
        command_label: "Parancs",
        execute_shell_label: "Execute Shell",
        disable_lebel: "Letiltás",
        module_label: "Modul",
        command_column: "Parancs",
        execute_shell_column: "Execute Shell",
        schedule_column: "Ütemezés",
        enable_error_log_column: "Hibanapló engedélyezése",
        disable_column: "Letiltás",
        success_count_column: "Sikerszám",
        last_activity_count_column: "Utolsó tevékenység",
        next_schedule_time_column: "Next Schedule Time",
        please_add_atleast_one_publishing_rights_error_message: "Kérjük, adjon hozzá legalább egy közzétételi jogot",
        genres_label: 'Műfajok',
        sub_genres_label: "Al műfajok",
        avod_Configuration_sub_menu: "Avod konfiguráció",
        avod_Configuration_label: "Avod konfiguráció",
        ad_tags_column: "Hirdetési címkék",
        avod_Configuration_dialog_header: "Avod konfiguráció létrehozása",
        features_label: "Jellemzők",
        please_select_title_error_message: "Kérjük, válassza ki a címet",
        ad_tag_column: "Hirdetéscímke",
        avod_configuration_page_breadcrumb: "Avod konfiguráció",
        avod_feature_label: "Avod szolgáltatás",
        ad_tag_label: "Hirdetéscímke létrehozása",
        please_select_ad_tag_error_message: "Kérjük, válasszon hirdetési címkét",
        linked_channels_label: "Kapcsolt csatornák",
        gender_label: "Nem",
        please_select_gender_error_message: "Kérjük, válassza ki a nemet",
        parent_contract_label: "Szülői szerződés",
        select_contract_collection_header: "Szerződések beszedése",
        non_linear_publishing_label: "Nem lineáris közzététel",
        video_not_found_error_message: "A videó nem található",
        time_line_view_tooltip: "Idővonal nézet",
        response_area_label: "Válasz",
        job_schedule_base_url_label: 'Munkaütemezési alap URL-címe',
        please_enter_job_schedule_base_url_error_message: "Kérjük, adja meg a Munkaütemezés alap URL-jét",
        downloading_excel_please_wait_message: 'Excel letöltése, kérjük, várjon...',
        enable_notification_label: 'Értesítés engedélyezése',
        show_shedule_dialog_header: 'Ütemterv megjelenítése',
        please_select_atleast_one_item_error_message: "Kérjük, válasszon legalább egy elemet",
        please_select_item_to_replace_error_message: "Kérjük, válassza ki a cserélni kívánt elemet",
        schedule_time_column: 'Ütemezési idő',
        select_item_to_replace_label: 'Cserélni kívánt elem kiválasztása',
        save_and_run_button_text: "Mentés és futtatás",
        epg_template_label: "EPG-sablon",
        message_sub_menu: "Üzenet",
        message_provider_sub_menu: "Üzenetszolgáltató",
        message_template_sub_menu: "Üzenetsablon",
        message_configuration_sub_menu: "Üzenet konfiguráció",
        message_provider_page_breadcrumb: "Üzenetszolgáltató",
        message_template_page_breadcrumb: "Üzenetsablon",
        message_configuration_page_breadcrumb: "Üzenet konfiguráció",
        message_provider_dialog_header: "Üzenetszolgáltató létrehozása",
        auth_key_labe: "Auth Key",
        message_template_dialog_header: "Üzenetsablon létrehozása",
        is_unicode_label: "Unicode",
        is_flash_label: "Flash",
        sender_id_lable: "Feladó azonosító",
        message_configuration_dialog_header: "Üzenet konfiguráció",
        message_type_label: "Üzenet típusa",
        message_template_label: "Üzenet sablon",
        message_provider_label: "Üzenetszolgáltató",
        please_enter_auth_key_error_message: "Kérjük, adja meg az auth kulcsot",
        please_enter_content_error_message: "Kérjük, adja meg a tartalmat",
        please_enter_sender_id_error_message: "Kérjük, adja meg a feladó azonosítóját",
        please_select_message_type_error_message: "Kérjük, válassza ki az üzenet típusát",
        message_variant_label: "Üzenetváltozat",
        devices_label: "Eszközök",
        device_name_column: "Eszköz neve",
        last_login_time_column: "Utolsó bejelentkezés időpontja",
        fontos_update_successfully_message: "Fontos frissítés sikeresen",
        param_label: "Param",
        please_add_atleast_one_Ad_tags_error_message: "Kérjük, adjon hozzá legalább egy hirdetési címkét",
        ingestion_logs_dialog_header: "Beadási naplók",
        ingestion_logs_sub_menu: "Beadási naplók",
        status_label: "Állapot",
        ingestion_logs_page_breadcrumb: "Adásnaplók",
        partner_ingestion_template: "Beadási sablon",
        partner_ingestion_base_url: "Ingestion Base URL",
        please_select_ingestion_template: "Kérjük, válasszon feldolgozási sablont",
        please_enter_ingestion_base_url: "Kérjük, adja meg az adatfeldolgozás alap URL-jét",
        data_column: "Adatok",
        please_select_status_error_message: "Kérjük, válassza az állapotot",
        please_enter_curl_error_message: "Kérjük, adja meg a Curl-t",
        curl_label: "Curl",
        params_label: 'Params',
        row_label: "Sor",
        table_view_label: "Táblázat nézet",
        please_select_message_variant_error_message: "Kérjük, válassza az Üzenetváltozatot",
        deactive_lebel: "Deaktív",
        parent_genre_label: "Szülő műfaj",
        parent_language_label: "Szülőnyelv",
        parent_pg_rating_label: "Parent PG Rating",
        parent_censor_rating_label: "Parent CensorRating",
        censor_rating_sub_menu: "Cenzor minősítés",
        pg_rating_dialog_header: "Pg minősítés létrehozása",
        censor_rating_dialog_header: "Cenzoros minősítés létrehozása",
        match_type_label: 'Egyezés típusa',
        match_type_page_breadcrumb: "Egyezés típusa",
        match_type_sub_menu: "Egyezés típusa",
        match_type_dialog_header: "Egyezési típus létrehozása",
        Column_column: 'Oszlop',
        request_label: 'Request',
        sales_dialog_header: "Értékesítés létrehozása",
        concurrency_label: 'Concurrency',
        force_upgrade_label: 'Frissítés kényszerítése',
        please_enter_version_error_message: "Kérjük, adja meg a verziót",
        check_every_label: 'Minden ellenőrzése',
        analytics_providers_sub_menu: 'Analytics Providers',
        analytics_providers_page_breadcrumb: "Analytics Providers",
        analytics_events_sub_menu: "Analytics események",
        analytics_events_page_breadcrumb: "Analytics események",
        create_analytics_provider_dialog_header: "Analytics szolgáltató létrehozása",
        please_enter_api_key_error_message: "Kérjük, adja meg az API-kulcsot",
        api_key_label: 'Api-kulcs',
        analytics_event_page_editpageheader: "Analytics esemény",
        please_enter_provider_name_error_message: "Kérjük, adja meg a szolgáltató nevét",
        provider_name_label: 'Szolgáltató neve',
        parental_control_label: "Szülői felügyelet engedélyezése",
        symbol_label: 'Szimbólum',
        please_enter_symbol_error_message: "Kérjük, írja be a szimbólumot",
        független_episode_page_breadcrumb: "Független epizódok",
        subscriber_profile_dialog_header: 'Feliratkozói profil',
        enable_pg_restriction_label: 'PG korlátozás engedélyezése',
        pin_label: 'Pin',
        enable_parent_control_label: "Szülői felügyelet engedélyezése",
        limited_pgratings_label: 'Korlátozott PgRatings',
        debug_mode_label: 'Hibakeresési mód',
        auto_restart_percent_label: "Automatikus újraindítás",
        set_resolution_dialog_header: 'Felbontás beállítása',
        please_select_resolution_error_message: 'Kérjük, válasszon megoldást',
        asrun_report_label: 'AsrunReport',
        asrun_report_tooltip: "Asrun jelentés",
        auto_fill_playlist_dialog_header: "Lejátszási lista automatikus kitöltése",
        apply_fixed_sequence_label: "Rögzített sorrend alkalmazása",
        apply_fixed_start_items_label: "Rögzített kezdőelemek alkalmazása",
        auto_manage_footers_label: "Láblécek automatikus kezelése",
        allow_footers_offset_label: "Engedélyezett lábléc-eltolás",
        fix_playlist_label: 'Lejátszási lista 24 órás javítása',
        category_required_in_sequence: "A kategóriák sorrendben szükségesek",
        select_format_label: 'Formátum kiválasztása',
        select_format_collection_header: "Formátum kiválasztása",
        select_media_category_type_collection_header: "Médiakategória típusának kiválasztása",
        error_log_column: "Hibanapló",
        please_wait_loading_error_message: 'Kérjük, várjon a betöltéssel...',
        media_management_report_sub_menu: 'Médiakezelési jelentés',
        media_management_report_dialog_header: "Médiakezelési jelentés",
        media_content_report_sub_menu: "Médiatartalom jelentés",
        media_content_report_page_breadcrumb: "Médiatartalom jelentés",
        long_form_label: 'Hosszú forma',
        short_form_label: 'Rövid űrlap',
        spot_label: 'Spot',
        play_mode_label: 'Lejátszási mód',
        memory_label: 'memória',
        used_label: 'Használt',
        free_label: 'Ingyenes',
        delete_storage_button_tooltip: "Tárhely törlése",
        asrun_error_report_dialog_header: 'Asrun Error',
        restart_history_dialog_header: 'Előzmények újraindítása',
        enable_asrunlog_label: 'AsrunLog engedélyezése',
        take_periodic_screenshots_label: "Időszakos képernyőképek",
        image_format_label: 'Képformátum',
        video_format_label: 'Videóformátum',
        restart_type_column: 'Újraindítás típusa',
        preset_label: 'Preset',
        commercial_schedule_list: "Ütemezett kereskedelmi helyek",
        disable_profile_selection_label: " Profilválasztás letiltása",
        auto_fill_music: "Zene automatikus kitöltése",
        content_group_label: "Tartalomcsoport",
        digital_sign_add_content_group_dialog_header: "Tartalmi csoport hozzáadása",
        digital_sign_add_overlays_dialog_header: "Fedvények hozzáadása",
        restart_screen_label: "Újraindító képernyő",
        sports_event_label: 'Sportesemény',
        mam_asset_report: "Mam Asset Report",
        sėkmingai_delete_storage_label: "Tárhely sikeresen törlése",
        live_event_details: "Élő esemény részletei",
        please_create_screen_first_label: "Először hozzon létre egy képernyőt...",
        screen_create_description_label: 'A képernyő hozzáadása után létrehozhat tartalmat, utána pedig lejátszási listát.',
        add_screen_button_label: "Képernyő hozzáadása",
        please_create_content_label: 'Kérjük, hozzon létre egy tartalmat...',
        content_create_description_label: 'A tartalom hozzáadása után létrehozhat lejátszási listát.',
        add_content_button_label: "Tartalom hozzáadása",
        please_create_playlist_label: "Kérjük, hozzon létre egy lejátszási listát...",
        playlist_create_description_label: "Létrehozhat lejátszási listát, kattintson a lejátszási lista hozzáadása gombra",
        add_playlist_button_label: 'Lejátszási lista hozzáadása',
        create_content_label: 'Tartalom létrehozása',
        content_message_label: 'Szeretne tartalmat hozzáadni?',
        create_playlist_label: 'Lejátszási lista létrehozása',
        playlist_message_label: 'Szeretne létrehozni lejátszási listát?',
        sync_mam_asset_label: "Sync Mam Asset",
        localization_dialog_header: 'Lokalizáció',
        cast_Type_dialog_header: 'Cast típusa',
        login_again_label: 'Jelentkezzen be újra',
        please_image_bucket_name_error_message: "Kérjük, adja meg az S3 képcsoport nevét",
        please_video_bucket_name_error_message: 'Kérjük, adja meg az S3-videócsoport nevét',
        please_enter_image_cdn_url_error_message: "Kérjük, adja meg az S3 kép CDN URL-jét",
        please_enter_video_cdn_url_error_message: "Kérjük, adja meg az S3 Video CDN URL-címét",
        base_api_key_label: 'Alap API-kulcs',
        s3_access_key_id_label: "S3 hozzáférési kulcs azonosítója",
        s3_secret_access_key_label: "S3 titkos hozzáférési kulcs",
        s3_region_label: "S3 régió",
        s3_image_bucket_name_label: "S3 képcsoport neve",
        s3_video_bucket_name_label: 'S3 videózóna neve',
        s3_image_cdn_url_label: "S3 kép CDN URL-címe",
        s3_video_cdn_url_label: "S3 Video CDN URL",
        how_to_create_google_slide: 'Hogyan hozzunk létre egy Google-diát:',
        go_to_google_slide: "Lépjen a Google Diák kezdőlapjára a megadott linkre kattintva.",
        click_on_homepage_template_option_available: 'A kezdőlapon válassza ki az üres diasablont vagy egy előre megtervezett sablont a rendelkezésre álló lehetőségek közül.',
        create_presentation: "Kezdje el a prezentáció létrehozását úgy, hogy az igényeinek megfelelően szöveget, képeket és terveket ad hozzá a diákhoz.",
        copy_url_of_google_slide: 'Kattintson a Közzététel gombra, másolja ki a prezentáció URL-jét, adja hozzá a loop=false paramétert, és illessze be az URL beviteli mezőjébe.',
        custom_title_1_label: "1. egyéni cím",
        custom_title_2_label: "2. egyéni cím",
        scheduled_playlist_page_breadcrumb: "Ütemezett lejátszási lista",
        scheduled_playlist_sub_menu: 'Ütemezett lejátszási lista',
        schedule_type_label: 'Ütemezés típusa',
        scheduled_playlist_header: 'Ütemezett lejátszási lista',
        no_end_date_label: "Nincs befejezési dátum",
        digital_sign_report_page_breadcrumb: "Jelentés",
        digital_sign_report_menu: 'Jelentés',
        digital_sign_report_header: "Jelentés",
        isRightToLeft: "jobbról balra van",
        show_deal_label: "Show Deal",
        acquition_report_sub_menu: 'Akvizíciós jelentés',
        hankinta_report_page_breadcrumb: "Akvizíciós jelentés",
        budget_column: 'Költségkeret',
        licensor_column: 'Licensor',
        payee_column: "Kedvezményezett",
        contract_media_library_label: "Contract Media Library",
        total_acq_label: 'Total Acq',
        total_budget_label: "Teljes költségkeret",
        amortization_rule_sub_menu: "Amortizációs szabály",
        amortization_rule_page_breadcrumb: "Amortizációs szabály",
        amortization_rule_dialog_header: "Amortizációs szabály",
        rule_text_label: 'Szabály szövege',
        please_select_amortization_rule_message: "Kérjük, válassza ki az amortizációs szabályt",
        please_enter_rule_text_message: "Kérjük, írja be a szabály szövegét",
        amortization_rule_label: "Amortizációs szabály",
        amortization_rule_report_button_tooltip: "Amortizációs jelentés",
        amortization_rule_report_dialog_header: "Amortizációs jelentés",
        rule_text_instruction: 'Írja be a vesszővel elválasztott százalékos értékeket, hogy biztosítsa a végösszeg 100%-át (pl. 10, 60, 30).',
        invalid_rule_text_total_error_message: 'A szabályszöveg értékek összegének 100%-nak kell lennie',
        amortization_rule_column: "Amortizációs szabály",
        amortization_value_column: "Amortizációs érték",
        detach_mam_asset_confirmation_msg: "Valóban le akarja választani ezt az eszközt erről az adathordozóról?",
        logo_height_label: 'Logo Height',
        select_custom_date_range: 'Egyéni dátumtartomány kiválasztása',
        kiállítás_used_label: 'Használt kiállítás',
        total_runs_label: 'Total Runs',
        kiállítás_szám_label: "Kiállítás száma",
        amortized_value_label: "Amortizált érték",
        kiállítás_schedule_label: 'Kiállítás ütemezve',
        trailer_label: 'trailerek',
        switch_to_planning_view_tooltip: "Váltás tervezési nézetre",
        switch_to_series_timeline_view_tooltip: "Váltás sorozat idővonal nézetre",
        upcoming_events_page_breadcrumb: "Közelgő események",
        upcoming_events_sub_menu: 'Közelgő események',
        upcoming_events_header: "Közelgő események",
        start_date_labe: 'Kezdő dátum',
        launch_date_label: "Indítás dátuma",
        ott_asset_label: "Eszköz",
        upcoming_event_dialog_header: 'Közelgő esemény',
        social_media_menu: 'Közösségi média',
        budget_sub_menu: 'Költségkeretek',
        budget_page_breadcrumb: "Költségkeret",
        budget_dialog_header: "Költségkeret",
        client_po_no_label: 'Ügyfél megrendelési száma',
        agency_commission_label: "Ügynökségi Bizottság",
        can_only_be_in_Percentage: "Csak százalékban (%) lehet",
        ad_status_column: "Hirdetés állapota",
        object_column: "Objective",
        daily_budget_column: "Napi költségkeret",
        spend_cap_column: "Költési sapka",
        buying_type_column: 'Vásárlási típus',
        please_enter_description_error_message: "Kérjük, adja meg a leírást",
        please_enter_client_po_no_error_message: 'Kérjük, adja meg az ügyfél megrendelési számát',
        please_select_status_error_message: "Kérjük, válassza az állapotot",
        please_enter_order_date_error_message: "Kérjük, válassza ki a rendelés dátumát",
        please_enter_from_date_error_message: 'Kérjük, válasszon a dátumtól',
        please_enter_to_date_error_message: "Kérjük, válassza a dátumot",
        please_enter_agency_error_message: "Kérjük, adja meg az Ügynökséget",
        please_enter_client_error_message: 'Kérjük, adja meg a klienst',
        please_enter_currency_error_message: 'Kérjük, válassza ki a pénznemet',
        please_enter_targetAmount_error_message: "Kérjük, adja meg a célösszeget",
        please_enter_target_amount_error_message: "A célösszeg nem lehet kevesebb, mint a kampány teljes költési korlátja",
        please_enter_agency_comission_error_message: "Az ügynökségi jutalék nem lehet negatív",
        budget_label: 'Költségkeret',
        campaign_dialog_header: "Kampány",
        object_label: 'Objective',
        buying_type_label: 'Vásárlás típusa',
        bid_strategy_label: "Ajánlattételi stratégia",
        spend_cap_label: "Költési felső határ",
        daily_budget_label: "Napi költségkeret",
        special_ad_categories_label: "Speciális hirdetési kategóriák",
        only_two_special_ad_categories: 'Csak két speciális hirdetéskategória választható ki.',
        audience_column: "Közönség",
        please_select_budget_error_message: "Kérjük, válassza ki a költségvetést",
        please_enter_start_time_error_message: "Kérjük, adja meg a kezdési időpontot",
        please_enter_end_time_error_message: "Kérjük, adja meg a befejezési időt",
        please_select_objective_error_message: 'Kérjük, válassza ki a célt',
        please_select_buying_type_error_message: "Kérjük, válassza ki a vásárlás típusát",
        please_select_bid_strategy_error_message: "Kérjük, válassza ki az ajánlattételi stratégiát",
        please_select_spend_cap_error_message: "Kérjük, válassza ki a költési felső határt",
        please_enter_spend_cap_cannot_exceed_available_budget_error_message: "A kiadási felső határ nem haladhatja meg a rendelkezésre álló költségkeretet",
        please_enter_daily_budget_error_message: "Kérjük, adja meg a napi költségkeretet",
        please_enter_daily_budget_cannot_exceed_spend_cap_error_message: "A napi költségkeret nem haladhatja meg a költési korlátot",
        please_enter_valid_targetAmount_error_message: "Kérjük, adjon meg érvényes célösszeget",
        sm_ads_page_breadcrumb: "Hirdetések",
        asset_id_label: "Eszközazonosító",
        title_label: "Cím",
        ad_dialog_header: "Hirdetés",
        image_column: 'Kép',
        file_name_column: 'Fájlnév',
        format_column: 'Formátum',
        delete_button_tooltip: "Törlés",
        please_enter_asset_id_error_message: "Kérjük, adja meg az eszközazonosítót",
        please_enter_title_error_message: "Kérjük, adja meg a címet",
        please_select_product_error_message: "Kérjük, válassza ki a terméket",
        please_select_brand_error_message: "Kérjük, válasszon márkát",
        please_attach_at_least_one_asset_error_message: "Kérjük, csatoljon legalább egy elemet",
        ads_sub_menu: 'Hirdetések',
        sm_audience_page_breadcrumb: "Közönség",
        audience_sub_menu: "Közönség",
        please_enter_name_error_message: 'Kérem, adja meg a nevet',
        please_enter_description_error_message: "Kérjük, adja meg a leírást",
        please_select_geo_location_error_message: "Kérjük, válassza ki a földrajzi helyet",
        please_select_interest_error_message: "Kérjük, válassza ki az érdeklődést",
        please_select_gender_error_message: 'Kérjük, válassza ki a nemet',
        please_enter_minimum_age_error_message: "Kérjük, adja meg a minimális életkort",
        please_enter_maximum_age_error_message: "Kérjük, adja meg a maximális életkort",
        sm_channels_sub_menu: 'Csatornák',
        sm_channels_page_breadcrumb: "Csatornák",
        publish_button_tooltip: 'Közzététel',
        un_publish_button_tooltip: 'Közzététel visszavonása',
        spotsperTRP_label: "Spots per TRP",
        target_trp_label: "Target TRP",
        upate_target_spots_button_tooltip: "Célpontok frissítése",
        advertising_channel_type_labe: "Hirdetési csatorna típusa",
        spand_cap_label: "Költéskorlát",
        please_select_advertising_channel_type_error_message: "Kérjük, válassza ki a hirdetési csatorna típusát",
        please_enter_cpc_bid_micros_error_message: "Kérjük, adja meg a kiadási felső határt",
        to_date_cannot_be_earlier_than_from_date_message: 'A dátum nem lehet korábbi, mint a Kezdő dátum.',
        end_time_cannot_be_earlier_than_start_time_message: 'A befejezési időpont nem lehet korábbi a kezdési időpontnál.',
        stop_date_label: "Leállítás dátuma",
        impressions_label: 'Megjelenítések',
        clicks_label: 'Kattintások',
        spends_label: 'Költés',
        cpc_label: 'CPC',
        cpm_label: 'CPM',
        ctr_label: 'CTR',
        show_insight_button_tooltip: "Show Insights",
        create_audience_button_tooltip: "Közönség létrehozása",
        audience_created_successfully: "A közönség sikeresen létrehozva",
        audience_updated_successfully: "A közönség frissítése sikeresen megtörtént",
        error_fetching_insights: "Hiba történt a kampány statisztikai adatainak lekérésekor",
        sm_dashboard_sub_menu: "Irányítópult",
        social_media_dashboard_page_breadcrumb: "Irányítópult",
        campaign_active_label: "Aktív kampányok",
        campaign_inactive_label: "Inaktív kampányok",
        publish_ads_label: "Hirdetések közzététele",
        unpublish_ads_label: 'Hirdetések közzétételének visszavonása',
        campaign_insights_label: "Kampánystatisztikák",
        spend_column: 'Elköltött',
        bid_strategy_column: "Ajánlattételi stratégia",
        skednetwork_attribution_column: "Skadnetwork hozzárendelés",
        split_test_variable_column: 'splitTest Variable',
        cpc_column: 'CPC',
        cpm_column: "CPM",
        ctr_column: 'CTR',
        sm_campaigns_sub_menu: "Kampányok",
        sm_campaigns_page_breadcrumb: "Kampányok",
        insight_dialog_header: "Insight",
        facebook_access_token_invalid_message: 'A Facebook hozzáférési token érvénytelen vagy lejárt. Kérjük, hitelesítse újra',
        failed_to_fetch_facebook_pages_message: "Nem sikerült lekérni a Facebook oldalakat",
        please_enter_daily_budget_error_message: "Kérjük, válassza ki a napi költségkeretet",
        target_type_label: 'Céltípus',
        please_select_linkedin_objective_type_error_message: 'Kérjük, válassza ki a céltípust',
        please_select_linkedin_type_error_message: "Kérjük, válassza ki a típust",
        upcoming_campaigns_label: "Közelgő kampányok",
        share_post_label: 'Megosztás bejegyzésben',
        create_post_button: 'Bejegyzés létrehozása',
        quote_label: 'Idézet',
        hashtag_label: "Hashtag",
        share_on_facebook_button: 'Megosztás a Facebookon',
        share_on_linkedin_button: 'Megosztás a LinkedIn-en',
        share_url_label: 'URL megosztása',
        share_this_link_via_label: 'A link megosztása ezen keresztül',
        cost_type_label: 'Költségtípus',
        add_program_sub_menu: "Program hozzáadása",
        search_program_sub_menu: "Keresési program",
        create_add_program_dialog_header: "Program létrehozása",
        inputs_sub_menu: "Bemenetek",
        dai_configuration_sub_menu: "Konfiguráció",
        dai_configuration_page_breadcrumb: "Konfiguráció",
        output_configuration_setting_label: 'Kimeneti konfiguráció',
        segment_length_label: "Szegmens hossza",
        admarkers_label: "AdMarkers",
        caption_language_mappings_label: "Feliratok nyelvi leképezései",
        caption_language_setting_label: "Feliratok nyelvi beállítása",
        client_cache: 'Client Cache',
        codec_specification_label: 'Kodek specifikáció',
        directory_structure_label: 'Könyvtárszerkezet',
        discontinuity_tags_label: "Discontinuity Tags",
        hlsId3_segment_tagging_label: "HlsId3 Segment Tagging",
        iframe_only_playlists_label: "IFrameOnly lejátszási listák",
        incomplete_segment_behavior_label: "Nem teljes szegmens viselkedés",
        indexn_segments_label: 'IndexN Segments',
        input_loss_action_label: "Bemeneti veszteség-művelet",
        ivin_manifest_label: "IvIn Manifest",
        iv_source_label: 'Iv Source',
        keep_segments_label: "Szegmensek megtartása",
        manifest_compression_label: "Manifest tömörítés",
        manifest_duration_format_label: 'Manifest DurationFormat',
        matchMediaode_label: 'Mód',
        output_selection_label: 'Kimenet kiválasztása',
        program_datetime_label: 'Program dátumának ideje',
        program_datetimeclock_label: "Program Date Time Clock",
        program_datetime_period_label: 'A program dátuma és ideje',
        redundantManifest_label: 'Redundáns manifeszt',
        segmentation_mode_label: "Szegmentációs mód",
        segmentsPer_subdirectory_label: 'Szegmensek alkönyvtáronként',
        satisfiestreaminf_resolution_label: 'InfResolution adatfolyam',
        timed_metadataid3frame_label: "Időzített metaadatazonosító 3 keret",
        timed_metadataid3period_label: "Időzített metaadat-azonosító 3. periódus",
        tsFile_mode_label: "Ts fájl mód",
        avail_configuration_label: 'Rendelkezésre álló konfiguráció',
        no_regional_blackout_flag_label: "Nincs regionális sötétítési zászló",
        web_delivery_allowed_flag_label: 'Web Delivery Allowed Flag',
        scte35_segmentation_scope_label: "Scte35 szegmentációs hatókör",
        media_configuration_label: 'Médiaelőzetes konfiguráció',
        enableAd_markerpassthrough_label: "AdMarker Passthrough engedélyezése",
        ad_insertionmode_label: "Hirdetésbeillesztési mód",
        avail_suppression_mode_label: 'Rendelkezésre állás elnyomási mód',
        avail_suppression_valie_label: 'Avail Suppression Value',
        input_configuration_label: "Bemeneti konfiguráció",
        audio_selectors_label: 'Hangválasztók',
        caption_selectors_label: "Feliratválasztók",
        deblock_filter_label: 'Deblock Filter',
        denoise_filter_label: 'Denoise Filter',
        filter_strength_label: "Szűrő erőssége",
        input_filter_label: "Beviteli szűrő",
        buffer_segments_label: "Pufferszegmensek",
        retries_label: 'Újrapróbálkozás',
        retry_interval_label: 'Újrapróbálkozási időköz',
        scte35_source_label: 'Scte35 Source',
        server_validation_label: 'Szerver érvényesítése',
        smpte2038_data_preference_label: "Smpte2038 Data Preference",
        source_end_behavior_label: 'Forrás végviselkedése',
        deblock_kilter_label: 'Deblock Filter',
        dai_input_page_breadCrumb: "Bemenet",
        dai_input_dialog_header: "Bemenet",
        input_class_label: "Beviteli osztály",
        password_param_label: 'Jelszó',
        outputs_sub_menu: 'Kimenetek',
        dai_output_page_breadCrumb: "Kimenet",
        dai_output_dialog_header: "Kimenet",
        dai_add_output_dialog_header: "Kimenet hozzáadása",
        please_select_output_name_error_message: "Kérjük, válassza ki a kimenet nevét",
        name_modifier_label: "Névmódosító",
        audio_rendition_sets_label: "Hangmegjelenítési készletek",
        audio_frames_per_pes_label: "Audio Frames Per PES",
        audio_pids_label: "Audio PID-ek",
        klv_behavior_label: "KLV viselkedés",
        nielsen_id3_behavior_label: "Nielsen ID3 viselkedés",
        pcr_control_label: "PCR vezérlés",
        pmt_pid_label: "PMT PID",
        program_num_label: "Programszám",
        scte35_behavior_label: "SCTE35 viselkedés",
        scte35_pid_label: "SCTE35 PID",
        timed_metadata_behavior_label: "Időzített metaadatok viselkedése",
        timed_metadata_pid_label: "Időzített metaadat PID",
        video_pid_label: "Videó PID",
        video_descriptions_title: "Videóleírások",
        h264_settings_title: "H264 beállítások",
        name_label: "Név",
        height_label: "Magasság",
        width_label: "Szélesség",
        afd_signaling_label: "AFD jelzés",
        bitrate_label: "Bitráta",
        framerate_control_label: "Framerate Control",
        gop_size_label: "GOP méret",
        gop_size_units_label: "GOP méretegységek",
        rate_control_mode_label: "Drágaszabályozási mód",
        scan_type_label: "Scan Type",
        scene_change_detect_label: "Scene Change Detect",
        timecode_insertion_label: "Időkód beillesztés",
        audio_descriptions_title: "Hangos leírások",
        audio_name_label: 'Név',
        audio_type_control_label: "Audiotípus-vezérlés",
        aac_settings_title: "AAC beállítások",
        bitrate_label: 'Bitráta',
        coding_mode_label: "Kódolási mód",
        input_type_label: "Beviteli típus",
        profile_label: 'Profil',
        rate_control_mode_label: "Drágaszabályozási mód",
        raw_format_label: 'Nyers formátum',
        sample_rate_label: 'Mintavételi sebesség',
        specification_label: 'specifikáció',
        output_name_label: 'Kimenet neve',
        add_timezone_label: 'További időzóna',
        enable_additional_timezone_label: "További időzóna engedélyezése",
        inputs_sub_menu: "Bemenetek",
        dai_channels_sub_menu: "Csatornák",
        dai_channels_page_breadcrumb: "Csatornák",
        dai_channel_dialog_header: "Csatorna létrehozása",
        input_label: 'Bemenet',
        output_label: 'Kimenet',
        configuration_label: 'Konfiguráció',
        please_select_input_error_message: 'Kérjük, válasszon bevitelt',
        please_select_output_error_message: 'Kérjük, válassza ki a kimenetet',
        please_select_configuration_error_message: "Kérjük, válassza ki a konfigurációt",
        please_enter_destination_s3_url_error_message: "Kérjük, adja meg a cél S3 URL-t",
        destinatio_s3_url_label: "Cél S3 URL",
        avail_suppression_fill_policy_label: 'Avail Suppression Fill Policy',
        dai_inputs_page_breadCrumb: "Bemenetek",
        dai_outputs_page_breadCrumb: "Kimenetek",
        add_avail_offset_label: "Rendelkezésre állás eltolása",
        avail_suppression_value_label: 'Avail Suppression Value',
        preview_label: 'Előnézet',
        ad_decision_server_url_label: "Ad Decision Server URL",
        video_content_source_url_label: "Videótartalom forrás URL-je",
        hls_url_label: 'HLS URL',
        dash_url_label: 'DASH URL',
        file_name_label: 'Fájlnév',
        please_enter_file_name_error_message: "Kérjük, adja meg a fájl nevét",
        no_preview_available_label: "Nem érhető el előnézet",
        create_input_button_tooltip: "Bemenet létrehozása",
        create_output_button_tooltip: 'Kimenet létrehozása',
        create_configuration_button_tooltip: 'Konfiguráció létrehozása',
        outputs_label: 'Kimenetek',
        edit_input_button_tooltip: "Bevitel szerkesztése",
        edit_output_button_tooltip: "Kimenet szerkesztése",
        edit_configuration_button_tooltip: "Konfiguráció szerkesztése"
    }


};